"use strict";

import PerformanceTimer from "/app/deps/hologram/assets/js/performance_timer.mjs";

const startTime = performance.now();

globalThis.hologram.pageReachableFunctionDefs = (deps) => {
	const {
		Bitstring,
		ERTS,
		HologramBoxedError,
		HologramInterpreterError,
		Interpreter,
		MemoryStorage,
		Type,
		Utils,
	} = deps;

	Interpreter.defineErlangFunction("binary", "match", 2, (subject, pattern) => {
		return Erlang_Binary["match/3"](subject, pattern, Type.list());
	});

	Interpreter.defineElixirFunction(
		"Ecto.Association.NotLoaded",
		"__struct__",
		0,
		"public",
		[
			{
				params: (context) => [],
				guards: [],
				body: (context) => {
					return Type.map([
						[Type.atom("__cardinality__"), Type.atom("nil")],
						[Type.atom("__field__"), Type.atom("nil")],
						[Type.atom("__owner__"), Type.atom("nil")],
						[
							Type.atom("__struct__"),
							Type.atom("Elixir.Ecto.Association.NotLoaded"),
						],
					]);
				},
			},
		],
	);

	Interpreter.defineElixirFunction(
		"Ecto.Association.NotLoaded",
		"__struct__",
		1,
		"public",
		[
			{
				params: (context) => [Type.variablePattern("kv_0")],
				guards: [],
				body: (context) => {
					return Elixir_Enum["reduce/3"](
						context.vars.kv_0,
						Type.map([
							[Type.atom("__cardinality__"), Type.atom("nil")],
							[Type.atom("__field__"), Type.atom("nil")],
							[Type.atom("__owner__"), Type.atom("nil")],
							[
								Type.atom("__struct__"),
								Type.atom("Elixir.Ecto.Association.NotLoaded"),
							],
						]),
						Type.anonymousFunction(
							2,
							[
								{
									params: (context) => [
										Type.tuple([
											Type.variablePattern("key_1"),
											Type.variablePattern("val_2"),
										]),
										Type.variablePattern("map_3"),
									],
									guards: [],
									body: (context) => {
										return Elixir_Map["merge/2"](
											context.vars.map_3,
											Type.map([[context.vars.key_1, context.vars.val_2]]),
										);
									},
								},
							],
							context,
						),
					);
				},
			},
		],
	);

	Interpreter.defineElixirFunction(
		"Ecto.Schema.Metadata",
		"__struct__",
		0,
		"public",
		[
			{
				params: (context) => [],
				guards: [],
				body: (context) => {
					return Type.map([
						[Type.atom("__struct__"), Type.atom("Elixir.Ecto.Schema.Metadata")],
						[Type.atom("context"), Type.atom("nil")],
						[Type.atom("prefix"), Type.atom("nil")],
						[Type.atom("schema"), Type.atom("nil")],
						[Type.atom("source"), Type.atom("nil")],
						[Type.atom("state"), Type.atom("nil")],
					]);
				},
			},
		],
	);

	Interpreter.defineElixirFunction(
		"Ecto.Schema.Metadata",
		"__struct__",
		1,
		"public",
		[
			{
				params: (context) => [Type.variablePattern("kv_0")],
				guards: [],
				body: (context) => {
					return Elixir_Enum["reduce/3"](
						context.vars.kv_0,
						Type.map([
							[
								Type.atom("__struct__"),
								Type.atom("Elixir.Ecto.Schema.Metadata"),
							],
							[Type.atom("context"), Type.atom("nil")],
							[Type.atom("prefix"), Type.atom("nil")],
							[Type.atom("schema"), Type.atom("nil")],
							[Type.atom("source"), Type.atom("nil")],
							[Type.atom("state"), Type.atom("nil")],
						]),
						Type.anonymousFunction(
							2,
							[
								{
									params: (context) => [
										Type.tuple([
											Type.variablePattern("key_1"),
											Type.variablePattern("val_2"),
										]),
										Type.variablePattern("map_3"),
									],
									guards: [],
									body: (context) => {
										return Elixir_Map["merge/2"](
											context.vars.map_3,
											Type.map([[context.vars.key_1, context.vars.val_2]]),
										);
									},
								},
							],
							context,
						),
					);
				},
			},
		],
	);

	Interpreter.defineElixirFunction("Enum", "any?", 2, "public", [
		{
			params: (context) => [
				Type.variablePattern("enumerable_0"),
				Type.variablePattern("fun_1"),
			],
			guards: [(context) => Erlang["is_list/1"](context.vars.enumerable_0)],
			body: (context) => {
				return Elixir_Enum["predicate_list/3"](
					context.vars.enumerable_0,
					Type.atom("false"),
					context.vars.fun_1,
				);
			},
		},
		{
			params: (context) => [
				Type.map([
					[Type.atom("__struct__"), Type.atom("Elixir.Range")],
					[Type.atom("first"), Type.variablePattern("first_0")],
					[Type.atom("last"), Type.variablePattern("last_1")],
					[Type.atom("step"), Type.variablePattern("step_2")],
				]),
				Type.variablePattern("fun_3"),
			],
			guards: [],
			body: (context) => {
				return Elixir_Enum["predicate_range/5"](
					context.vars.first_0,
					context.vars.last_1,
					context.vars.step_2,
					Type.atom("false"),
					context.vars.fun_3,
				);
			},
		},
		{
			params: (context) => [
				Type.variablePattern("enumerable_0"),
				Type.variablePattern("fun_1"),
			],
			guards: [],
			body: (context) => {
				return Erlang["element/2"](
					Type.integer(2n),
					Elixir_Enumerable["reduce/3"](
						context.vars.enumerable_0,
						Type.tuple([Type.atom("cont"), Type.atom("false")]),
						Type.anonymousFunction(
							2,
							[
								{
									params: (context) => [
										Type.variablePattern("entry_2"),
										Type.matchPlaceholder(),
									],
									guards: [],
									body: (context) => {
										return Interpreter.case(
											Interpreter.callAnonymousFunction(context.vars.fun_1, [
												context.vars.entry_2,
											]),
											[
												{
													match: Type.variablePattern("x_3"),
													guards: [
														(context) =>
															Erlang["orelse/2"](
																(context) =>
																	Erlang["=:=/2"](
																		context.vars.x_3,
																		Type.atom("false"),
																	),
																(context) =>
																	Erlang["=:=/2"](
																		context.vars.x_3,
																		Type.atom("nil"),
																	),
																context,
															),
													],
													body: (context) => {
														return Type.tuple([
															Type.atom("cont"),
															Type.atom("false"),
														]);
													},
												},
												{
													match: Type.matchPlaceholder(),
													guards: [],
													body: (context) => {
														return Type.tuple([
															Type.atom("halt"),
															Type.atom("true"),
														]);
													},
												},
											],
											context,
										);
									},
								},
							],
							context,
						),
					),
				);
			},
		},
	]);

	Interpreter.defineElixirFunction("Enum", "predicate_list", 3, "private", [
		{
			params: (context) => [
				Type.consPattern(
					Type.variablePattern("h_0"),
					Type.variablePattern("t_1"),
				),
				Type.variablePattern("initial_2"),
				Type.variablePattern("fun_3"),
			],
			guards: [],
			body: (context) => {
				return Interpreter.case(
					Erlang["==/2"](
						Interpreter.case(
							Interpreter.callAnonymousFunction(context.vars.fun_3, [
								context.vars.h_0,
							]),
							[
								{
									match: Type.variablePattern("x_4"),
									guards: [
										(context) =>
											Erlang["orelse/2"](
												(context) =>
													Erlang["=:=/2"](context.vars.x_4, Type.atom("false")),
												(context) =>
													Erlang["=:=/2"](context.vars.x_4, Type.atom("nil")),
												context,
											),
									],
									body: (context) => {
										return Type.atom("false");
									},
								},
								{
									match: Type.matchPlaceholder(),
									guards: [],
									body: (context) => {
										return Type.atom("true");
									},
								},
							],
							context,
						),
						context.vars.initial_2,
					),
					[
						{
							match: Type.atom("false"),
							guards: [],
							body: (context) => {
								return Erlang["not/1"](context.vars.initial_2);
							},
						},
						{
							match: Type.atom("true"),
							guards: [],
							body: (context) => {
								return Elixir_Enum["predicate_list/3"](
									context.vars.t_1,
									context.vars.initial_2,
									context.vars.fun_3,
								);
							},
						},
					],
					context,
				);
			},
		},
		{
			params: (context) => [
				Type.list([]),
				Type.variablePattern("initial_0"),
				Type.matchPlaceholder(),
			],
			guards: [],
			body: (context) => {
				return context.vars.initial_0;
			},
		},
	]);

	Interpreter.defineElixirFunction("Enum", "predicate_range", 5, "private", [
		{
			params: (context) => [
				Type.variablePattern("first_0"),
				Type.variablePattern("last_1"),
				Type.variablePattern("step_2"),
				Type.variablePattern("initial_3"),
				Type.variablePattern("fun_4"),
			],
			guards: [
				(context) =>
					Erlang["andalso/2"](
						(context) => Erlang[">/2"](context.vars.step_2, Type.integer(0n)),
						(context) =>
							Erlang["=</2"](context.vars.first_0, context.vars.last_1),
						context,
					),
				(context) =>
					Erlang["andalso/2"](
						(context) => Erlang["</2"](context.vars.step_2, Type.integer(0n)),
						(context) =>
							Erlang[">=/2"](context.vars.first_0, context.vars.last_1),
						context,
					),
			],
			body: (context) => {
				return Interpreter.case(
					Erlang["==/2"](
						Interpreter.case(
							Interpreter.callAnonymousFunction(context.vars.fun_4, [
								context.vars.first_0,
							]),
							[
								{
									match: Type.variablePattern("x_5"),
									guards: [
										(context) =>
											Erlang["orelse/2"](
												(context) =>
													Erlang["=:=/2"](context.vars.x_5, Type.atom("false")),
												(context) =>
													Erlang["=:=/2"](context.vars.x_5, Type.atom("nil")),
												context,
											),
									],
									body: (context) => {
										return Type.atom("false");
									},
								},
								{
									match: Type.matchPlaceholder(),
									guards: [],
									body: (context) => {
										return Type.atom("true");
									},
								},
							],
							context,
						),
						context.vars.initial_3,
					),
					[
						{
							match: Type.atom("false"),
							guards: [],
							body: (context) => {
								return Erlang["not/1"](context.vars.initial_3);
							},
						},
						{
							match: Type.atom("true"),
							guards: [],
							body: (context) => {
								return Elixir_Enum["predicate_range/5"](
									Erlang["+/2"](context.vars.first_0, context.vars.step_2),
									context.vars.last_1,
									context.vars.step_2,
									context.vars.initial_3,
									context.vars.fun_4,
								);
							},
						},
					],
					context,
				);
			},
		},
		{
			params: (context) => [
				Type.matchPlaceholder(),
				Type.matchPlaceholder(),
				Type.matchPlaceholder(),
				Type.variablePattern("initial_3"),
				Type.matchPlaceholder(),
			],
			guards: [],
			body: (context) => {
				return context.vars.initial_3;
			},
		},
	]);

	Interpreter.defineElixirFunction(
		"Hologram.Router.Helpers",
		"page_bundle_path",
		1,
		"public",
		[
			{
				params: (context) => [Type.variablePattern("page_digest_0")],
				guards: [],
				body: (context) => {
					return Type.bitstring([
						Type.bitstringSegment(Type.string("/hologram/page-"), {
							type: "binary",
						}),
						Type.bitstringSegment(
							Elixir_String_Chars["to_string/1"](context.vars.page_digest_0),
							{ type: "binary" },
						),
						Type.bitstringSegment(Type.string(".js"), { type: "binary" }),
					]);
				},
			},
		],
	);

	Interpreter.defineElixirFunction(
		"Hologram.Server",
		"__struct__",
		0,
		"public",
		[
			{
				params: (context) => [],
				guards: [],
				body: (context) => {
					return Type.map([
						[
							Type.atom("__meta__"),
							Type.map([
								[
									Type.atom("__struct__"),
									Type.atom("Elixir.Hologram.Server.Metadata"),
								],
								[Type.atom("cookie_ops"), Type.map([])],
								[Type.atom("session_ops"), Type.map([])],
							]),
						],
						[Type.atom("__struct__"), Type.atom("Elixir.Hologram.Server")],
						[Type.atom("cookies"), Type.map([])],
						[Type.atom("next_action"), Type.atom("nil")],
						[Type.atom("session"), Type.map([])],
					]);
				},
			},
		],
	);

	Interpreter.defineElixirFunction(
		"Hologram.Server",
		"__struct__",
		1,
		"public",
		[
			{
				params: (context) => [Type.variablePattern("kv_0")],
				guards: [],
				body: (context) => {
					return Elixir_Enum["reduce/3"](
						context.vars.kv_0,
						Type.map([
							[
								Type.atom("__meta__"),
								Type.map([
									[
										Type.atom("__struct__"),
										Type.atom("Elixir.Hologram.Server.Metadata"),
									],
									[Type.atom("cookie_ops"), Type.map([])],
									[Type.atom("session_ops"), Type.map([])],
								]),
							],
							[Type.atom("__struct__"), Type.atom("Elixir.Hologram.Server")],
							[Type.atom("cookies"), Type.map([])],
							[Type.atom("next_action"), Type.atom("nil")],
							[Type.atom("session"), Type.map([])],
						]),
						Type.anonymousFunction(
							2,
							[
								{
									params: (context) => [
										Type.tuple([
											Type.variablePattern("key_1"),
											Type.variablePattern("val_2"),
										]),
										Type.variablePattern("map_3"),
									],
									guards: [],
									body: (context) => {
										return Elixir_Map["merge/2"](
											context.vars.map_3,
											Type.map([[context.vars.key_1, context.vars.val_2]]),
										);
									},
								},
							],
							context,
						),
					);
				},
			},
		],
	);

	Interpreter.defineElixirFunction(
		"Hologram.Server.Metadata",
		"__struct__",
		0,
		"public",
		[
			{
				params: (context) => [],
				guards: [],
				body: (context) => {
					return Type.map([
						[
							Type.atom("__struct__"),
							Type.atom("Elixir.Hologram.Server.Metadata"),
						],
						[Type.atom("cookie_ops"), Type.map([])],
						[Type.atom("session_ops"), Type.map([])],
					]);
				},
			},
		],
	);

	Interpreter.defineElixirFunction(
		"Hologram.Server.Metadata",
		"__struct__",
		1,
		"public",
		[
			{
				params: (context) => [Type.variablePattern("kv_0")],
				guards: [],
				body: (context) => {
					return Elixir_Enum["reduce/3"](
						context.vars.kv_0,
						Type.map([
							[
								Type.atom("__struct__"),
								Type.atom("Elixir.Hologram.Server.Metadata"),
							],
							[Type.atom("cookie_ops"), Type.map([])],
							[Type.atom("session_ops"), Type.map([])],
						]),
						Type.anonymousFunction(
							2,
							[
								{
									params: (context) => [
										Type.tuple([
											Type.variablePattern("key_1"),
											Type.variablePattern("val_2"),
										]),
										Type.variablePattern("map_3"),
									],
									guards: [],
									body: (context) => {
										return Elixir_Map["merge/2"](
											context.vars.map_3,
											Type.map([[context.vars.key_1, context.vars.val_2]]),
										);
									},
								},
							],
							context,
						),
					);
				},
			},
		],
	);

	Interpreter.defineElixirFunction(
		"Hologram.UI.Runtime",
		"__props__",
		0,
		"public",
		[
			{
				params: (context) => [],
				guards: [],
				body: (context) => {
					return Elixir_Enum["reverse/1"](
						Type.list([
							Type.tuple([
								Type.atom("page_mounted?"),
								Type.atom("boolean"),
								Type.list([
									Type.tuple([
										Type.atom("from_context"),
										Type.tuple([
											Type.atom("Elixir.Hologram.Runtime"),
											Type.atom("page_mounted?"),
										]),
									]),
								]),
							]),
							Type.tuple([
								Type.atom("page_digest"),
								Type.atom("string"),
								Type.list([
									Type.tuple([
										Type.atom("from_context"),
										Type.tuple([
											Type.atom("Elixir.Hologram.Runtime"),
											Type.atom("page_digest"),
										]),
									]),
								]),
							]),
							Type.tuple([
								Type.atom("initial_page?"),
								Type.atom("boolean"),
								Type.list([
									Type.tuple([
										Type.atom("from_context"),
										Type.tuple([
											Type.atom("Elixir.Hologram.Runtime"),
											Type.atom("initial_page?"),
										]),
									]),
								]),
							]),
							Type.tuple([
								Type.atom("csrf_token"),
								Type.atom("string"),
								Type.list([
									Type.tuple([
										Type.atom("from_context"),
										Type.tuple([
											Type.atom("Elixir.Hologram.Runtime"),
											Type.atom("csrf_token"),
										]),
									]),
								]),
							]),
						]),
					);
				},
			},
		],
	);

	Interpreter.defineElixirFunction(
		"Hologram.UI.Runtime",
		"template",
		0,
		"public",
		[
			{
				params: (context) => [],
				guards: [],
				body: (context) => {
					globalThis.hologram.return = Type.anonymousFunction(
						1,
						[
							{
								params: (context) => [Type.variablePattern("vars_0")],
								guards: [],
								body: (context) => {
									Interpreter.matchOperator(
										context.vars.vars_0,
										Type.matchPlaceholder(),
										context,
									);
									Interpreter.updateVarsToMatchedValues(context);
									return Type.list([
										Interpreter.case(
											Interpreter.case(
												Interpreter.dotOperator(
													context.vars.vars_0,
													Type.atom("initial_page?"),
												),
												[
													{
														match: Type.variablePattern("x_1"),
														guards: [
															(context) =>
																Erlang["orelse/2"](
																	(context) =>
																		Erlang["=:=/2"](
																			context.vars.x_1,
																			Type.atom("false"),
																		),
																	(context) =>
																		Erlang["=:=/2"](
																			context.vars.x_1,
																			Type.atom("nil"),
																		),
																	context,
																),
														],
														body: (context) => {
															return context.vars.x_1;
														},
													},
													{
														match: Type.matchPlaceholder(),
														guards: [],
														body: (context) => {
															return Interpreter.case(
																Interpreter.dotOperator(
																	context.vars.vars_0,
																	Type.atom("page_mounted?"),
																),
																[
																	{
																		match: Type.variablePattern("x_2"),
																		guards: [
																			(context) =>
																				Erlang["orelse/2"](
																					(context) =>
																						Erlang["=:=/2"](
																							context.vars.x_2,
																							Type.atom("false"),
																						),
																					(context) =>
																						Erlang["=:=/2"](
																							context.vars.x_2,
																							Type.atom("nil"),
																						),
																					context,
																				),
																		],
																		body: (context) => {
																			return Type.atom("true");
																		},
																	},
																	{
																		match: Type.matchPlaceholder(),
																		guards: [],
																		body: (context) => {
																			return Type.atom("false");
																		},
																	},
																],
																context,
															);
														},
													},
												],
												context,
											),
											[
												{
													match: Type.variablePattern("x_3"),
													guards: [
														(context) =>
															Erlang["orelse/2"](
																(context) =>
																	Erlang["=:=/2"](
																		context.vars.x_3,
																		Type.atom("false"),
																	),
																(context) =>
																	Erlang["=:=/2"](
																		context.vars.x_3,
																		Type.atom("nil"),
																	),
																context,
															),
													],
													body: (context) => {
														return Type.atom("nil");
													},
												},
												{
													match: Type.matchPlaceholder(),
													guards: [],
													body: (context) => {
														return Type.list([
															Type.tuple([
																Type.atom("text"),
																Type.bitstring("\n  "),
															]),
															Type.tuple([
																Type.atom("element"),
																Type.bitstring("script"),
																Type.list([]),
																Type.list([
																	Type.tuple([
																		Type.atom("text"),
																		Type.bitstring(
																			'\n    globalThis.hologram ??= {};\n    globalThis.hologram.csrfToken = "',
																		),
																	]),
																	Type.tuple([
																		Type.atom("expression"),
																		Type.tuple([
																			Interpreter.dotOperator(
																				context.vars.vars_0,
																				Type.atom("csrf_token"),
																			),
																		]),
																	]),
																	Type.tuple([
																		Type.atom("text"),
																		Type.bitstring(
																			'";\n    globalThis.hologram.assetManifest = $ASSET_MANIFEST_JS_PLACEHOLDER\n  ',
																		),
																	]),
																]),
															]),
															Type.tuple([
																Type.atom("text"),
																Type.bitstring("\n"),
															]),
														]);
													},
												},
											],
											context,
										),
										Type.tuple([Type.atom("text"), Type.bitstring("\n\n")]),
										Interpreter.case(
											Interpreter.case(
												Interpreter.dotOperator(
													context.vars.vars_0,
													Type.atom("page_mounted?"),
												),
												[
													{
														match: Type.variablePattern("x_4"),
														guards: [
															(context) =>
																Erlang["orelse/2"](
																	(context) =>
																		Erlang["=:=/2"](
																			context.vars.x_4,
																			Type.atom("false"),
																		),
																	(context) =>
																		Erlang["=:=/2"](
																			context.vars.x_4,
																			Type.atom("nil"),
																		),
																	context,
																),
														],
														body: (context) => {
															return Type.atom("true");
														},
													},
													{
														match: Type.matchPlaceholder(),
														guards: [],
														body: (context) => {
															return Type.atom("false");
														},
													},
												],
												context,
											),
											[
												{
													match: Type.atom("false"),
													guards: [],
													body: (context) => {
														return Type.atom("nil");
													},
												},
												{
													match: Type.atom("true"),
													guards: [],
													body: (context) => {
														return Type.list([
															Type.tuple([
																Type.atom("text"),
																Type.bitstring("\n  "),
															]),
															Type.tuple([
																Type.atom("element"),
																Type.bitstring("script"),
																Type.list([]),
																Type.list([
																	Type.tuple([
																		Type.atom("text"),
																		Type.bitstring(
																			"\n    \n      globalThis.hologram.pageMountData = (deps) => {\n        const Type = deps.Type;\n        \n        return {\n          componentRegistry: $COMPONENT_REGISTRY_JS_PLACEHOLDER,\n          pageModule: $PAGE_MODULE_JS_PLACEHOLDER,\n          pageParams: $PAGE_PARAMS_JS_PLACEHOLDER\n        };\n      };\n    ",
																		),
																	]),
																	Type.tuple([
																		Type.atom("text"),
																		Type.bitstring("\n  "),
																	]),
																]),
															]),
															Type.tuple([
																Type.atom("text"),
																Type.bitstring("\n"),
															]),
														]);
													},
												},
											],
											context,
										),
										Type.tuple([Type.atom("text"), Type.bitstring("\n\n")]),
										Interpreter.case(
											Interpreter.case(
												Interpreter.dotOperator(
													context.vars.vars_0,
													Type.atom("initial_page?"),
												),
												[
													{
														match: Type.variablePattern("x_5"),
														guards: [
															(context) =>
																Erlang["orelse/2"](
																	(context) =>
																		Erlang["=:=/2"](
																			context.vars.x_5,
																			Type.atom("false"),
																		),
																	(context) =>
																		Erlang["=:=/2"](
																			context.vars.x_5,
																			Type.atom("nil"),
																		),
																	context,
																),
														],
														body: (context) => {
															return context.vars.x_5;
														},
													},
													{
														match: Type.matchPlaceholder(),
														guards: [],
														body: (context) => {
															return Interpreter.case(
																Interpreter.dotOperator(
																	context.vars.vars_0,
																	Type.atom("page_mounted?"),
																),
																[
																	{
																		match: Type.variablePattern("x_6"),
																		guards: [
																			(context) =>
																				Erlang["orelse/2"](
																					(context) =>
																						Erlang["=:=/2"](
																							context.vars.x_6,
																							Type.atom("false"),
																						),
																					(context) =>
																						Erlang["=:=/2"](
																							context.vars.x_6,
																							Type.atom("nil"),
																						),
																					context,
																				),
																		],
																		body: (context) => {
																			return Type.atom("true");
																		},
																	},
																	{
																		match: Type.matchPlaceholder(),
																		guards: [],
																		body: (context) => {
																			return Type.atom("false");
																		},
																	},
																],
																context,
															);
														},
													},
												],
												context,
											),
											[
												{
													match: Type.variablePattern("x_7"),
													guards: [
														(context) =>
															Erlang["orelse/2"](
																(context) =>
																	Erlang["=:=/2"](
																		context.vars.x_7,
																		Type.atom("false"),
																	),
																(context) =>
																	Erlang["=:=/2"](
																		context.vars.x_7,
																		Type.atom("nil"),
																	),
																context,
															),
													],
													body: (context) => {
														return Type.atom("nil");
													},
												},
												{
													match: Type.matchPlaceholder(),
													guards: [],
													body: (context) => {
														return Type.list([
															Type.tuple([
																Type.atom("text"),
																Type.bitstring("\n  "),
															]),
															Type.tuple([
																Type.atom("element"),
																Type.bitstring("script"),
																Type.list([
																	Type.tuple([
																		Type.bitstring("async"),
																		Type.list([]),
																	]),
																	Type.tuple([
																		Type.bitstring("src"),
																		Type.list([
																			Type.tuple([
																				Type.atom("expression"),
																				Type.tuple([
																					Elixir_Hologram_Router_Helpers[
																						"asset_path/1"
																					](
																						Type.bitstring(
																							"hologram/runtime.js",
																						),
																					),
																				]),
																			]),
																		]),
																	]),
																]),
																Type.list([]),
															]),
															Type.tuple([
																Type.atom("text"),
																Type.bitstring("\n"),
															]),
														]);
													},
												},
											],
											context,
										),
										Type.tuple([Type.atom("text"), Type.bitstring("\n\n")]),
										Interpreter.case(
											Interpreter.case(
												Interpreter.dotOperator(
													context.vars.vars_0,
													Type.atom("page_mounted?"),
												),
												[
													{
														match: Type.variablePattern("x_8"),
														guards: [
															(context) =>
																Erlang["orelse/2"](
																	(context) =>
																		Erlang["=:=/2"](
																			context.vars.x_8,
																			Type.atom("false"),
																		),
																	(context) =>
																		Erlang["=:=/2"](
																			context.vars.x_8,
																			Type.atom("nil"),
																		),
																	context,
																),
														],
														body: (context) => {
															return Type.atom("true");
														},
													},
													{
														match: Type.matchPlaceholder(),
														guards: [],
														body: (context) => {
															return Type.atom("false");
														},
													},
												],
												context,
											),
											[
												{
													match: Type.atom("false"),
													guards: [],
													body: (context) => {
														return Type.atom("nil");
													},
												},
												{
													match: Type.atom("true"),
													guards: [],
													body: (context) => {
														return Type.list([
															Type.tuple([
																Type.atom("text"),
																Type.bitstring("\n  "),
															]),
															Type.tuple([
																Type.atom("element"),
																Type.bitstring("script"),
																Type.list([
																	Type.tuple([
																		Type.bitstring("async"),
																		Type.list([]),
																	]),
																	Type.tuple([
																		Type.bitstring("src"),
																		Type.list([
																			Type.tuple([
																				Type.atom("expression"),
																				Type.tuple([
																					Elixir_Hologram_Router_Helpers[
																						"page_bundle_path/1"
																					](
																						Interpreter.dotOperator(
																							context.vars.vars_0,
																							Type.atom("page_digest"),
																						),
																					),
																				]),
																			]),
																		]),
																	]),
																]),
																Type.list([]),
															]),
															Type.tuple([
																Type.atom("text"),
																Type.bitstring("\n"),
															]),
														]);
													},
												},
											],
											context,
										),
									]);
								},
							},
						],
						context,
					);
					Interpreter.updateVarsToMatchedValues(context);
					return globalThis.hologram.return;
				},
			},
		],
	);

	Interpreter.defineElixirFunction(
		"Jason.EncodeError",
		"__struct__",
		0,
		"public",
		[
			{
				params: (context) => [],
				guards: [],
				body: (context) => {
					return Type.map([
						[Type.atom("__exception__"), Type.atom("true")],
						[Type.atom("__struct__"), Type.atom("Elixir.Jason.EncodeError")],
						[Type.atom("message"), Type.atom("nil")],
					]);
				},
			},
		],
	);

	Interpreter.defineElixirFunction(
		"Jason.EncodeError",
		"__struct__",
		1,
		"public",
		[
			{
				params: (context) => [Type.variablePattern("kv_0")],
				guards: [],
				body: (context) => {
					return Elixir_Enum["reduce/3"](
						context.vars.kv_0,
						Type.map([
							[Type.atom("__exception__"), Type.atom("true")],
							[Type.atom("__struct__"), Type.atom("Elixir.Jason.EncodeError")],
							[Type.atom("message"), Type.atom("nil")],
						]),
						Type.anonymousFunction(
							2,
							[
								{
									params: (context) => [
										Type.tuple([
											Type.variablePattern("key_1"),
											Type.variablePattern("val_2"),
										]),
										Type.variablePattern("map_3"),
									],
									guards: [],
									body: (context) => {
										return Elixir_Map["merge/2"](
											context.vars.map_3,
											Type.map([[context.vars.key_1, context.vars.val_2]]),
										);
									},
								},
							],
							context,
						),
					);
				},
			},
		],
	);

	Interpreter.defineElixirFunction(
		"Jason.Fragment",
		"__struct__",
		0,
		"public",
		[
			{
				params: (context) => [],
				guards: [],
				body: (context) => {
					return Type.map([
						[Type.atom("__struct__"), Type.atom("Elixir.Jason.Fragment")],
						[Type.atom("encode"), Type.atom("nil")],
					]);
				},
			},
		],
	);

	Interpreter.defineElixirFunction(
		"Jason.Fragment",
		"__struct__",
		1,
		"public",
		[
			{
				params: (context) => [Type.variablePattern("kv_0")],
				guards: [],
				body: (context) => {
					return Elixir_Enum["reduce/3"](
						context.vars.kv_0,
						Type.map([
							[Type.atom("__struct__"), Type.atom("Elixir.Jason.Fragment")],
							[Type.atom("encode"), Type.atom("nil")],
						]),
						Type.anonymousFunction(
							2,
							[
								{
									params: (context) => [
										Type.tuple([
											Type.variablePattern("key_1"),
											Type.variablePattern("val_2"),
										]),
										Type.variablePattern("map_3"),
									],
									guards: [],
									body: (context) => {
										return Elixir_Map["merge/2"](
											context.vars.map_3,
											Type.map([[context.vars.key_1, context.vars.val_2]]),
										);
									},
								},
							],
							context,
						),
					);
				},
			},
		],
	);

	Interpreter.defineElixirFunction(
		"LeaplyWeb.Hologram.Components.ApplicantShell",
		"__props__",
		0,
		"public",
		[
			{
				params: (context) => [],
				guards: [],
				body: (context) => {
					return Elixir_Enum["reverse/1"](
						Type.list([
							Type.tuple([
								Type.atom("show_opportunities_navigation"),
								Type.atom("boolean"),
								Type.list([
									Type.tuple([Type.atom("default"), Type.atom("true")]),
								]),
							]),
							Type.tuple([
								Type.atom("profile_return_to"),
								Type.atom("string"),
								Type.list([
									Type.tuple([Type.atom("default"), Type.atom("nil")]),
								]),
							]),
							Type.tuple([
								Type.atom("professional_url"),
								Type.atom("string"),
								Type.list([
									Type.tuple([
										Type.atom("default"),
										Type.bitstring("/me/profile"),
									]),
								]),
							]),
							Type.tuple([
								Type.atom("display_name"),
								Type.atom("string"),
								Type.list([
									Type.tuple([Type.atom("default"), Type.bitstring("")]),
								]),
							]),
							Type.tuple([
								Type.atom("csrf_token"),
								Type.atom("string"),
								Type.list([
									Type.tuple([Type.atom("default"), Type.atom("nil")]),
								]),
							]),
							Type.tuple([
								Type.atom("authenticated"),
								Type.atom("boolean"),
								Type.list([
									Type.tuple([Type.atom("default"), Type.atom("false")]),
								]),
							]),
							Type.tuple([
								Type.atom("account_url"),
								Type.atom("string"),
								Type.list([
									Type.tuple([
										Type.atom("default"),
										Type.bitstring("/me/profile/settings"),
									]),
								]),
							]),
							Type.tuple([
								Type.atom("active_profile_page"),
								Type.atom("string"),
								Type.list([
									Type.tuple([Type.atom("default"), Type.atom("nil")]),
								]),
							]),
							Type.tuple([
								Type.atom("active_section"),
								Type.atom("string"),
								Type.list([
									Type.tuple([
										Type.atom("default"),
										Type.bitstring("listings"),
									]),
								]),
							]),
						]),
					);
				},
			},
		],
	);

	Interpreter.defineElixirFunction(
		"LeaplyWeb.Hologram.Components.ApplicantShell",
		"active_link_class",
		2,
		"public",
		[
			{
				params: (context) => [
					Type.variablePattern("active_section_0"),
					Type.variablePattern("section_1"),
				],
				guards: [],
				body: (context) => {
					return Interpreter.case(
						Erlang["==/2"](
							context.vars.active_section_0,
							context.vars.section_1,
						),
						[
							{
								match: Type.atom("false"),
								guards: [],
								body: (context) => {
									return Type.bitstring("btn btn-ghost min-h-11");
								},
							},
							{
								match: Type.atom("true"),
								guards: [],
								body: (context) => {
									return Type.bitstring("btn btn-primary min-h-11");
								},
							},
						],
						context,
					);
				},
			},
		],
	);

	Interpreter.defineElixirFunction(
		"LeaplyWeb.Hologram.Components.ApplicantShell",
		"aria_current",
		2,
		"public",
		[
			{
				params: (context) => [
					Type.variablePattern("active_section_0"),
					Type.variablePattern("section_1"),
				],
				guards: [],
				body: (context) => {
					return Interpreter.case(
						Erlang["==/2"](
							context.vars.active_section_0,
							context.vars.section_1,
						),
						[
							{
								match: Type.atom("false"),
								guards: [],
								body: (context) => {
									return Type.atom("nil");
								},
							},
							{
								match: Type.atom("true"),
								guards: [],
								body: (context) => {
									return Type.bitstring("page");
								},
							},
						],
						context,
					);
				},
			},
		],
	);

	Interpreter.defineElixirFunction(
		"LeaplyWeb.Hologram.Components.ApplicantShell",
		"profile_menu_account_url",
		2,
		"public",
		[
			{
				params: (context) => [
					Type.variablePattern("account_url_0"),
					Type.variablePattern("return_to_1"),
				],
				guards: [(context) => Erlang["is_binary/1"](context.vars.return_to_1)],
				body: (context) => {
					return Elixir_LeaplyWeb_Hologram_Helpers_ReturnToQuery["append/2"](
						context.vars.account_url_0,
						context.vars.return_to_1,
					);
				},
			},
			{
				params: (context) => [
					Type.variablePattern("account_url_0"),
					Type.matchPlaceholder(),
				],
				guards: [],
				body: (context) => {
					return context.vars.account_url_0;
				},
			},
		],
	);

	Interpreter.defineElixirFunction(
		"LeaplyWeb.Hologram.Components.ApplicantShell",
		"profile_menu_professional_url",
		2,
		"public",
		[
			{
				params: (context) => [
					Type.matchPlaceholder(),
					Type.variablePattern("return_to_1"),
				],
				guards: [(context) => Erlang["is_binary/1"](context.vars.return_to_1)],
				body: (context) => {
					return Elixir_LeaplyWeb_Hologram_Components_ProfileAreaNavigation[
						"professional_url/1"
					](context.vars.return_to_1);
				},
			},
			{
				params: (context) => [
					Type.variablePattern("professional_url_0"),
					Type.matchPlaceholder(),
				],
				guards: [],
				body: (context) => {
					return context.vars.professional_url_0;
				},
			},
		],
	);

	Interpreter.defineElixirFunction(
		"LeaplyWeb.Hologram.Components.ApplicantShell",
		"template",
		0,
		"public",
		[
			{
				params: (context) => [],
				guards: [],
				body: (context) => {
					globalThis.hologram.return = Type.anonymousFunction(
						1,
						[
							{
								params: (context) => [Type.variablePattern("vars_0")],
								guards: [],
								body: (context) => {
									Interpreter.matchOperator(
										context.vars.vars_0,
										Type.matchPlaceholder(),
										context,
									);
									Interpreter.updateVarsToMatchedValues(context);
									return Type.list([
										Type.tuple([
											Type.atom("element"),
											Type.bitstring("a"),
											Type.list([
												Type.tuple([
													Type.bitstring("href"),
													Type.list([
														Type.tuple([
															Type.atom("text"),
															Type.bitstring("#main-content"),
														]),
													]),
												]),
												Type.tuple([
													Type.bitstring("class"),
													Type.list([
														Type.tuple([
															Type.atom("text"),
															Type.bitstring(
																"sr-only fixed left-4 top-4 z-50 rounded-md bg-primary px-4 py-3 font-semibold text-primary-content focus:fixed focus:not-sr-only",
															),
														]),
													]),
												]),
											]),
											Type.list([
												Type.tuple([
													Type.atom("text"),
													Type.bitstring("Skip to main content"),
												]),
											]),
										]),
										Type.tuple([Type.atom("text"), Type.bitstring("\n")]),
										Type.tuple([
											Type.atom("element"),
											Type.bitstring("header"),
											Type.list([
												Type.tuple([
													Type.bitstring("class"),
													Type.list([
														Type.tuple([
															Type.atom("text"),
															Type.bitstring(
																"sticky top-0 z-40 border-b border-base-300 bg-base-100 text-base-content",
															),
														]),
													]),
												]),
												Type.tuple([
													Type.bitstring("id"),
													Type.list([
														Type.tuple([
															Type.atom("text"),
															Type.bitstring("applicant-shell"),
														]),
													]),
												]),
											]),
											Type.list([
												Type.tuple([Type.atom("text"), Type.bitstring("\n  ")]),
												Type.tuple([
													Type.atom("element"),
													Type.bitstring("div"),
													Type.list([
														Type.tuple([
															Type.bitstring("class"),
															Type.list([
																Type.tuple([
																	Type.atom("text"),
																	Type.bitstring(
																		"flex h-[var(--application-header-height)] w-full items-center gap-1 px-3 sm:gap-3 sm:px-6 lg:px-8",
																	),
																]),
															]),
														]),
													]),
													Type.list([
														Type.tuple([
															Type.atom("text"),
															Type.bitstring("\n    "),
														]),
														Type.tuple([
															Type.atom("element"),
															Type.bitstring("a"),
															Type.list([
																Type.tuple([
																	Type.bitstring("href"),
																	Type.list([
																		Type.tuple([
																			Type.atom("text"),
																			Type.bitstring("/"),
																		]),
																	]),
																]),
																Type.tuple([
																	Type.bitstring("class"),
																	Type.list([
																		Type.tuple([
																			Type.atom("text"),
																			Type.bitstring(
																				"group flex min-h-11 shrink-0 items-center rounded-md focus-visible:outline-2 focus-visible:outline-offset-4 focus-visible:outline-primary",
																			),
																		]),
																	]),
																]),
																Type.tuple([
																	Type.bitstring("aria-label"),
																	Type.list([
																		Type.tuple([
																			Type.atom("text"),
																			Type.bitstring("Leaply home"),
																		]),
																	]),
																]),
															]),
															Type.list([
																Type.tuple([
																	Type.atom("text"),
																	Type.bitstring("\n      "),
																]),
																Type.tuple([
																	Type.atom("element"),
																	Type.bitstring("img"),
																	Type.list([
																		Type.tuple([
																			Type.bitstring("src"),
																			Type.list([
																				Type.tuple([
																					Type.atom("text"),
																					Type.bitstring("/images/leaply.svg"),
																				]),
																			]),
																		]),
																		Type.tuple([
																			Type.bitstring("width"),
																			Type.list([
																				Type.tuple([
																					Type.atom("text"),
																					Type.bitstring("120"),
																				]),
																			]),
																		]),
																		Type.tuple([
																			Type.bitstring("height"),
																			Type.list([
																				Type.tuple([
																					Type.atom("text"),
																					Type.bitstring("40"),
																				]),
																			]),
																		]),
																		Type.tuple([
																			Type.bitstring("alt"),
																			Type.list([
																				Type.tuple([
																					Type.atom("text"),
																					Type.bitstring("Leaply"),
																				]),
																			]),
																		]),
																		Type.tuple([
																			Type.bitstring("class"),
																			Type.list([
																				Type.tuple([
																					Type.atom("text"),
																					Type.bitstring(
																						"h-auto w-16 transition duration-200 group-hover:-translate-y-0.5 motion-reduce:transform-none sm:h-10 sm:w-auto",
																					),
																				]),
																			]),
																		]),
																	]),
																	Type.list([]),
																]),
																Type.tuple([
																	Type.atom("text"),
																	Type.bitstring("\n    "),
																]),
															]),
														]),
														Type.tuple([
															Type.atom("text"),
															Type.bitstring("\n\n    "),
														]),
														Interpreter.case(
															Interpreter.dotOperator(
																context.vars.vars_0,
																Type.atom("show_opportunities_navigation"),
															),
															[
																{
																	match: Type.variablePattern("x_1"),
																	guards: [
																		(context) =>
																			Erlang["orelse/2"](
																				(context) =>
																					Erlang["=:=/2"](
																						context.vars.x_1,
																						Type.atom("false"),
																					),
																				(context) =>
																					Erlang["=:=/2"](
																						context.vars.x_1,
																						Type.atom("nil"),
																					),
																				context,
																			),
																	],
																	body: (context) => {
																		return Type.atom("nil");
																	},
																},
																{
																	match: Type.matchPlaceholder(),
																	guards: [],
																	body: (context) => {
																		return Type.list([
																			Type.tuple([
																				Type.atom("text"),
																				Type.bitstring("\n      "),
																			]),
																			Type.tuple([
																				Type.atom("element"),
																				Type.bitstring("nav"),
																				Type.list([
																					Type.tuple([
																						Type.bitstring(
																							"data-opportunities-navigation",
																						),
																						Type.list([]),
																					]),
																					Type.tuple([
																						Type.bitstring("class"),
																						Type.list([
																							Type.tuple([
																								Type.atom("text"),
																								Type.bitstring(
																									"hidden flex-1 items-center justify-center gap-1 md:flex",
																								),
																							]),
																						]),
																					]),
																					Type.tuple([
																						Type.bitstring("aria-label"),
																						Type.list([
																							Type.tuple([
																								Type.atom("text"),
																								Type.bitstring(
																									"Applicant navigation",
																								),
																							]),
																						]),
																					]),
																				]),
																				Type.list([
																					Type.tuple([
																						Type.atom("text"),
																						Type.bitstring("\n        "),
																					]),
																					Type.tuple([
																						Type.atom("element"),
																						Type.bitstring("a"),
																						Type.list([
																							Type.tuple([
																								Type.bitstring("href"),
																								Type.list([
																									Type.tuple([
																										Type.atom("text"),
																										Type.bitstring("/listings"),
																									]),
																								]),
																							]),
																							Type.tuple([
																								Type.bitstring("class"),
																								Type.list([
																									Type.tuple([
																										Type.atom("expression"),
																										Type.tuple([
																											Elixir_LeaplyWeb_Hologram_Components_ApplicantShell[
																												"active_link_class/2"
																											](
																												Interpreter.dotOperator(
																													context.vars.vars_0,
																													Type.atom(
																														"active_section",
																													),
																												),
																												Type.bitstring(
																													"listings",
																												),
																											),
																										]),
																									]),
																								]),
																							]),
																							Type.tuple([
																								Type.bitstring("aria-current"),
																								Type.list([
																									Type.tuple([
																										Type.atom("expression"),
																										Type.tuple([
																											Elixir_LeaplyWeb_Hologram_Components_ApplicantShell[
																												"aria_current/2"
																											](
																												Interpreter.dotOperator(
																													context.vars.vars_0,
																													Type.atom(
																														"active_section",
																													),
																												),
																												Type.bitstring(
																													"listings",
																												),
																											),
																										]),
																									]),
																								]),
																							]),
																						]),
																						Type.list([
																							Type.tuple([
																								Type.atom("text"),
																								Type.bitstring("Opportunities"),
																							]),
																						]),
																					]),
																					Type.tuple([
																						Type.atom("text"),
																						Type.bitstring("\n        "),
																					]),
																					Interpreter.case(
																						Interpreter.dotOperator(
																							context.vars.vars_0,
																							Type.atom("authenticated"),
																						),
																						[
																							{
																								match:
																									Type.variablePattern("x_2"),
																								guards: [
																									(context) =>
																										Erlang["orelse/2"](
																											(context) =>
																												Erlang["=:=/2"](
																													context.vars.x_2,
																													Type.atom("false"),
																												),
																											(context) =>
																												Erlang["=:=/2"](
																													context.vars.x_2,
																													Type.atom("nil"),
																												),
																											context,
																										),
																								],
																								body: (context) => {
																									return Type.atom("nil");
																								},
																							},
																							{
																								match: Type.matchPlaceholder(),
																								guards: [],
																								body: (context) => {
																									return Type.list([
																										Type.tuple([
																											Type.atom("text"),
																											Type.bitstring(
																												"\n          ",
																											),
																										]),
																										Type.tuple([
																											Type.atom("element"),
																											Type.bitstring("a"),
																											Type.list([
																												Type.tuple([
																													Type.bitstring(
																														"href",
																													),
																													Type.list([
																														Type.tuple([
																															Type.atom("text"),
																															Type.bitstring(
																																"/applications",
																															),
																														]),
																													]),
																												]),
																												Type.tuple([
																													Type.bitstring(
																														"class",
																													),
																													Type.list([
																														Type.tuple([
																															Type.atom(
																																"expression",
																															),
																															Type.tuple([
																																Elixir_LeaplyWeb_Hologram_Components_ApplicantShell[
																																	"active_link_class/2"
																																](
																																	Interpreter.dotOperator(
																																		context.vars
																																			.vars_0,
																																		Type.atom(
																																			"active_section",
																																		),
																																	),
																																	Type.bitstring(
																																		"applications",
																																	),
																																),
																															]),
																														]),
																													]),
																												]),
																												Type.tuple([
																													Type.bitstring(
																														"aria-current",
																													),
																													Type.list([
																														Type.tuple([
																															Type.atom(
																																"expression",
																															),
																															Type.tuple([
																																Elixir_LeaplyWeb_Hologram_Components_ApplicantShell[
																																	"aria_current/2"
																																](
																																	Interpreter.dotOperator(
																																		context.vars
																																			.vars_0,
																																		Type.atom(
																																			"active_section",
																																		),
																																	),
																																	Type.bitstring(
																																		"applications",
																																	),
																																),
																															]),
																														]),
																													]),
																												]),
																											]),
																											Type.list([
																												Type.tuple([
																													Type.atom("text"),
																													Type.bitstring(
																														"My applications",
																													),
																												]),
																											]),
																										]),
																										Type.tuple([
																											Type.atom("text"),
																											Type.bitstring(
																												"\n        ",
																											),
																										]),
																									]);
																								},
																							},
																						],
																						context,
																					),
																					Type.tuple([
																						Type.atom("text"),
																						Type.bitstring("\n      "),
																					]),
																				]),
																			]),
																			Type.tuple([
																				Type.atom("text"),
																				Type.bitstring("\n    "),
																			]),
																		]);
																	},
																},
															],
															context,
														),
														Type.tuple([
															Type.atom("text"),
															Type.bitstring("\n\n    "),
														]),
														Type.tuple([
															Type.atom("element"),
															Type.bitstring("div"),
															Type.list([
																Type.tuple([
																	Type.bitstring("class"),
																	Type.list([
																		Type.tuple([
																			Type.atom("text"),
																			Type.bitstring(
																				"ml-auto flex items-center gap-1 sm:gap-2",
																			),
																		]),
																	]),
																]),
															]),
															Type.list([
																Type.tuple([
																	Type.atom("text"),
																	Type.bitstring("\n      "),
																]),
																Type.tuple([
																	Type.atom("component"),
																	Type.atom(
																		"Elixir.LeaplyWeb.Hologram.Components.ThemeToggle",
																	),
																	Type.list([]),
																	Type.list([]),
																]),
																Type.tuple([
																	Type.atom("text"),
																	Type.bitstring("\n\n      "),
																]),
																Interpreter.case(
																	Interpreter.dotOperator(
																		context.vars.vars_0,
																		Type.atom("authenticated"),
																	),
																	[
																		{
																			match: Type.variablePattern("x_3"),
																			guards: [
																				(context) =>
																					Erlang["orelse/2"](
																						(context) =>
																							Erlang["=:=/2"](
																								context.vars.x_3,
																								Type.atom("false"),
																							),
																						(context) =>
																							Erlang["=:=/2"](
																								context.vars.x_3,
																								Type.atom("nil"),
																							),
																						context,
																					),
																			],
																			body: (context) => {
																				return Type.list([
																					Type.tuple([
																						Type.atom("text"),
																						Type.bitstring("\n        "),
																					]),
																					Type.tuple([
																						Type.atom("element"),
																						Type.bitstring("a"),
																						Type.list([
																							Type.tuple([
																								Type.bitstring("href"),
																								Type.list([
																									Type.tuple([
																										Type.atom("text"),
																										Type.bitstring("/login"),
																									]),
																								]),
																							]),
																							Type.tuple([
																								Type.bitstring("class"),
																								Type.list([
																									Type.tuple([
																										Type.atom("text"),
																										Type.bitstring(
																											"btn btn-ghost min-h-11 whitespace-nowrap px-1.5 sm:px-4",
																										),
																									]),
																								]),
																							]),
																						]),
																						Type.list([
																							Type.tuple([
																								Type.atom("text"),
																								Type.bitstring(
																									"\n          Log in\n        ",
																								),
																							]),
																						]),
																					]),
																					Type.tuple([
																						Type.atom("text"),
																						Type.bitstring("\n        "),
																					]),
																					Type.tuple([
																						Type.atom("element"),
																						Type.bitstring("a"),
																						Type.list([
																							Type.tuple([
																								Type.bitstring("href"),
																								Type.list([
																									Type.tuple([
																										Type.atom("text"),
																										Type.bitstring("/register"),
																									]),
																								]),
																							]),
																							Type.tuple([
																								Type.bitstring("class"),
																								Type.list([
																									Type.tuple([
																										Type.atom("text"),
																										Type.bitstring(
																											"btn btn-primary min-h-11 px-2 sm:px-4",
																										),
																									]),
																								]),
																							]),
																						]),
																						Type.list([
																							Type.tuple([
																								Type.atom("text"),
																								Type.bitstring("\n          "),
																							]),
																							Type.tuple([
																								Type.atom("element"),
																								Type.bitstring("span"),
																								Type.list([
																									Type.tuple([
																										Type.bitstring("class"),
																										Type.list([
																											Type.tuple([
																												Type.atom("text"),
																												Type.bitstring(
																													"sm:hidden",
																												),
																											]),
																										]),
																									]),
																								]),
																								Type.list([
																									Type.tuple([
																										Type.atom("text"),
																										Type.bitstring("Join"),
																									]),
																								]),
																							]),
																							Type.tuple([
																								Type.atom("text"),
																								Type.bitstring("\n          "),
																							]),
																							Type.tuple([
																								Type.atom("element"),
																								Type.bitstring("span"),
																								Type.list([
																									Type.tuple([
																										Type.bitstring("class"),
																										Type.list([
																											Type.tuple([
																												Type.atom("text"),
																												Type.bitstring(
																													"hidden sm:inline",
																												),
																											]),
																										]),
																									]),
																								]),
																								Type.list([
																									Type.tuple([
																										Type.atom("text"),
																										Type.bitstring(
																											"Create profile",
																										),
																									]),
																								]),
																							]),
																							Type.tuple([
																								Type.atom("text"),
																								Type.bitstring("\n        "),
																							]),
																						]),
																					]),
																					Type.tuple([
																						Type.atom("text"),
																						Type.bitstring("\n      "),
																					]),
																				]);
																			},
																		},
																		{
																			match: Type.matchPlaceholder(),
																			guards: [],
																			body: (context) => {
																				return Type.list([
																					Type.tuple([
																						Type.atom("text"),
																						Type.bitstring("\n        "),
																					]),
																					Type.tuple([
																						Type.atom("component"),
																						Type.atom(
																							"Elixir.LeaplyWeb.Hologram.Components.ApplicationMenu",
																						),
																						Type.list([
																							Type.tuple([
																								Type.bitstring("cid"),
																								Type.list([
																									Type.tuple([
																										Type.atom("text"),
																										Type.bitstring(
																											"application-menu",
																										),
																									]),
																								]),
																							]),
																							Type.tuple([
																								Type.bitstring(
																									"professional_url",
																								),
																								Type.list([
																									Type.tuple([
																										Type.atom("expression"),
																										Type.tuple([
																											Elixir_LeaplyWeb_Hologram_Components_ApplicantShell[
																												"profile_menu_professional_url/2"
																											](
																												Interpreter.dotOperator(
																													context.vars.vars_0,
																													Type.atom(
																														"professional_url",
																													),
																												),
																												Interpreter.dotOperator(
																													context.vars.vars_0,
																													Type.atom(
																														"profile_return_to",
																													),
																												),
																											),
																										]),
																									]),
																								]),
																							]),
																							Type.tuple([
																								Type.bitstring("account_url"),
																								Type.list([
																									Type.tuple([
																										Type.atom("expression"),
																										Type.tuple([
																											Elixir_LeaplyWeb_Hologram_Components_ApplicantShell[
																												"profile_menu_account_url/2"
																											](
																												Interpreter.dotOperator(
																													context.vars.vars_0,
																													Type.atom(
																														"account_url",
																													),
																												),
																												Interpreter.dotOperator(
																													context.vars.vars_0,
																													Type.atom(
																														"profile_return_to",
																													),
																												),
																											),
																										]),
																									]),
																								]),
																							]),
																						]),
																						Type.list([]),
																					]),
																					Type.tuple([
																						Type.atom("text"),
																						Type.bitstring("\n      "),
																					]),
																				]);
																			},
																		},
																	],
																	context,
																),
																Type.tuple([
																	Type.atom("text"),
																	Type.bitstring("\n    "),
																]),
															]),
														]),
														Type.tuple([
															Type.atom("text"),
															Type.bitstring("\n  "),
														]),
													]),
												]),
												Type.tuple([
													Type.atom("text"),
													Type.bitstring("\n\n  "),
												]),
												Interpreter.case(
													Interpreter.dotOperator(
														context.vars.vars_0,
														Type.atom("show_opportunities_navigation"),
													),
													[
														{
															match: Type.variablePattern("x_4"),
															guards: [
																(context) =>
																	Erlang["orelse/2"](
																		(context) =>
																			Erlang["=:=/2"](
																				context.vars.x_4,
																				Type.atom("false"),
																			),
																		(context) =>
																			Erlang["=:=/2"](
																				context.vars.x_4,
																				Type.atom("nil"),
																			),
																		context,
																	),
															],
															body: (context) => {
																return Type.atom("nil");
															},
														},
														{
															match: Type.matchPlaceholder(),
															guards: [],
															body: (context) => {
																return Type.list([
																	Type.tuple([
																		Type.atom("text"),
																		Type.bitstring("\n    "),
																	]),
																	Type.tuple([
																		Type.atom("element"),
																		Type.bitstring("nav"),
																		Type.list([
																			Type.tuple([
																				Type.bitstring(
																					"data-opportunities-navigation",
																				),
																				Type.list([]),
																			]),
																			Type.tuple([
																				Type.bitstring("class"),
																				Type.list([
																					Type.tuple([
																						Type.atom("text"),
																						Type.bitstring(
																							"flex border-t border-base-300 px-3 py-2 md:hidden",
																						),
																					]),
																				]),
																			]),
																			Type.tuple([
																				Type.bitstring("aria-label"),
																				Type.list([
																					Type.tuple([
																						Type.atom("text"),
																						Type.bitstring(
																							"Mobile applicant navigation",
																						),
																					]),
																				]),
																			]),
																		]),
																		Type.list([
																			Type.tuple([
																				Type.atom("text"),
																				Type.bitstring("\n      "),
																			]),
																			Type.tuple([
																				Type.atom("element"),
																				Type.bitstring("a"),
																				Type.list([
																					Type.tuple([
																						Type.bitstring("href"),
																						Type.list([
																							Type.tuple([
																								Type.atom("text"),
																								Type.bitstring("/listings"),
																							]),
																						]),
																					]),
																					Type.tuple([
																						Type.bitstring("class"),
																						Type.list([
																							Type.tuple([
																								Type.atom("expression"),
																								Type.tuple([
																									Type.bitstring([
																										Type.bitstringSegment(
																											Type.string("flex-1 "),
																											{ type: "binary" },
																										),
																										Type.bitstringSegment(
																											Elixir_String_Chars[
																												"to_string/1"
																											](
																												Elixir_LeaplyWeb_Hologram_Components_ApplicantShell[
																													"active_link_class/2"
																												](
																													Interpreter.dotOperator(
																														context.vars.vars_0,
																														Type.atom(
																															"active_section",
																														),
																													),
																													Type.bitstring(
																														"listings",
																													),
																												),
																											),
																											{ type: "binary" },
																										),
																									]),
																								]),
																							]),
																						]),
																					]),
																					Type.tuple([
																						Type.bitstring("aria-current"),
																						Type.list([
																							Type.tuple([
																								Type.atom("expression"),
																								Type.tuple([
																									Elixir_LeaplyWeb_Hologram_Components_ApplicantShell[
																										"aria_current/2"
																									](
																										Interpreter.dotOperator(
																											context.vars.vars_0,
																											Type.atom(
																												"active_section",
																											),
																										),
																										Type.bitstring("listings"),
																									),
																								]),
																							]),
																						]),
																					]),
																				]),
																				Type.list([
																					Type.tuple([
																						Type.atom("text"),
																						Type.bitstring("Opportunities"),
																					]),
																				]),
																			]),
																			Type.tuple([
																				Type.atom("text"),
																				Type.bitstring("\n      "),
																			]),
																			Interpreter.case(
																				Interpreter.dotOperator(
																					context.vars.vars_0,
																					Type.atom("authenticated"),
																				),
																				[
																					{
																						match: Type.variablePattern("x_5"),
																						guards: [
																							(context) =>
																								Erlang["orelse/2"](
																									(context) =>
																										Erlang["=:=/2"](
																											context.vars.x_5,
																											Type.atom("false"),
																										),
																									(context) =>
																										Erlang["=:=/2"](
																											context.vars.x_5,
																											Type.atom("nil"),
																										),
																									context,
																								),
																						],
																						body: (context) => {
																							return Type.atom("nil");
																						},
																					},
																					{
																						match: Type.matchPlaceholder(),
																						guards: [],
																						body: (context) => {
																							return Type.list([
																								Type.tuple([
																									Type.atom("text"),
																									Type.bitstring("\n        "),
																								]),
																								Type.tuple([
																									Type.atom("element"),
																									Type.bitstring("a"),
																									Type.list([
																										Type.tuple([
																											Type.bitstring("href"),
																											Type.list([
																												Type.tuple([
																													Type.atom("text"),
																													Type.bitstring(
																														"/applications",
																													),
																												]),
																											]),
																										]),
																										Type.tuple([
																											Type.bitstring("class"),
																											Type.list([
																												Type.tuple([
																													Type.atom(
																														"expression",
																													),
																													Type.tuple([
																														Type.bitstring([
																															Type.bitstringSegment(
																																Type.string(
																																	"flex-1 ",
																																),
																																{
																																	type: "binary",
																																},
																															),
																															Type.bitstringSegment(
																																Elixir_String_Chars[
																																	"to_string/1"
																																](
																																	Elixir_LeaplyWeb_Hologram_Components_ApplicantShell[
																																		"active_link_class/2"
																																	](
																																		Interpreter.dotOperator(
																																			context
																																				.vars
																																				.vars_0,
																																			Type.atom(
																																				"active_section",
																																			),
																																		),
																																		Type.bitstring(
																																			"applications",
																																		),
																																	),
																																),
																																{
																																	type: "binary",
																																},
																															),
																														]),
																													]),
																												]),
																											]),
																										]),
																										Type.tuple([
																											Type.bitstring(
																												"aria-current",
																											),
																											Type.list([
																												Type.tuple([
																													Type.atom(
																														"expression",
																													),
																													Type.tuple([
																														Elixir_LeaplyWeb_Hologram_Components_ApplicantShell[
																															"aria_current/2"
																														](
																															Interpreter.dotOperator(
																																context.vars
																																	.vars_0,
																																Type.atom(
																																	"active_section",
																																),
																															),
																															Type.bitstring(
																																"applications",
																															),
																														),
																													]),
																												]),
																											]),
																										]),
																									]),
																									Type.list([
																										Type.tuple([
																											Type.atom("text"),
																											Type.bitstring(
																												"My applications",
																											),
																										]),
																									]),
																								]),
																								Type.tuple([
																									Type.atom("text"),
																									Type.bitstring("\n      "),
																								]),
																							]);
																						},
																					},
																				],
																				context,
																			),
																			Type.tuple([
																				Type.atom("text"),
																				Type.bitstring("\n    "),
																			]),
																		]),
																	]),
																	Type.tuple([
																		Type.atom("text"),
																		Type.bitstring("\n  "),
																	]),
																]);
															},
														},
													],
													context,
												),
												Type.tuple([Type.atom("text"), Type.bitstring("\n")]),
											]),
										]),
									]);
								},
							},
						],
						context,
					);
					Interpreter.updateVarsToMatchedValues(context);
					return globalThis.hologram.return;
				},
			},
		],
	);

	Interpreter.defineElixirFunction(
		"LeaplyWeb.Hologram.Components.ApplicationBar",
		"__props__",
		0,
		"public",
		[
			{
				params: (context) => [],
				guards: [],
				body: (context) => {
					return Elixir_Enum["reverse/1"](
						Type.list([
							Type.tuple([
								Type.atom("navigation"),
								Type.atom("map"),
								Type.list([
									Type.tuple([Type.atom("default"), Type.atom("nil")]),
									Type.tuple([
										Type.atom("from_context"),
										Type.tuple([
											Type.atom("Elixir.LeaplyWeb.ApplicationNavigation"),
											Type.atom("navigation"),
										]),
									]),
								]),
							]),
						]),
					);
				},
			},
		],
	);

	Interpreter.defineElixirFunction(
		"LeaplyWeb.Hologram.Components.ApplicationBar",
		"template",
		0,
		"public",
		[
			{
				params: (context) => [],
				guards: [],
				body: (context) => {
					globalThis.hologram.return = Type.anonymousFunction(
						1,
						[
							{
								params: (context) => [Type.variablePattern("vars_0")],
								guards: [],
								body: (context) => {
									Interpreter.matchOperator(
										context.vars.vars_0,
										Type.matchPlaceholder(),
										context,
									);
									Interpreter.updateVarsToMatchedValues(context);
									return Type.list([
										Interpreter.case(
											Interpreter.dotOperator(
												context.vars.vars_0,
												Type.atom("navigation"),
											),
											[
												{
													match: Type.variablePattern("x_1"),
													guards: [
														(context) =>
															Erlang["orelse/2"](
																(context) =>
																	Erlang["=:=/2"](
																		context.vars.x_1,
																		Type.atom("false"),
																	),
																(context) =>
																	Erlang["=:=/2"](
																		context.vars.x_1,
																		Type.atom("nil"),
																	),
																context,
															),
													],
													body: (context) => {
														return Type.atom("nil");
													},
												},
												{
													match: Type.matchPlaceholder(),
													guards: [],
													body: (context) => {
														return Type.list([
															Type.tuple([
																Type.atom("text"),
																Type.bitstring("\n  "),
															]),
															Type.tuple([
																Type.atom("component"),
																Type.atom(
																	"Elixir.LeaplyWeb.Hologram.Components.ApplicationHeader",
																),
																Type.list([
																	Type.tuple([
																		Type.bitstring("cid"),
																		Type.list([
																			Type.tuple([
																				Type.atom("text"),
																				Type.bitstring("application-header"),
																			]),
																		]),
																	]),
																]),
																Type.list([
																	Type.tuple([
																		Type.atom("text"),
																		Type.bitstring("\n    "),
																	]),
																	Type.tuple([
																		Type.atom("element"),
																		Type.bitstring("div"),
																		Type.list([
																			Type.tuple([
																				Type.bitstring("class"),
																				Type.list([
																					Type.tuple([
																						Type.atom("text"),
																						Type.bitstring(
																							"ml-auto flex items-center gap-1 sm:gap-2",
																						),
																					]),
																				]),
																			]),
																		]),
																		Type.list([
																			Type.tuple([
																				Type.atom("text"),
																				Type.bitstring("\n      "),
																			]),
																			Type.tuple([
																				Type.atom("component"),
																				Type.atom(
																					"Elixir.LeaplyWeb.Hologram.Components.ThemeToggle",
																				),
																				Type.list([
																					Type.tuple([
																						Type.bitstring("cid"),
																						Type.list([
																							Type.tuple([
																								Type.atom("text"),
																								Type.bitstring(
																									"application-theme-toggle",
																								),
																							]),
																						]),
																					]),
																				]),
																				Type.list([]),
																			]),
																			Type.tuple([
																				Type.atom("text"),
																				Type.bitstring("\n      "),
																			]),
																			Type.tuple([
																				Type.atom("component"),
																				Type.atom(
																					"Elixir.LeaplyWeb.Hologram.Components.ApplicationMenu",
																				),
																				Type.list([
																					Type.tuple([
																						Type.bitstring("cid"),
																						Type.list([
																							Type.tuple([
																								Type.atom("text"),
																								Type.bitstring(
																									"application-menu",
																								),
																							]),
																						]),
																					]),
																				]),
																				Type.list([]),
																			]),
																			Type.tuple([
																				Type.atom("text"),
																				Type.bitstring("\n    "),
																			]),
																		]),
																	]),
																	Type.tuple([
																		Type.atom("text"),
																		Type.bitstring("\n  "),
																	]),
																]),
															]),
															Type.tuple([
																Type.atom("text"),
																Type.bitstring("\n"),
															]),
														]);
													},
												},
											],
											context,
										),
									]);
								},
							},
						],
						context,
					);
					Interpreter.updateVarsToMatchedValues(context);
					return globalThis.hologram.return;
				},
			},
		],
	);

	Interpreter.defineElixirFunction(
		"LeaplyWeb.Hologram.Components.ApplicationHeader",
		"__props__",
		0,
		"public",
		[
			{
				params: (context) => [],
				guards: [],
				body: (context) => {
					return Elixir_Enum["reverse/1"](
						Type.list([
							Type.tuple([
								Type.atom("preview"),
								Type.atom("boolean"),
								Type.list([
									Type.tuple([Type.atom("default"), Type.atom("false")]),
								]),
							]),
							Type.tuple([
								Type.atom("home_path"),
								Type.atom("string"),
								Type.list([
									Type.tuple([Type.atom("default"), Type.bitstring("/")]),
								]),
							]),
						]),
					);
				},
			},
		],
	);

	Interpreter.defineElixirFunction(
		"LeaplyWeb.Hologram.Components.ApplicationHeader",
		"home_label",
		0,
		"public",
		[
			{
				params: (context) => [],
				guards: [],
				body: (context) => {
					return Elixir_LeaplyWeb_Hologram_Helpers_CatalogText["get/2"](
						Type.bitstring("shared"),
						Type.bitstring("shared.navigation.home"),
					);
				},
			},
		],
	);

	Interpreter.defineElixirFunction(
		"LeaplyWeb.Hologram.Components.ApplicationHeader",
		"logo_size",
		1,
		"public",
		[
			{
				params: (context) => [Type.atom("true")],
				guards: [],
				body: (context) => {
					return Type.bitstring(
						"@min-[40rem]/story:h-10 @min-[40rem]/story:w-auto",
					);
				},
			},
			{
				params: (context) => [Type.atom("false")],
				guards: [],
				body: (context) => {
					return Type.bitstring("sm:h-10 sm:w-auto");
				},
			},
		],
	);

	Interpreter.defineElixirFunction(
		"LeaplyWeb.Hologram.Components.ApplicationHeader",
		"spacing",
		1,
		"public",
		[
			{
				params: (context) => [Type.atom("true")],
				guards: [],
				body: (context) => {
					return Type.bitstring(
						"@min-[40rem]/story:gap-3 @min-[40rem]/story:px-6 @min-[64rem]/story:px-8",
					);
				},
			},
			{
				params: (context) => [Type.atom("false")],
				guards: [],
				body: (context) => {
					return Type.bitstring("sm:gap-3 sm:px-6 lg:px-8");
				},
			},
		],
	);

	Interpreter.defineElixirFunction(
		"LeaplyWeb.Hologram.Components.ApplicationHeader",
		"template",
		0,
		"public",
		[
			{
				params: (context) => [],
				guards: [],
				body: (context) => {
					globalThis.hologram.return = Type.anonymousFunction(
						1,
						[
							{
								params: (context) => [Type.variablePattern("vars_0")],
								guards: [],
								body: (context) => {
									Interpreter.matchOperator(
										context.vars.vars_0,
										Type.matchPlaceholder(),
										context,
									);
									Interpreter.updateVarsToMatchedValues(context);
									return Type.list([
										Type.tuple([
											Type.atom("element"),
											Type.bitstring("header"),
											Type.list([
												Type.tuple([
													Type.bitstring("data-application-bar"),
													Type.list([]),
												]),
												Type.tuple([
													Type.bitstring("class"),
													Type.list([
														Type.tuple([
															Type.atom("text"),
															Type.bitstring(
																"sticky top-0 z-40 border-b border-base-300 bg-base-100 text-base-content",
															),
														]),
													]),
												]),
											]),
											Type.list([
												Type.tuple([Type.atom("text"), Type.bitstring("\n  ")]),
												Type.tuple([
													Type.atom("element"),
													Type.bitstring("div"),
													Type.list([
														Type.tuple([
															Type.bitstring("class"),
															Type.list([
																Type.tuple([
																	Type.atom("expression"),
																	Type.tuple([
																		Type.bitstring([
																			Type.bitstringSegment(
																				Type.string(
																					"flex h-[var(--application-header-height)] items-center gap-1 px-3 ",
																				),
																				{ type: "binary" },
																			),
																			Type.bitstringSegment(
																				Elixir_LeaplyWeb_Hologram_Components_ApplicationHeader[
																					"spacing/1"
																				](
																					Interpreter.dotOperator(
																						context.vars.vars_0,
																						Type.atom("preview"),
																					),
																				),
																				{ type: "binary" },
																			),
																		]),
																	]),
																]),
															]),
														]),
													]),
													Type.list([
														Type.tuple([
															Type.atom("text"),
															Type.bitstring("\n    "),
														]),
														Type.tuple([
															Type.atom("element"),
															Type.bitstring("a"),
															Type.list([
																Type.tuple([
																	Type.bitstring("href"),
																	Type.list([
																		Type.tuple([
																			Type.atom("expression"),
																			Type.tuple([
																				Interpreter.dotOperator(
																					context.vars.vars_0,
																					Type.atom("home_path"),
																				),
																			]),
																		]),
																	]),
																]),
																Type.tuple([
																	Type.bitstring("aria-label"),
																	Type.list([
																		Type.tuple([
																			Type.atom("expression"),
																			Type.tuple([
																				Elixir_LeaplyWeb_Hologram_Components_ApplicationHeader[
																					"home_label/0"
																				](),
																			]),
																		]),
																	]),
																]),
																Type.tuple([
																	Type.bitstring("class"),
																	Type.list([
																		Type.tuple([
																			Type.atom("text"),
																			Type.bitstring(
																				"group inline-flex min-h-11 shrink-0 items-center rounded-md focus-visible:outline-2 focus-visible:outline-offset-4 focus-visible:outline-primary",
																			),
																		]),
																	]),
																]),
															]),
															Type.list([
																Type.tuple([
																	Type.atom("element"),
																	Type.bitstring("img"),
																	Type.list([
																		Type.tuple([
																			Type.bitstring("src"),
																			Type.list([
																				Type.tuple([
																					Type.atom("text"),
																					Type.bitstring("/images/leaply.svg"),
																				]),
																			]),
																		]),
																		Type.tuple([
																			Type.bitstring("width"),
																			Type.list([
																				Type.tuple([
																					Type.atom("text"),
																					Type.bitstring("120"),
																				]),
																			]),
																		]),
																		Type.tuple([
																			Type.bitstring("height"),
																			Type.list([
																				Type.tuple([
																					Type.atom("text"),
																					Type.bitstring("40"),
																				]),
																			]),
																		]),
																		Type.tuple([
																			Type.bitstring("alt"),
																			Type.list([
																				Type.tuple([
																					Type.atom("text"),
																					Type.bitstring("Leaply"),
																				]),
																			]),
																		]),
																		Type.tuple([
																			Type.bitstring("class"),
																			Type.list([
																				Type.tuple([
																					Type.atom("expression"),
																					Type.tuple([
																						Type.bitstring([
																							Type.bitstringSegment(
																								Type.string(
																									"h-auto w-16 transition duration-200 group-hover:-translate-y-0.5 motion-reduce:transform-none ",
																								),
																								{ type: "binary" },
																							),
																							Type.bitstringSegment(
																								Elixir_LeaplyWeb_Hologram_Components_ApplicationHeader[
																									"logo_size/1"
																								](
																									Interpreter.dotOperator(
																										context.vars.vars_0,
																										Type.atom("preview"),
																									),
																								),
																								{ type: "binary" },
																							),
																						]),
																					]),
																				]),
																			]),
																		]),
																	]),
																	Type.list([]),
																]),
															]),
														]),
														Type.tuple([
															Type.atom("text"),
															Type.bitstring("\n    "),
														]),
														Type.tuple([
															Type.atom("element"),
															Type.bitstring("slot"),
															Type.list([]),
															Type.list([]),
														]),
														Type.tuple([
															Type.atom("text"),
															Type.bitstring("\n  "),
														]),
													]),
												]),
												Type.tuple([Type.atom("text"), Type.bitstring("\n")]),
											]),
										]),
									]);
								},
							},
						],
						context,
					);
					Interpreter.updateVarsToMatchedValues(context);
					return globalThis.hologram.return;
				},
			},
		],
	);

	Interpreter.defineElixirFunction(
		"LeaplyWeb.Hologram.Components.ApplicationMenu",
		"__props__",
		0,
		"public",
		[
			{
				params: (context) => [],
				guards: [],
				body: (context) => {
					return Elixir_Enum["reverse/1"](
						Type.list([
							Type.tuple([
								Type.atom("preview"),
								Type.atom("boolean"),
								Type.list([
									Type.tuple([Type.atom("default"), Type.atom("false")]),
								]),
							]),
							Type.tuple([
								Type.atom("id_prefix"),
								Type.atom("string"),
								Type.list([
									Type.tuple([
										Type.atom("default"),
										Type.bitstring("applicant-profile-menu"),
									]),
								]),
							]),
							Type.tuple([
								Type.atom("account_url"),
								Type.atom("string"),
								Type.list([
									Type.tuple([
										Type.atom("default"),
										Type.bitstring("/me/profile/settings"),
									]),
								]),
							]),
							Type.tuple([
								Type.atom("professional_url"),
								Type.atom("string"),
								Type.list([
									Type.tuple([
										Type.atom("default"),
										Type.bitstring("/me/profile"),
									]),
								]),
							]),
							Type.tuple([
								Type.atom("request_navigation"),
								Type.atom("map"),
								Type.list([
									Type.tuple([Type.atom("default"), Type.atom("nil")]),
									Type.tuple([
										Type.atom("from_context"),
										Type.tuple([
											Type.atom("Elixir.LeaplyWeb.ApplicationNavigation"),
											Type.atom("navigation"),
										]),
									]),
								]),
							]),
							Type.tuple([
								Type.atom("navigation"),
								Type.atom("map"),
								Type.list([
									Type.tuple([Type.atom("default"), Type.atom("nil")]),
								]),
							]),
						]),
					);
				},
			},
		],
	);

	Interpreter.defineElixirFunction(
		"LeaplyWeb.Hologram.Components.ApplicationMenu",
		"aria_current",
		1,
		"public",
		[
			{
				params: (context) => [Type.atom("true")],
				guards: [],
				body: (context) => {
					return Type.bitstring("page");
				},
			},
			{
				params: (context) => [Type.atom("false")],
				guards: [],
				body: (context) => {
					return Type.atom("nil");
				},
			},
		],
	);

	Interpreter.defineElixirFunction(
		"LeaplyWeb.Hologram.Components.ApplicationMenu",
		"icon",
		1,
		"public",
		[
			{
				params: (context) => [Type.bitstring("opportunities")],
				guards: [],
				body: (context) => {
					return Type.bitstring("hero-magnifying-glass");
				},
			},
			{
				params: (context) => [Type.bitstring("applications")],
				guards: [],
				body: (context) => {
					return Type.bitstring("hero-document-text");
				},
			},
			{
				params: (context) => [Type.bitstring("professional")],
				guards: [],
				body: (context) => {
					return Type.bitstring("hero-user-circle");
				},
			},
			{
				params: (context) => [Type.bitstring("settings")],
				guards: [],
				body: (context) => {
					return Type.bitstring("hero-cog-6-tooth");
				},
			},
			{
				params: (context) => [Type.bitstring("managed-listings")],
				guards: [],
				body: (context) => {
					return Type.bitstring("hero-building-office-2");
				},
			},
			{
				params: (context) => [Type.bitstring("system-questions")],
				guards: [],
				body: (context) => {
					return Type.bitstring("hero-question-mark-circle");
				},
			},
			{
				params: (context) => [Type.bitstring("identity-reviews")],
				guards: [],
				body: (context) => {
					return Type.bitstring("hero-identification");
				},
			},
			{
				params: (context) => [Type.bitstring("handbooks")],
				guards: [],
				body: (context) => {
					return Type.bitstring("hero-book-open");
				},
			},
			{
				params: (context) => [Type.bitstring("institution-reviews")],
				guards: [],
				body: (context) => {
					return Type.bitstring("hero-building-office");
				},
			},
			{
				params: (context) => [Type.bitstring("academic-catalogue")],
				guards: [],
				body: (context) => {
					return Type.bitstring("hero-academic-cap");
				},
			},
			{
				params: (context) => [Type.bitstring("data-browser")],
				guards: [],
				body: (context) => {
					return Type.bitstring("hero-circle-stack");
				},
			},
			{
				params: (context) => [Type.bitstring("design-system")],
				guards: [],
				body: (context) => {
					return Type.bitstring("hero-swatch");
				},
			},
			{
				params: (context) => [Type.bitstring("documentation")],
				guards: [],
				body: (context) => {
					return Type.bitstring("hero-book-open");
				},
			},
		],
	);

	Interpreter.defineElixirFunction(
		"LeaplyWeb.Hologram.Components.ApplicationMenu",
		"initial",
		1,
		"public",
		[
			{
				params: (context) => [Type.variablePattern("name_0")],
				guards: [],
				body: (context) => {
					return Elixir_String["upcase/1"](
						Interpreter.case(
							Elixir_String["first/1"](
								Elixir_String["trim/1"](context.vars.name_0),
							),
							[
								{
									match: Type.variablePattern("x_1"),
									guards: [
										(context) =>
											Erlang["orelse/2"](
												(context) =>
													Erlang["=:=/2"](context.vars.x_1, Type.atom("false")),
												(context) =>
													Erlang["=:=/2"](context.vars.x_1, Type.atom("nil")),
												context,
											),
									],
									body: (context) => {
										return Type.bitstring("P");
									},
								},
								{
									match: Type.variablePattern("x_2"),
									guards: [],
									body: (context) => {
										return context.vars.x_2;
									},
								},
							],
							context,
						),
					);
				},
			},
		],
	);

	Interpreter.defineElixirFunction(
		"LeaplyWeb.Hologram.Components.ApplicationMenu",
		"link_class",
		1,
		"public",
		[
			{
				params: (context) => [Type.atom("true")],
				guards: [],
				body: (context) => {
					return Type.bitstring("menu-active min-h-11 content-center");
				},
			},
			{
				params: (context) => [Type.atom("false")],
				guards: [],
				body: (context) => {
					return Type.bitstring("min-h-11 content-center");
				},
			},
		],
	);

	Interpreter.defineElixirFunction(
		"LeaplyWeb.Hologram.Components.ApplicationMenu",
		"link_path",
		4,
		"public",
		[
			{
				params: (context) => [
					Type.matchPlaceholder(),
					Type.matchPlaceholder(),
					Type.matchPlaceholder(),
					Type.atom("true"),
				],
				guards: [],
				body: (context) => {
					return Type.bitstring("#compositions");
				},
			},
			{
				params: (context) => [
					Type.map([[Type.atom("id"), Type.bitstring("professional")]]),
					Type.variablePattern("professional_0"),
					Type.matchPlaceholder(),
					Type.matchPlaceholder(),
				],
				guards: [],
				body: (context) => {
					return context.vars.professional_0;
				},
			},
			{
				params: (context) => [
					Type.map([[Type.atom("id"), Type.bitstring("settings")]]),
					Type.matchPlaceholder(),
					Type.variablePattern("settings_1"),
					Type.matchPlaceholder(),
				],
				guards: [],
				body: (context) => {
					return context.vars.settings_1;
				},
			},
			{
				params: (context) => [
					Type.variablePattern("entry_0"),
					Type.matchPlaceholder(),
					Type.matchPlaceholder(),
					Type.matchPlaceholder(),
				],
				guards: [],
				body: (context) => {
					return Interpreter.dotOperator(
						context.vars.entry_0,
						Type.atom("path"),
					);
				},
			},
		],
	);

	Interpreter.defineElixirFunction(
		"LeaplyWeb.Hologram.Components.ApplicationMenu",
		"name_visibility",
		1,
		"public",
		[
			{
				params: (context) => [Type.atom("true")],
				guards: [],
				body: (context) => {
					return Type.bitstring("@min-[40rem]/story:block");
				},
			},
			{
				params: (context) => [Type.atom("false")],
				guards: [],
				body: (context) => {
					return Type.bitstring("sm:block");
				},
			},
		],
	);

	Interpreter.defineElixirFunction(
		"LeaplyWeb.Hologram.Components.ApplicationMenu",
		"projection",
		2,
		"public",
		[
			{
				params: (context) => [
					Type.variablePattern("navigation_0"),
					Type.variablePattern("request_navigation_1"),
				],
				guards: [],
				body: (context) => {
					return Interpreter.case(
						context.vars.navigation_0,
						[
							{
								match: Type.variablePattern("x_2"),
								guards: [
									(context) =>
										Erlang["orelse/2"](
											(context) =>
												Erlang["=:=/2"](context.vars.x_2, Type.atom("false")),
											(context) =>
												Erlang["=:=/2"](context.vars.x_2, Type.atom("nil")),
											context,
										),
								],
								body: (context) => {
									return context.vars.request_navigation_1;
								},
							},
							{
								match: Type.variablePattern("x_3"),
								guards: [],
								body: (context) => {
									return context.vars.x_3;
								},
							},
						],
						context,
					);
				},
			},
		],
	);

	Interpreter.defineElixirFunction(
		"LeaplyWeb.Hologram.Components.ApplicationMenu",
		"template",
		0,
		"public",
		[
			{
				params: (context) => [],
				guards: [],
				body: (context) => {
					globalThis.hologram.return = Type.anonymousFunction(
						1,
						[
							{
								params: (context) => [Type.variablePattern("vars_0")],
								guards: [],
								body: (context) => {
									Interpreter.matchOperator(
										context.vars.vars_0,
										Type.matchPlaceholder(),
										context,
									);
									Interpreter.updateVarsToMatchedValues(context);
									return Type.list([
										Interpreter.case(
											Elixir_LeaplyWeb_Hologram_Components_ApplicationMenu[
												"projection/2"
											](
												Interpreter.dotOperator(
													context.vars.vars_0,
													Type.atom("navigation"),
												),
												Interpreter.dotOperator(
													context.vars.vars_0,
													Type.atom("request_navigation"),
												),
											),
											[
												{
													match: Type.variablePattern("x_1"),
													guards: [
														(context) =>
															Erlang["orelse/2"](
																(context) =>
																	Erlang["=:=/2"](
																		context.vars.x_1,
																		Type.atom("false"),
																	),
																(context) =>
																	Erlang["=:=/2"](
																		context.vars.x_1,
																		Type.atom("nil"),
																	),
																context,
															),
													],
													body: (context) => {
														return Type.atom("nil");
													},
												},
												{
													match: Type.matchPlaceholder(),
													guards: [],
													body: (context) => {
														return Type.list([
															Type.tuple([
																Type.atom("text"),
																Type.bitstring("\n  "),
															]),
															Type.tuple([
																Type.atom("element"),
																Type.bitstring("details"),
																Type.list([
																	Type.tuple([
																		Type.bitstring("class"),
																		Type.list([
																			Type.tuple([
																				Type.atom("text"),
																				Type.bitstring(
																					"dropdown dropdown-end relative shrink-0 text-base-content",
																				),
																			]),
																		]),
																	]),
																	Type.tuple([
																		Type.bitstring("id"),
																		Type.list([
																			Type.tuple([
																				Type.atom("expression"),
																				Type.tuple([
																					Interpreter.dotOperator(
																						context.vars.vars_0,
																						Type.atom("id_prefix"),
																					),
																				]),
																			]),
																		]),
																	]),
																	Type.tuple([
																		Type.bitstring("data-profile-menu"),
																		Type.list([]),
																	]),
																]),
																Type.list([
																	Type.tuple([
																		Type.atom("text"),
																		Type.bitstring("\n    "),
																	]),
																	Type.tuple([
																		Type.atom("element"),
																		Type.bitstring("summary"),
																		Type.list([
																			Type.tuple([
																				Type.bitstring("class"),
																				Type.list([
																					Type.tuple([
																						Type.atom("text"),
																						Type.bitstring(
																							"btn btn-ghost min-h-11 max-w-60 gap-2 px-2",
																						),
																					]),
																				]),
																			]),
																			Type.tuple([
																				Type.bitstring("aria-label"),
																				Type.list([
																					Type.tuple([
																						Type.atom("expression"),
																						Type.tuple([
																							Elixir_LeaplyWeb_Hologram_Components_ApplicationMenu[
																								"text/1"
																							](Type.bitstring("menu")),
																						]),
																					]),
																				]),
																			]),
																			Type.tuple([
																				Type.bitstring("aria-controls"),
																				Type.list([
																					Type.tuple([
																						Type.atom("expression"),
																						Type.tuple([
																							Type.bitstring([
																								Type.bitstringSegment(
																									Interpreter.dotOperator(
																										context.vars.vars_0,
																										Type.atom("id_prefix"),
																									),
																									{ type: "binary" },
																								),
																								Type.bitstringSegment(
																									Type.string("-panel"),
																									{ type: "binary" },
																								),
																							]),
																						]),
																					]),
																				]),
																			]),
																			Type.tuple([
																				Type.bitstring("aria-haspopup"),
																				Type.list([
																					Type.tuple([
																						Type.atom("text"),
																						Type.bitstring("true"),
																					]),
																				]),
																			]),
																			Type.tuple([
																				Type.bitstring("id"),
																				Type.list([
																					Type.tuple([
																						Type.atom("expression"),
																						Type.tuple([
																							Type.bitstring([
																								Type.bitstringSegment(
																									Interpreter.dotOperator(
																										context.vars.vars_0,
																										Type.atom("id_prefix"),
																									),
																									{ type: "binary" },
																								),
																								Type.bitstringSegment(
																									Type.string("-trigger"),
																									{ type: "binary" },
																								),
																							]),
																						]),
																					]),
																				]),
																			]),
																			Type.tuple([
																				Type.bitstring(
																					"data-profile-menu-trigger",
																				),
																				Type.list([]),
																			]),
																		]),
																		Type.list([
																			Type.tuple([
																				Type.atom("text"),
																				Type.bitstring("\n      "),
																			]),
																			Type.tuple([
																				Type.atom("element"),
																				Type.bitstring("span"),
																				Type.list([
																					Type.tuple([
																						Type.bitstring("class"),
																						Type.list([
																							Type.tuple([
																								Type.atom("text"),
																								Type.bitstring(
																									"flex h-8 w-8 shrink-0 items-center justify-center rounded-full bg-base-300 font-semibold",
																								),
																							]),
																						]),
																					]),
																					Type.tuple([
																						Type.bitstring("aria-hidden"),
																						Type.list([
																							Type.tuple([
																								Type.atom("text"),
																								Type.bitstring("true"),
																							]),
																						]),
																					]),
																				]),
																				Type.list([
																					Type.tuple([
																						Type.atom("expression"),
																						Type.tuple([
																							Elixir_LeaplyWeb_Hologram_Components_ApplicationMenu[
																								"initial/1"
																							](
																								Interpreter.dotOperator(
																									Elixir_LeaplyWeb_Hologram_Components_ApplicationMenu[
																										"projection/2"
																									](
																										Interpreter.dotOperator(
																											context.vars.vars_0,
																											Type.atom("navigation"),
																										),
																										Interpreter.dotOperator(
																											context.vars.vars_0,
																											Type.atom(
																												"request_navigation",
																											),
																										),
																									),
																									Type.atom("display_name"),
																								),
																							),
																						]),
																					]),
																				]),
																			]),
																			Type.tuple([
																				Type.atom("text"),
																				Type.bitstring("\n      "),
																			]),
																			Type.tuple([
																				Type.atom("element"),
																				Type.bitstring("span"),
																				Type.list([
																					Type.tuple([
																						Type.bitstring("class"),
																						Type.list([
																							Type.tuple([
																								Type.atom("expression"),
																								Type.tuple([
																									Type.bitstring([
																										Type.bitstringSegment(
																											Type.string(
																												"hidden max-w-36 truncate ",
																											),
																											{ type: "binary" },
																										),
																										Type.bitstringSegment(
																											Elixir_LeaplyWeb_Hologram_Components_ApplicationMenu[
																												"name_visibility/1"
																											](
																												Interpreter.dotOperator(
																													context.vars.vars_0,
																													Type.atom("preview"),
																												),
																											),
																											{ type: "binary" },
																										),
																									]),
																								]),
																							]),
																						]),
																					]),
																				]),
																				Type.list([
																					Type.tuple([
																						Type.atom("expression"),
																						Type.tuple([
																							Interpreter.dotOperator(
																								Elixir_LeaplyWeb_Hologram_Components_ApplicationMenu[
																									"projection/2"
																								](
																									Interpreter.dotOperator(
																										context.vars.vars_0,
																										Type.atom("navigation"),
																									),
																									Interpreter.dotOperator(
																										context.vars.vars_0,
																										Type.atom(
																											"request_navigation",
																										),
																									),
																								),
																								Type.atom("display_name"),
																							),
																						]),
																					]),
																				]),
																			]),
																			Type.tuple([
																				Type.atom("text"),
																				Type.bitstring("\n      "),
																			]),
																			Type.tuple([
																				Type.atom("element"),
																				Type.bitstring("span"),
																				Type.list([
																					Type.tuple([
																						Type.bitstring("class"),
																						Type.list([
																							Type.tuple([
																								Type.atom("text"),
																								Type.bitstring(
																									"hero-chevron-down h-4 w-4 shrink-0",
																								),
																							]),
																						]),
																					]),
																					Type.tuple([
																						Type.bitstring("aria-hidden"),
																						Type.list([
																							Type.tuple([
																								Type.atom("text"),
																								Type.bitstring("true"),
																							]),
																						]),
																					]),
																				]),
																				Type.list([]),
																			]),
																			Type.tuple([
																				Type.atom("text"),
																				Type.bitstring("\n    "),
																			]),
																		]),
																	]),
																	Type.tuple([
																		Type.atom("text"),
																		Type.bitstring("\n    "),
																	]),
																	Type.tuple([
																		Type.atom("element"),
																		Type.bitstring("div"),
																		Type.list([
																			Type.tuple([
																				Type.bitstring("class"),
																				Type.list([
																					Type.tuple([
																						Type.atom("text"),
																						Type.bitstring(
																							"dropdown-content absolute right-0 z-50 mt-2 max-h-[min(36rem,calc(var(--admin-workspace-height,100dvh)-var(--application-header-height)-2rem),var(--application-menu-height,calc(100dvh-14rem)))] w-[min(20rem,calc(100vw-2rem))] overflow-y-auto overscroll-contain rounded-lg border border-base-300 bg-base-100 p-2 shadow-lg",
																						),
																					]),
																				]),
																			]),
																			Type.tuple([
																				Type.bitstring("id"),
																				Type.list([
																					Type.tuple([
																						Type.atom("expression"),
																						Type.tuple([
																							Type.bitstring([
																								Type.bitstringSegment(
																									Interpreter.dotOperator(
																										context.vars.vars_0,
																										Type.atom("id_prefix"),
																									),
																									{ type: "binary" },
																								),
																								Type.bitstringSegment(
																									Type.string("-panel"),
																									{ type: "binary" },
																								),
																							]),
																						]),
																					]),
																				]),
																			]),
																			Type.tuple([
																				Type.bitstring(
																					"data-profile-menu-panel",
																				),
																				Type.list([]),
																			]),
																		]),
																		Type.list([
																			Type.tuple([
																				Type.atom("text"),
																				Type.bitstring("\n      "),
																			]),
																			Type.tuple([
																				Type.atom("element"),
																				Type.bitstring("p"),
																				Type.list([
																					Type.tuple([
																						Type.bitstring("class"),
																						Type.list([
																							Type.tuple([
																								Type.atom("text"),
																								Type.bitstring(
																									"break-words px-3 py-2 text-sm font-semibold",
																								),
																							]),
																						]),
																					]),
																					Type.tuple([
																						Type.bitstring(
																							"data-navigation-identity",
																						),
																						Type.list([]),
																					]),
																				]),
																				Type.list([
																					Type.tuple([
																						Type.atom("expression"),
																						Type.tuple([
																							Interpreter.dotOperator(
																								Elixir_LeaplyWeb_Hologram_Components_ApplicationMenu[
																									"projection/2"
																								](
																									Interpreter.dotOperator(
																										context.vars.vars_0,
																										Type.atom("navigation"),
																									),
																									Interpreter.dotOperator(
																										context.vars.vars_0,
																										Type.atom(
																											"request_navigation",
																										),
																									),
																								),
																								Type.atom("display_name"),
																							),
																						]),
																					]),
																				]),
																			]),
																			Type.tuple([
																				Type.atom("text"),
																				Type.bitstring("\n      "),
																			]),
																			Type.tuple([
																				Type.atom("element"),
																				Type.bitstring("nav"),
																				Type.list([
																					Type.tuple([
																						Type.bitstring("aria-label"),
																						Type.list([
																							Type.tuple([
																								Type.atom("expression"),
																								Type.tuple([
																									Elixir_LeaplyWeb_Hologram_Components_ApplicationMenu[
																										"text/1"
																									](Type.bitstring("menu")),
																								]),
																							]),
																						]),
																					]),
																				]),
																				Type.list([
																					Type.tuple([
																						Type.atom("text"),
																						Type.bitstring("\n        "),
																					]),
																					Interpreter.comprehension(
																						[
																							{
																								match:
																									Type.variablePattern(
																										"group_2",
																									),
																								guards: [],
																								body: (context) =>
																									Interpreter.dotOperator(
																										Elixir_LeaplyWeb_Hologram_Components_ApplicationMenu[
																											"projection/2"
																										](
																											Interpreter.dotOperator(
																												context.vars.vars_0,
																												Type.atom("navigation"),
																											),
																											Interpreter.dotOperator(
																												context.vars.vars_0,
																												Type.atom(
																													"request_navigation",
																												),
																											),
																										),
																										Type.atom("groups"),
																									),
																							},
																						],
																						[],
																						Type.list([]),
																						false,
																						(context) => {
																							return Type.list([
																								Type.tuple([
																									Type.atom("text"),
																									Type.bitstring(
																										"\n          ",
																									),
																								]),
																								Type.tuple([
																									Type.atom("element"),
																									Type.bitstring("ul"),
																									Type.list([
																										Type.tuple([
																											Type.bitstring("class"),
																											Type.list([
																												Type.tuple([
																													Type.atom("text"),
																													Type.bitstring(
																														"menu w-full p-0 text-sm",
																													),
																												]),
																											]),
																										]),
																										Type.tuple([
																											Type.bitstring(
																												"aria-label",
																											),
																											Type.list([
																												Type.tuple([
																													Type.atom(
																														"expression",
																													),
																													Type.tuple([
																														Interpreter.dotOperator(
																															context.vars
																																.group_2,
																															Type.atom(
																																"label",
																															),
																														),
																													]),
																												]),
																											]),
																										]),
																									]),
																									Type.list([
																										Type.tuple([
																											Type.atom("text"),
																											Type.bitstring(
																												"\n            ",
																											),
																										]),
																										Type.tuple([
																											Type.atom("element"),
																											Type.bitstring("li"),
																											Type.list([
																												Type.tuple([
																													Type.bitstring(
																														"class",
																													),
																													Type.list([
																														Type.tuple([
																															Type.atom("text"),
																															Type.bitstring(
																																"menu-title text-base-content/75",
																															),
																														]),
																													]),
																												]),
																											]),
																											Type.list([
																												Type.tuple([
																													Type.atom(
																														"expression",
																													),
																													Type.tuple([
																														Interpreter.dotOperator(
																															context.vars
																																.group_2,
																															Type.atom(
																																"label",
																															),
																														),
																													]),
																												]),
																											]),
																										]),
																										Type.tuple([
																											Type.atom("text"),
																											Type.bitstring(
																												"\n            ",
																											),
																										]),
																										Interpreter.comprehension(
																											[
																												{
																													match:
																														Type.variablePattern(
																															"entry_3",
																														),
																													guards: [],
																													body: (context) =>
																														Interpreter.dotOperator(
																															context.vars
																																.group_2,
																															Type.atom(
																																"entries",
																															),
																														),
																												},
																											],
																											[],
																											Type.list([]),
																											false,
																											(context) => {
																												return Type.list([
																													Type.tuple([
																														Type.atom("text"),
																														Type.bitstring(
																															"\n              ",
																														),
																													]),
																													Type.tuple([
																														Type.atom(
																															"element",
																														),
																														Type.bitstring(
																															"li",
																														),
																														Type.list([]),
																														Type.list([
																															Type.tuple([
																																Type.atom(
																																	"element",
																																),
																																Type.bitstring(
																																	"a",
																																),
																																Type.list([
																																	Type.tuple([
																																		Type.bitstring(
																																			"href",
																																		),
																																		Type.list([
																																			Type.tuple(
																																				[
																																					Type.atom(
																																						"expression",
																																					),
																																					Type.tuple(
																																						[
																																							Elixir_LeaplyWeb_Hologram_Components_ApplicationMenu[
																																								"link_path/4"
																																							](
																																								context
																																									.vars
																																									.entry_3,
																																								Interpreter.dotOperator(
																																									context
																																										.vars
																																										.vars_0,
																																									Type.atom(
																																										"professional_url",
																																									),
																																								),
																																								Interpreter.dotOperator(
																																									context
																																										.vars
																																										.vars_0,
																																									Type.atom(
																																										"account_url",
																																									),
																																								),
																																								Interpreter.dotOperator(
																																									context
																																										.vars
																																										.vars_0,
																																									Type.atom(
																																										"preview",
																																									),
																																								),
																																							),
																																						],
																																					),
																																				],
																																			),
																																		]),
																																	]),
																																	Type.tuple([
																																		Type.bitstring(
																																			"class",
																																		),
																																		Type.list([
																																			Type.tuple(
																																				[
																																					Type.atom(
																																						"expression",
																																					),
																																					Type.tuple(
																																						[
																																							Elixir_LeaplyWeb_Hologram_Components_ApplicationMenu[
																																								"link_class/1"
																																							](
																																								Interpreter.dotOperator(
																																									context
																																										.vars
																																										.entry_3,
																																									Type.atom(
																																										"current",
																																									),
																																								),
																																							),
																																						],
																																					),
																																				],
																																			),
																																		]),
																																	]),
																																	Type.tuple([
																																		Type.bitstring(
																																			"aria-current",
																																		),
																																		Type.list([
																																			Type.tuple(
																																				[
																																					Type.atom(
																																						"expression",
																																					),
																																					Type.tuple(
																																						[
																																							Elixir_LeaplyWeb_Hologram_Components_ApplicationMenu[
																																								"aria_current/1"
																																							](
																																								Interpreter.dotOperator(
																																									context
																																										.vars
																																										.entry_3,
																																									Type.atom(
																																										"current",
																																									),
																																								),
																																							),
																																						],
																																					),
																																				],
																																			),
																																		]),
																																	]),
																																	Type.tuple([
																																		Type.bitstring(
																																			"id",
																																		),
																																		Type.list([
																																			Type.tuple(
																																				[
																																					Type.atom(
																																						"expression",
																																					),
																																					Type.tuple(
																																						[
																																							Type.bitstring(
																																								[
																																									Type.bitstringSegment(
																																										Interpreter.dotOperator(
																																											context
																																												.vars
																																												.vars_0,
																																											Type.atom(
																																												"id_prefix",
																																											),
																																										),
																																										{
																																											type: "binary",
																																										},
																																									),
																																									Type.bitstringSegment(
																																										Type.string(
																																											"-",
																																										),
																																										{
																																											type: "binary",
																																										},
																																									),
																																									Type.bitstringSegment(
																																										Interpreter.dotOperator(
																																											context
																																												.vars
																																												.entry_3,
																																											Type.atom(
																																												"id",
																																											),
																																										),
																																										{
																																											type: "binary",
																																										},
																																									),
																																									Type.bitstringSegment(
																																										Type.string(
																																											"-link",
																																										),
																																										{
																																											type: "binary",
																																										},
																																									),
																																								],
																																							),
																																						],
																																					),
																																				],
																																			),
																																		]),
																																	]),
																																]),
																																Type.list([
																																	Type.tuple([
																																		Type.atom(
																																			"element",
																																		),
																																		Type.bitstring(
																																			"span",
																																		),
																																		Type.list([
																																			Type.tuple(
																																				[
																																					Type.bitstring(
																																						"class",
																																					),
																																					Type.list(
																																						[
																																							Type.tuple(
																																								[
																																									Type.atom(
																																										"expression",
																																									),
																																									Type.tuple(
																																										[
																																											Type.bitstring(
																																												[
																																													Type.bitstringSegment(
																																														Elixir_LeaplyWeb_Hologram_Components_ApplicationMenu[
																																															"icon/1"
																																														](
																																															Interpreter.dotOperator(
																																																context
																																																	.vars
																																																	.entry_3,
																																																Type.atom(
																																																	"id",
																																																),
																																															),
																																														),
																																														{
																																															type: "binary",
																																														},
																																													),
																																													Type.bitstringSegment(
																																														Type.string(
																																															" h-5 w-5 shrink-0",
																																														),
																																														{
																																															type: "binary",
																																														},
																																													),
																																												],
																																											),
																																										],
																																									),
																																								],
																																							),
																																						],
																																					),
																																				],
																																			),
																																			Type.tuple(
																																				[
																																					Type.bitstring(
																																						"aria-hidden",
																																					),
																																					Type.list(
																																						[
																																							Type.tuple(
																																								[
																																									Type.atom(
																																										"text",
																																									),
																																									Type.bitstring(
																																										"true",
																																									),
																																								],
																																							),
																																						],
																																					),
																																				],
																																			),
																																		]),
																																		Type.list(
																																			[],
																																		),
																																	]),
																																	Type.tuple([
																																		Type.atom(
																																			"element",
																																		),
																																		Type.bitstring(
																																			"span",
																																		),
																																		Type.list([
																																			Type.tuple(
																																				[
																																					Type.bitstring(
																																						"class",
																																					),
																																					Type.list(
																																						[
																																							Type.tuple(
																																								[
																																									Type.atom(
																																										"text",
																																									),
																																									Type.bitstring(
																																										"min-w-0",
																																									),
																																								],
																																							),
																																						],
																																					),
																																				],
																																			),
																																		]),
																																		Type.list([
																																			Type.tuple(
																																				[
																																					Type.atom(
																																						"expression",
																																					),
																																					Type.tuple(
																																						[
																																							Interpreter.dotOperator(
																																								context
																																									.vars
																																									.entry_3,
																																								Type.atom(
																																									"label",
																																								),
																																							),
																																						],
																																					),
																																				],
																																			),
																																		]),
																																	]),
																																]),
																															]),
																														]),
																													]),
																													Type.tuple([
																														Type.atom("text"),
																														Type.bitstring(
																															"\n            ",
																														),
																													]),
																												]);
																											},
																											context,
																										),
																										Type.tuple([
																											Type.atom("text"),
																											Type.bitstring(
																												"\n          ",
																											),
																										]),
																									]),
																								]),
																								Type.tuple([
																									Type.atom("text"),
																									Type.bitstring("\n        "),
																								]),
																							]);
																						},
																						context,
																					),
																					Type.tuple([
																						Type.atom("text"),
																						Type.bitstring("\n      "),
																					]),
																				]),
																			]),
																			Type.tuple([
																				Type.atom("text"),
																				Type.bitstring("\n      "),
																			]),
																			Interpreter.case(
																				Interpreter.case(
																					Interpreter.dotOperator(
																						context.vars.vars_0,
																						Type.atom("preview"),
																					),
																					[
																						{
																							match:
																								Type.variablePattern("x_4"),
																							guards: [
																								(context) =>
																									Erlang["orelse/2"](
																										(context) =>
																											Erlang["=:=/2"](
																												context.vars.x_4,
																												Type.atom("false"),
																											),
																										(context) =>
																											Erlang["=:=/2"](
																												context.vars.x_4,
																												Type.atom("nil"),
																											),
																										context,
																									),
																							],
																							body: (context) => {
																								return Type.atom("true");
																							},
																						},
																						{
																							match: Type.matchPlaceholder(),
																							guards: [],
																							body: (context) => {
																								return Type.atom("false");
																							},
																						},
																					],
																					context,
																				),
																				[
																					{
																						match: Type.atom("false"),
																						guards: [],
																						body: (context) => {
																							return Type.atom("nil");
																						},
																					},
																					{
																						match: Type.atom("true"),
																						guards: [],
																						body: (context) => {
																							return Type.list([
																								Type.tuple([
																									Type.atom("text"),
																									Type.bitstring("\n        "),
																								]),
																								Type.tuple([
																									Type.atom("element"),
																									Type.bitstring("form"),
																									Type.list([
																										Type.tuple([
																											Type.bitstring("action"),
																											Type.list([
																												Type.tuple([
																													Type.atom("text"),
																													Type.bitstring(
																														"/logout",
																													),
																												]),
																											]),
																										]),
																										Type.tuple([
																											Type.bitstring("method"),
																											Type.list([
																												Type.tuple([
																													Type.atom("text"),
																													Type.bitstring(
																														"post",
																													),
																												]),
																											]),
																										]),
																										Type.tuple([
																											Type.bitstring("class"),
																											Type.list([
																												Type.tuple([
																													Type.atom("text"),
																													Type.bitstring(
																														"mt-2 border-t border-base-300 pt-2",
																													),
																												]),
																											]),
																										]),
																										Type.tuple([
																											Type.bitstring("id"),
																											Type.list([
																												Type.tuple([
																													Type.atom(
																														"expression",
																													),
																													Type.tuple([
																														Type.bitstring([
																															Type.bitstringSegment(
																																Interpreter.dotOperator(
																																	context.vars
																																		.vars_0,
																																	Type.atom(
																																		"id_prefix",
																																	),
																																),
																																{
																																	type: "binary",
																																},
																															),
																															Type.bitstringSegment(
																																Type.string(
																																	"-logout-form",
																																),
																																{
																																	type: "binary",
																																},
																															),
																														]),
																													]),
																												]),
																											]),
																										]),
																									]),
																									Type.list([
																										Type.tuple([
																											Type.atom("text"),
																											Type.bitstring(
																												"\n          ",
																											),
																										]),
																										Type.tuple([
																											Type.atom("element"),
																											Type.bitstring("input"),
																											Type.list([
																												Type.tuple([
																													Type.bitstring(
																														"type",
																													),
																													Type.list([
																														Type.tuple([
																															Type.atom("text"),
																															Type.bitstring(
																																"hidden",
																															),
																														]),
																													]),
																												]),
																												Type.tuple([
																													Type.bitstring(
																														"name",
																													),
																													Type.list([
																														Type.tuple([
																															Type.atom("text"),
																															Type.bitstring(
																																"_csrf_token",
																															),
																														]),
																													]),
																												]),
																												Type.tuple([
																													Type.bitstring(
																														"value",
																													),
																													Type.list([
																														Type.tuple([
																															Type.atom(
																																"expression",
																															),
																															Type.tuple([
																																Interpreter.dotOperator(
																																	Elixir_LeaplyWeb_Hologram_Components_ApplicationMenu[
																																		"projection/2"
																																	](
																																		Interpreter.dotOperator(
																																			context
																																				.vars
																																				.vars_0,
																																			Type.atom(
																																				"navigation",
																																			),
																																		),
																																		Interpreter.dotOperator(
																																			context
																																				.vars
																																				.vars_0,
																																			Type.atom(
																																				"request_navigation",
																																			),
																																		),
																																	),
																																	Type.atom(
																																		"csrf_token",
																																	),
																																),
																															]),
																														]),
																													]),
																												]),
																											]),
																											Type.list([]),
																										]),
																										Type.tuple([
																											Type.atom("text"),
																											Type.bitstring(
																												"\n          ",
																											),
																										]),
																										Type.tuple([
																											Type.atom("element"),
																											Type.bitstring("button"),
																											Type.list([
																												Type.tuple([
																													Type.bitstring(
																														"type",
																													),
																													Type.list([
																														Type.tuple([
																															Type.atom("text"),
																															Type.bitstring(
																																"submit",
																															),
																														]),
																													]),
																												]),
																												Type.tuple([
																													Type.bitstring(
																														"class",
																													),
																													Type.list([
																														Type.tuple([
																															Type.atom("text"),
																															Type.bitstring(
																																"btn btn-ghost min-h-11 w-full justify-start",
																															),
																														]),
																													]),
																												]),
																												Type.tuple([
																													Type.bitstring("id"),
																													Type.list([
																														Type.tuple([
																															Type.atom(
																																"expression",
																															),
																															Type.tuple([
																																Type.bitstring([
																																	Type.bitstringSegment(
																																		Interpreter.dotOperator(
																																			context
																																				.vars
																																				.vars_0,
																																			Type.atom(
																																				"id_prefix",
																																			),
																																		),
																																		{
																																			type: "binary",
																																		},
																																	),
																																	Type.bitstringSegment(
																																		Type.string(
																																			"-logout-button",
																																		),
																																		{
																																			type: "binary",
																																		},
																																	),
																																]),
																															]),
																														]),
																													]),
																												]),
																											]),
																											Type.list([
																												Type.tuple([
																													Type.atom("element"),
																													Type.bitstring(
																														"span",
																													),
																													Type.list([
																														Type.tuple([
																															Type.bitstring(
																																"class",
																															),
																															Type.list([
																																Type.tuple([
																																	Type.atom(
																																		"text",
																																	),
																																	Type.bitstring(
																																		"hero-arrow-right-start-on-rectangle h-5 w-5",
																																	),
																																]),
																															]),
																														]),
																														Type.tuple([
																															Type.bitstring(
																																"aria-hidden",
																															),
																															Type.list([
																																Type.tuple([
																																	Type.atom(
																																		"text",
																																	),
																																	Type.bitstring(
																																		"true",
																																	),
																																]),
																															]),
																														]),
																													]),
																													Type.list([]),
																												]),
																												Type.tuple([
																													Type.atom(
																														"expression",
																													),
																													Type.tuple([
																														Elixir_LeaplyWeb_Hologram_Components_ApplicationMenu[
																															"text/1"
																														](
																															Type.bitstring(
																																"logout",
																															),
																														),
																													]),
																												]),
																											]),
																										]),
																										Type.tuple([
																											Type.atom("text"),
																											Type.bitstring(
																												"\n        ",
																											),
																										]),
																									]),
																								]),
																								Type.tuple([
																									Type.atom("text"),
																									Type.bitstring("\n      "),
																								]),
																							]);
																						},
																					},
																				],
																				context,
																			),
																			Type.tuple([
																				Type.atom("text"),
																				Type.bitstring("\n    "),
																			]),
																		]),
																	]),
																	Type.tuple([
																		Type.atom("text"),
																		Type.bitstring("\n  "),
																	]),
																]),
															]),
															Type.tuple([
																Type.atom("text"),
																Type.bitstring("\n"),
															]),
														]);
													},
												},
											],
											context,
										),
									]);
								},
							},
						],
						context,
					);
					Interpreter.updateVarsToMatchedValues(context);
					return globalThis.hologram.return;
				},
			},
		],
	);

	Interpreter.defineElixirFunction(
		"LeaplyWeb.Hologram.Components.ApplicationMenu",
		"text",
		1,
		"public",
		[
			{
				params: (context) => [Type.variablePattern("key_0")],
				guards: [],
				body: (context) => {
					return Elixir_LeaplyWeb_Hologram_Helpers_CatalogText["get/2"](
						Type.bitstring("shared"),
						Type.bitstring([
							Type.bitstringSegment(Type.string("shared.navigation."), {
								type: "binary",
							}),
							Type.bitstringSegment(
								Elixir_String_Chars["to_string/1"](context.vars.key_0),
								{ type: "binary" },
							),
						]),
					);
				},
			},
		],
	);

	Interpreter.defineElixirFunction(
		"LeaplyWeb.Hologram.Components.Head.StructuredData",
		"__props__",
		0,
		"public",
		[
			{
				params: (context) => [],
				guards: [],
				body: (context) => {
					return Elixir_Enum["reverse/1"](
						Type.list([
							Type.tuple([
								Type.atom("json"),
								Type.atom("string"),
								Type.list([]),
							]),
						]),
					);
				},
			},
		],
	);

	Interpreter.defineElixirFunction(
		"LeaplyWeb.Hologram.Components.Head.StructuredData",
		"template",
		0,
		"public",
		[
			{
				params: (context) => [],
				guards: [],
				body: (context) => {
					return Type.anonymousFunction(
						1,
						[
							{
								params: (context) => [
									Type.map([
										[Type.atom("json"), Type.variablePattern("json_0")],
									]),
								],
								guards: [],
								body: (context) => {
									return Type.list([
										Type.tuple([
											Type.atom("element"),
											Type.bitstring("script"),
											Type.list([
												Type.tuple([
													Type.bitstring("type"),
													Type.list([
														Type.tuple([
															Type.atom("text"),
															Type.bitstring("application/ld+json"),
														]),
													]),
												]),
											]),
											Type.list([
												Type.tuple([Type.atom("text"), context.vars.json_0]),
											]),
										]),
									]);
								},
							},
						],
						context,
					);
				},
			},
		],
	);

	Interpreter.defineElixirFunction(
		"LeaplyWeb.Hologram.Components.Listings.ListingBody",
		"__props__",
		0,
		"public",
		[
			{
				params: (context) => [],
				guards: [],
				body: (context) => {
					return Elixir_Enum["reverse/1"](
						Type.list([
							Type.tuple([
								Type.atom("blocks"),
								Type.atom("list"),
								Type.list([Type.tuple([Type.atom("default"), Type.list([])])]),
							]),
						]),
					);
				},
			},
		],
	);

	Interpreter.defineElixirFunction(
		"LeaplyWeb.Hologram.Components.Listings.ListingBody",
		"template",
		0,
		"public",
		[
			{
				params: (context) => [],
				guards: [],
				body: (context) => {
					globalThis.hologram.return = Type.anonymousFunction(
						1,
						[
							{
								params: (context) => [Type.variablePattern("vars_0")],
								guards: [],
								body: (context) => {
									Interpreter.matchOperator(
										context.vars.vars_0,
										Type.matchPlaceholder(),
										context,
									);
									Interpreter.updateVarsToMatchedValues(context);
									return Type.list([
										Type.tuple([
											Type.atom("element"),
											Type.bitstring("div"),
											Type.list([
												Type.tuple([
													Type.bitstring("class"),
													Type.list([
														Type.tuple([
															Type.atom("text"),
															Type.bitstring(
																"space-y-6 text-base leading-8 text-app-muted",
															),
														]),
													]),
												]),
												Type.tuple([
													Type.bitstring("id"),
													Type.list([
														Type.tuple([
															Type.atom("text"),
															Type.bitstring("listing-body"),
														]),
													]),
												]),
											]),
											Type.list([
												Type.tuple([Type.atom("text"), Type.bitstring("\n  ")]),
												Interpreter.comprehension(
													[
														{
															match: Type.variablePattern("block_1"),
															guards: [],
															body: (context) =>
																Interpreter.dotOperator(
																	context.vars.vars_0,
																	Type.atom("blocks"),
																),
														},
													],
													[],
													Type.list([]),
													false,
													(context) => {
														return Type.list([
															Type.tuple([
																Type.atom("text"),
																Type.bitstring("\n    "),
															]),
															Interpreter.case(
																Erlang["==/2"](
																	Interpreter.dotOperator(
																		context.vars.block_1,
																		Type.atom("type"),
																	),
																	Type.atom("paragraph"),
																),
																[
																	{
																		match: Type.atom("false"),
																		guards: [],
																		body: (context) => {
																			return Type.atom("nil");
																		},
																	},
																	{
																		match: Type.atom("true"),
																		guards: [],
																		body: (context) => {
																			return Type.list([
																				Type.tuple([
																					Type.atom("text"),
																					Type.bitstring("\n      "),
																				]),
																				Type.tuple([
																					Type.atom("element"),
																					Type.bitstring("p"),
																					Type.list([
																						Type.tuple([
																							Type.bitstring("class"),
																							Type.list([
																								Type.tuple([
																									Type.atom("text"),
																									Type.bitstring(
																										"whitespace-pre-line",
																									),
																								]),
																							]),
																						]),
																					]),
																					Type.list([
																						Type.tuple([
																							Type.atom("expression"),
																							Type.tuple([
																								Interpreter.dotOperator(
																									context.vars.block_1,
																									Type.atom("text"),
																								),
																							]),
																						]),
																					]),
																				]),
																				Type.tuple([
																					Type.atom("text"),
																					Type.bitstring("\n    "),
																				]),
																			]);
																		},
																	},
																],
																context,
															),
															Type.tuple([
																Type.atom("text"),
																Type.bitstring("\n\n    "),
															]),
															Interpreter.case(
																Interpreter.case(
																	Erlang["==/2"](
																		Interpreter.dotOperator(
																			context.vars.block_1,
																			Type.atom("type"),
																		),
																		Type.atom("heading"),
																	),
																	[
																		{
																			match: Type.variablePattern("x_2"),
																			guards: [
																				(context) =>
																					Erlang["orelse/2"](
																						(context) =>
																							Erlang["=:=/2"](
																								context.vars.x_2,
																								Type.atom("false"),
																							),
																						(context) =>
																							Erlang["=:=/2"](
																								context.vars.x_2,
																								Type.atom("nil"),
																							),
																						context,
																					),
																			],
																			body: (context) => {
																				return context.vars.x_2;
																			},
																		},
																		{
																			match: Type.matchPlaceholder(),
																			guards: [],
																			body: (context) => {
																				return Erlang["==/2"](
																					Interpreter.dotOperator(
																						context.vars.block_1,
																						Type.atom("level"),
																					),
																					Type.integer(2n),
																				);
																			},
																		},
																	],
																	context,
																),
																[
																	{
																		match: Type.variablePattern("x_3"),
																		guards: [
																			(context) =>
																				Erlang["orelse/2"](
																					(context) =>
																						Erlang["=:=/2"](
																							context.vars.x_3,
																							Type.atom("false"),
																						),
																					(context) =>
																						Erlang["=:=/2"](
																							context.vars.x_3,
																							Type.atom("nil"),
																						),
																					context,
																				),
																		],
																		body: (context) => {
																			return Type.atom("nil");
																		},
																	},
																	{
																		match: Type.matchPlaceholder(),
																		guards: [],
																		body: (context) => {
																			return Type.list([
																				Type.tuple([
																					Type.atom("text"),
																					Type.bitstring("\n      "),
																				]),
																				Type.tuple([
																					Type.atom("element"),
																					Type.bitstring("h2"),
																					Type.list([
																						Type.tuple([
																							Type.bitstring("class"),
																							Type.list([
																								Type.tuple([
																									Type.atom("text"),
																									Type.bitstring(
																										"pt-3 text-2xl font-bold tracking-tight text-app-ink",
																									),
																								]),
																							]),
																						]),
																					]),
																					Type.list([
																						Type.tuple([
																							Type.atom("expression"),
																							Type.tuple([
																								Interpreter.dotOperator(
																									context.vars.block_1,
																									Type.atom("text"),
																								),
																							]),
																						]),
																					]),
																				]),
																				Type.tuple([
																					Type.atom("text"),
																					Type.bitstring("\n    "),
																				]),
																			]);
																		},
																	},
																],
																context,
															),
															Type.tuple([
																Type.atom("text"),
																Type.bitstring("\n\n    "),
															]),
															Interpreter.case(
																Interpreter.case(
																	Erlang["==/2"](
																		Interpreter.dotOperator(
																			context.vars.block_1,
																			Type.atom("type"),
																		),
																		Type.atom("heading"),
																	),
																	[
																		{
																			match: Type.variablePattern("x_4"),
																			guards: [
																				(context) =>
																					Erlang["orelse/2"](
																						(context) =>
																							Erlang["=:=/2"](
																								context.vars.x_4,
																								Type.atom("false"),
																							),
																						(context) =>
																							Erlang["=:=/2"](
																								context.vars.x_4,
																								Type.atom("nil"),
																							),
																						context,
																					),
																			],
																			body: (context) => {
																				return context.vars.x_4;
																			},
																		},
																		{
																			match: Type.matchPlaceholder(),
																			guards: [],
																			body: (context) => {
																				return Erlang["==/2"](
																					Interpreter.dotOperator(
																						context.vars.block_1,
																						Type.atom("level"),
																					),
																					Type.integer(3n),
																				);
																			},
																		},
																	],
																	context,
																),
																[
																	{
																		match: Type.variablePattern("x_5"),
																		guards: [
																			(context) =>
																				Erlang["orelse/2"](
																					(context) =>
																						Erlang["=:=/2"](
																							context.vars.x_5,
																							Type.atom("false"),
																						),
																					(context) =>
																						Erlang["=:=/2"](
																							context.vars.x_5,
																							Type.atom("nil"),
																						),
																					context,
																				),
																		],
																		body: (context) => {
																			return Type.atom("nil");
																		},
																	},
																	{
																		match: Type.matchPlaceholder(),
																		guards: [],
																		body: (context) => {
																			return Type.list([
																				Type.tuple([
																					Type.atom("text"),
																					Type.bitstring("\n      "),
																				]),
																				Type.tuple([
																					Type.atom("element"),
																					Type.bitstring("h3"),
																					Type.list([
																						Type.tuple([
																							Type.bitstring("class"),
																							Type.list([
																								Type.tuple([
																									Type.atom("text"),
																									Type.bitstring(
																										"pt-2 text-xl font-bold tracking-tight text-app-ink",
																									),
																								]),
																							]),
																						]),
																					]),
																					Type.list([
																						Type.tuple([
																							Type.atom("expression"),
																							Type.tuple([
																								Interpreter.dotOperator(
																									context.vars.block_1,
																									Type.atom("text"),
																								),
																							]),
																						]),
																					]),
																				]),
																				Type.tuple([
																					Type.atom("text"),
																					Type.bitstring("\n    "),
																				]),
																			]);
																		},
																	},
																],
																context,
															),
															Type.tuple([
																Type.atom("text"),
																Type.bitstring("\n\n    "),
															]),
															Interpreter.case(
																Erlang["==/2"](
																	Interpreter.dotOperator(
																		context.vars.block_1,
																		Type.atom("type"),
																	),
																	Type.atom("bullet_list"),
																),
																[
																	{
																		match: Type.atom("false"),
																		guards: [],
																		body: (context) => {
																			return Type.atom("nil");
																		},
																	},
																	{
																		match: Type.atom("true"),
																		guards: [],
																		body: (context) => {
																			return Type.list([
																				Type.tuple([
																					Type.atom("text"),
																					Type.bitstring("\n      "),
																				]),
																				Type.tuple([
																					Type.atom("element"),
																					Type.bitstring("div"),
																					Type.list([]),
																					Type.list([
																						Type.tuple([
																							Type.atom("text"),
																							Type.bitstring("\n        "),
																						]),
																						Interpreter.case(
																							Interpreter.dotOperator(
																								context.vars.block_1,
																								Type.atom("title"),
																							),
																							[
																								{
																									match:
																										Type.variablePattern("x_6"),
																									guards: [
																										(context) =>
																											Erlang["orelse/2"](
																												(context) =>
																													Erlang["=:=/2"](
																														context.vars.x_6,
																														Type.atom("false"),
																													),
																												(context) =>
																													Erlang["=:=/2"](
																														context.vars.x_6,
																														Type.atom("nil"),
																													),
																												context,
																											),
																									],
																									body: (context) => {
																										return Type.atom("nil");
																									},
																								},
																								{
																									match:
																										Type.matchPlaceholder(),
																									guards: [],
																									body: (context) => {
																										return Type.list([
																											Type.tuple([
																												Type.atom("text"),
																												Type.bitstring(
																													"\n          ",
																												),
																											]),
																											Type.tuple([
																												Type.atom("element"),
																												Type.bitstring("h3"),
																												Type.list([
																													Type.tuple([
																														Type.bitstring(
																															"class",
																														),
																														Type.list([
																															Type.tuple([
																																Type.atom(
																																	"text",
																																),
																																Type.bitstring(
																																	"mb-3 text-lg font-bold text-app-ink",
																																),
																															]),
																														]),
																													]),
																												]),
																												Type.list([
																													Type.tuple([
																														Type.atom(
																															"expression",
																														),
																														Type.tuple([
																															Interpreter.dotOperator(
																																context.vars
																																	.block_1,
																																Type.atom(
																																	"title",
																																),
																															),
																														]),
																													]),
																												]),
																											]),
																											Type.tuple([
																												Type.atom("text"),
																												Type.bitstring(
																													"\n        ",
																												),
																											]),
																										]);
																									},
																								},
																							],
																							context,
																						),
																						Type.tuple([
																							Type.atom("text"),
																							Type.bitstring("\n        "),
																						]),
																						Type.tuple([
																							Type.atom("element"),
																							Type.bitstring("ul"),
																							Type.list([
																								Type.tuple([
																									Type.bitstring("class"),
																									Type.list([
																										Type.tuple([
																											Type.atom("text"),
																											Type.bitstring(
																												"space-y-3",
																											),
																										]),
																									]),
																								]),
																								Type.tuple([
																									Type.bitstring("role"),
																									Type.list([
																										Type.tuple([
																											Type.atom("text"),
																											Type.bitstring("list"),
																										]),
																									]),
																								]),
																							]),
																							Type.list([
																								Type.tuple([
																									Type.atom("text"),
																									Type.bitstring(
																										"\n          ",
																									),
																								]),
																								Interpreter.comprehension(
																									[
																										{
																											match:
																												Type.variablePattern(
																													"item_7",
																												),
																											guards: [],
																											body: (context) =>
																												Interpreter.dotOperator(
																													context.vars.block_1,
																													Type.atom("items"),
																												),
																										},
																									],
																									[],
																									Type.list([]),
																									false,
																									(context) => {
																										return Type.list([
																											Type.tuple([
																												Type.atom("text"),
																												Type.bitstring(
																													"\n            ",
																												),
																											]),
																											Type.tuple([
																												Type.atom("element"),
																												Type.bitstring("li"),
																												Type.list([
																													Type.tuple([
																														Type.bitstring(
																															"class",
																														),
																														Type.list([
																															Type.tuple([
																																Type.atom(
																																	"text",
																																),
																																Type.bitstring(
																																	"flex gap-3",
																																),
																															]),
																														]),
																													]),
																												]),
																												Type.list([
																													Type.tuple([
																														Type.atom("text"),
																														Type.bitstring(
																															"\n              ",
																														),
																													]),
																													Type.tuple([
																														Type.atom(
																															"element",
																														),
																														Type.bitstring(
																															"span",
																														),
																														Type.list([
																															Type.tuple([
																																Type.bitstring(
																																	"class",
																																),
																																Type.list([
																																	Type.tuple([
																																		Type.atom(
																																			"text",
																																		),
																																		Type.bitstring(
																																			"mt-3 h-1.5 w-1.5 shrink-0 rounded-full bg-blue-500",
																																		),
																																	]),
																																]),
																															]),
																															Type.tuple([
																																Type.bitstring(
																																	"aria-hidden",
																																),
																																Type.list([
																																	Type.tuple([
																																		Type.atom(
																																			"text",
																																		),
																																		Type.bitstring(
																																			"true",
																																		),
																																	]),
																																]),
																															]),
																														]),
																														Type.list([]),
																													]),
																													Type.tuple([
																														Type.atom("text"),
																														Type.bitstring(
																															"\n              ",
																														),
																													]),
																													Type.tuple([
																														Type.atom(
																															"element",
																														),
																														Type.bitstring(
																															"span",
																														),
																														Type.list([]),
																														Type.list([
																															Type.tuple([
																																Type.atom(
																																	"expression",
																																),
																																Type.tuple([
																																	context.vars
																																		.item_7,
																																]),
																															]),
																														]),
																													]),
																													Type.tuple([
																														Type.atom("text"),
																														Type.bitstring(
																															"\n            ",
																														),
																													]),
																												]),
																											]),
																											Type.tuple([
																												Type.atom("text"),
																												Type.bitstring(
																													"\n          ",
																												),
																											]),
																										]);
																									},
																									context,
																								),
																								Type.tuple([
																									Type.atom("text"),
																									Type.bitstring("\n        "),
																								]),
																							]),
																						]),
																						Type.tuple([
																							Type.atom("text"),
																							Type.bitstring("\n      "),
																						]),
																					]),
																				]),
																				Type.tuple([
																					Type.atom("text"),
																					Type.bitstring("\n    "),
																				]),
																			]);
																		},
																	},
																],
																context,
															),
															Type.tuple([
																Type.atom("text"),
																Type.bitstring("\n  "),
															]),
														]);
													},
													context,
												),
												Type.tuple([Type.atom("text"), Type.bitstring("\n")]),
											]),
										]),
									]);
								},
							},
						],
						context,
					);
					Interpreter.updateVarsToMatchedValues(context);
					return globalThis.hologram.return;
				},
			},
		],
	);

	Interpreter.defineElixirFunction(
		"LeaplyWeb.Hologram.Components.ProfileAreaNavigation",
		"professional_url",
		1,
		"public",
		[
			{
				params: (context) => [Type.variablePattern("return_to_0")],
				guards: [(context) => Erlang["is_binary/1"](context.vars.return_to_0)],
				body: (context) => {
					return Interpreter.case(
						Interpreter.case(
							Erlang["==/2"](
								context.vars.return_to_0,
								Type.bitstring("/me/profile"),
							),
							[
								{
									match: Type.atom("false"),
									guards: [],
									body: (context) => {
										return Elixir_String["starts_with?/2"](
											context.vars.return_to_0,
											Type.bitstring("/me/profile?"),
										);
									},
								},
								{
									match: Type.atom("true"),
									guards: [],
									body: (context) => {
										return Type.atom("true");
									},
								},
							],
							context,
						),
						[
							{
								match: Type.variablePattern("x_1"),
								guards: [
									(context) =>
										Erlang["orelse/2"](
											(context) =>
												Erlang["=:=/2"](context.vars.x_1, Type.atom("false")),
											(context) =>
												Erlang["=:=/2"](context.vars.x_1, Type.atom("nil")),
											context,
										),
								],
								body: (context) => {
									return Type.bitstring("/me/profile");
								},
							},
							{
								match: Type.matchPlaceholder(),
								guards: [],
								body: (context) => {
									return context.vars.return_to_0;
								},
							},
						],
						context,
					);
				},
			},
			{
				params: (context) => [Type.matchPlaceholder()],
				guards: [],
				body: (context) => {
					return Type.bitstring("/me/profile");
				},
			},
		],
	);

	Interpreter.defineElixirFunction(
		"LeaplyWeb.Hologram.Components.ThemeToggle",
		"__props__",
		0,
		"public",
		[
			{
				params: (context) => [],
				guards: [],
				body: (context) => {
					return Elixir_Enum["reverse/1"](
						Type.list([
							Type.tuple([
								Type.atom("icon_only"),
								Type.atom("boolean"),
								Type.list([
									Type.tuple([Type.atom("default"), Type.atom("false")]),
								]),
							]),
						]),
					);
				},
			},
		],
	);

	Interpreter.defineElixirFunction(
		"LeaplyWeb.Hologram.Components.ThemeToggle",
		"button_class",
		1,
		"public",
		[
			{
				params: (context) => [Type.atom("true")],
				guards: [],
				body: (context) => {
					return Type.bitstring("btn btn-ghost btn-square min-h-11 min-w-11");
				},
			},
			{
				params: (context) => [Type.atom("false")],
				guards: [],
				body: (context) => {
					return Type.bitstring(
						"btn btn-ghost min-h-11 min-w-11 px-2.5 xl:px-4",
					);
				},
			},
		],
	);

	Interpreter.defineElixirFunction(
		"LeaplyWeb.Hologram.Components.ThemeToggle",
		"template",
		0,
		"public",
		[
			{
				params: (context) => [],
				guards: [],
				body: (context) => {
					globalThis.hologram.return = Type.anonymousFunction(
						1,
						[
							{
								params: (context) => [Type.variablePattern("vars_0")],
								guards: [],
								body: (context) => {
									Interpreter.matchOperator(
										context.vars.vars_0,
										Type.matchPlaceholder(),
										context,
									);
									Interpreter.updateVarsToMatchedValues(context);
									return Type.list([
										Type.tuple([
											Type.atom("element"),
											Type.bitstring("button"),
											Type.list([
												Type.tuple([
													Type.bitstring("type"),
													Type.list([
														Type.tuple([
															Type.atom("text"),
															Type.bitstring("button"),
														]),
													]),
												]),
												Type.tuple([
													Type.bitstring("data-theme-toggle"),
													Type.list([]),
												]),
												Type.tuple([
													Type.bitstring("data-switch-to-light-label"),
													Type.list([
														Type.tuple([
															Type.atom("expression"),
															Type.tuple([
																Elixir_LeaplyWeb_Hologram_Components_ThemeToggle[
																	"text/1"
																](
																	Type.bitstring(
																		"shared.theme.switch_to_light",
																	),
																),
															]),
														]),
													]),
												]),
												Type.tuple([
													Type.bitstring("data-switch-to-dark-label"),
													Type.list([
														Type.tuple([
															Type.atom("expression"),
															Type.tuple([
																Elixir_LeaplyWeb_Hologram_Components_ThemeToggle[
																	"text/1"
																](
																	Type.bitstring("shared.theme.switch_to_dark"),
																),
															]),
														]),
													]),
												]),
												Type.tuple([
													Type.bitstring("data-light-label"),
													Type.list([
														Type.tuple([
															Type.atom("expression"),
															Type.tuple([
																Elixir_LeaplyWeb_Hologram_Components_ThemeToggle[
																	"text/1"
																](Type.bitstring("shared.theme.light")),
															]),
														]),
													]),
												]),
												Type.tuple([
													Type.bitstring("data-dark-label"),
													Type.list([
														Type.tuple([
															Type.atom("expression"),
															Type.tuple([
																Elixir_LeaplyWeb_Hologram_Components_ThemeToggle[
																	"text/1"
																](Type.bitstring("shared.theme.dark")),
															]),
														]),
													]),
												]),
												Type.tuple([
													Type.bitstring("aria-label"),
													Type.list([
														Type.tuple([
															Type.atom("expression"),
															Type.tuple([
																Elixir_LeaplyWeb_Hologram_Components_ThemeToggle[
																	"text/1"
																](
																	Type.bitstring("shared.theme.switch_to_dark"),
																),
															]),
														]),
													]),
												]),
												Type.tuple([
													Type.bitstring("title"),
													Type.list([
														Type.tuple([
															Type.atom("expression"),
															Type.tuple([
																Elixir_LeaplyWeb_Hologram_Components_ThemeToggle[
																	"text/1"
																](
																	Type.bitstring("shared.theme.switch_to_dark"),
																),
															]),
														]),
													]),
												]),
												Type.tuple([
													Type.bitstring("class"),
													Type.list([
														Type.tuple([
															Type.atom("expression"),
															Type.tuple([
																Elixir_LeaplyWeb_Hologram_Components_ThemeToggle[
																	"button_class/1"
																](
																	Interpreter.dotOperator(
																		context.vars.vars_0,
																		Type.atom("icon_only"),
																	),
																),
															]),
														]),
													]),
												]),
											]),
											Type.list([
												Type.tuple([Type.atom("text"), Type.bitstring("\n  ")]),
												Type.tuple([
													Type.atom("element"),
													Type.bitstring("span"),
													Type.list([
														Type.tuple([
															Type.bitstring("class"),
															Type.list([
																Type.tuple([
																	Type.atom("text"),
																	Type.bitstring(
																		"hero-sun h-5 w-5 dark:hidden",
																	),
																]),
															]),
														]),
														Type.tuple([
															Type.bitstring("aria-hidden"),
															Type.list([
																Type.tuple([
																	Type.atom("text"),
																	Type.bitstring("true"),
																]),
															]),
														]),
													]),
													Type.list([]),
												]),
												Type.tuple([Type.atom("text"), Type.bitstring("\n  ")]),
												Type.tuple([
													Type.atom("element"),
													Type.bitstring("span"),
													Type.list([
														Type.tuple([
															Type.bitstring("class"),
															Type.list([
																Type.tuple([
																	Type.atom("text"),
																	Type.bitstring(
																		"hero-moon hidden h-5 w-5 dark:block",
																	),
																]),
															]),
														]),
														Type.tuple([
															Type.bitstring("aria-hidden"),
															Type.list([
																Type.tuple([
																	Type.atom("text"),
																	Type.bitstring("true"),
																]),
															]),
														]),
													]),
													Type.list([]),
												]),
												Type.tuple([Type.atom("text"), Type.bitstring("\n  ")]),
												Interpreter.case(
													Interpreter.case(
														Interpreter.dotOperator(
															context.vars.vars_0,
															Type.atom("icon_only"),
														),
														[
															{
																match: Type.variablePattern("x_1"),
																guards: [
																	(context) =>
																		Erlang["orelse/2"](
																			(context) =>
																				Erlang["=:=/2"](
																					context.vars.x_1,
																					Type.atom("false"),
																				),
																			(context) =>
																				Erlang["=:=/2"](
																					context.vars.x_1,
																					Type.atom("nil"),
																				),
																			context,
																		),
																],
																body: (context) => {
																	return Type.atom("true");
																},
															},
															{
																match: Type.matchPlaceholder(),
																guards: [],
																body: (context) => {
																	return Type.atom("false");
																},
															},
														],
														context,
													),
													[
														{
															match: Type.atom("false"),
															guards: [],
															body: (context) => {
																return Type.atom("nil");
															},
														},
														{
															match: Type.atom("true"),
															guards: [],
															body: (context) => {
																return Type.list([
																	Type.tuple([
																		Type.atom("element"),
																		Type.bitstring("span"),
																		Type.list([
																			Type.tuple([
																				Type.bitstring(
																					"data-theme-toggle-label",
																				),
																				Type.list([]),
																			]),
																			Type.tuple([
																				Type.bitstring("class"),
																				Type.list([
																					Type.tuple([
																						Type.atom("text"),
																						Type.bitstring(
																							"hidden text-sm font-semibold xl:inline",
																						),
																					]),
																				]),
																			]),
																		]),
																		Type.list([
																			Type.tuple([
																				Type.atom("expression"),
																				Type.tuple([
																					Elixir_LeaplyWeb_Hologram_Components_ThemeToggle[
																						"text/1"
																					](
																						Type.bitstring("shared.theme.dark"),
																					),
																				]),
																			]),
																		]),
																	]),
																]);
															},
														},
													],
													context,
												),
												Type.tuple([Type.atom("text"), Type.bitstring("\n")]),
											]),
										]),
									]);
								},
							},
						],
						context,
					);
					Interpreter.updateVarsToMatchedValues(context);
					return globalThis.hologram.return;
				},
			},
		],
	);

	Interpreter.defineElixirFunction(
		"LeaplyWeb.Hologram.Components.ThemeToggle",
		"text",
		1,
		"public",
		[
			{
				params: (context) => [Type.variablePattern("key_0")],
				guards: [],
				body: (context) => {
					return Elixir_LeaplyWeb_Hologram_Helpers_ThemeText["get/1"](
						context.vars.key_0,
					);
				},
			},
		],
	);

	Interpreter.defineElixirFunction(
		"LeaplyWeb.Hologram.Helpers.CatalogText",
		"get",
		2,
		"public",
		[
			{
				params: (context) => [
					Type.variablePattern("domain_0"),
					Type.variablePattern("key_1"),
				],
				guards: [],
				body: (context) => {
					return Elixir_LeaplyWeb_Hologram_Helpers_CatalogText["get/3"](
						context.vars.domain_0,
						context.vars.key_1,
						Type.list([]),
					);
				},
			},
		],
	);

	Interpreter.defineElixirFunction(
		"LeaplyWeb.Hologram.Helpers.CatalogText",
		"get",
		3,
		"public",
		[
			{
				params: (context) => [
					Type.variablePattern("domain_0"),
					Type.variablePattern("key_1"),
					Type.variablePattern("bindings_2"),
				],
				guards: [],
				body: (context) => {
					Interpreter.matchOperator(
						Elixir_Map["get/3"](
							Type.map([
								[
									Type.bitstring("listings"),
									Type.map([
										[
											Type.atom("plural"),
											Type.map([
												[
													Type.bitstring("listings.accounts.count.one"),
													Type.tuple([
														Type.bitstring("listings.accounts.count.other"),
														Type.map([
															[
																Type.integer(0n),
																Type.bitstring("%{count} account"),
															],
															[
																Type.integer(1n),
																Type.bitstring("%{count} accounts"),
															],
														]),
													]),
												],
												[
													Type.bitstring("listings.workspace.count.one"),
													Type.tuple([
														Type.bitstring("listings.workspace.count.other"),
														Type.map([
															[
																Type.integer(0n),
																Type.bitstring("%{count} listing"),
															],
															[
																Type.integer(1n),
																Type.bitstring("%{count} listings"),
															],
														]),
													]),
												],
											]),
										],
										[
											Type.atom("singular"),
											Type.map([
												[
													Type.bitstring(
														"applications.screening.attention_heading",
													),
													Type.bitstring(
														"Your screening eligibility needs attention",
													),
												],
												[
													Type.bitstring(
														"applications.screening.stable_status_help",
													),
													Type.bitstring(
														"Your application remains in review. Its status and the opportunity team's pipeline totals have not been changed.",
													),
												],
												[
													Type.bitstring("listings.accounts.account_fallback"),
													Type.bitstring("Account"),
												],
												[
													Type.bitstring(
														"listings.accounts.back_to_opportunities",
													),
													Type.bitstring("Back to opportunities"),
												],
												[
													Type.bitstring("listings.accounts.card_action"),
													Type.bitstring(
														"View listings and configure applicant screening",
													),
												],
												[
													Type.bitstring("listings.accounts.description"),
													Type.bitstring(
														"Choose an organisation to manage its listings, screening questions, and applicants.",
													),
												],
												[
													Type.bitstring("listings.accounts.empty.action"),
													Type.bitstring("Browse opportunities"),
												],
												[
													Type.bitstring("listings.accounts.empty.description"),
													Type.bitstring(
														"Accounts you own or help administer will appear here. Your applicant profile and opportunities remain available as normal.",
													),
												],
												[
													Type.bitstring("listings.accounts.empty.heading"),
													Type.bitstring("No managed accounts yet"),
												],
												[
													Type.bitstring("listings.accounts.eyebrow"),
													Type.bitstring("Publisher workspace"),
												],
												[
													Type.bitstring("listings.accounts.heading"),
													Type.bitstring("Managed accounts"),
												],
												[
													Type.bitstring("listings.accounts.page_title"),
													Type.bitstring("Accounts"),
												],
												[
													Type.bitstring("listings.common.breadcrumb"),
													Type.bitstring("Breadcrumb"),
												],
												[
													Type.bitstring("listings.common.cancel"),
													Type.bitstring("Cancel"),
												],
												[
													Type.bitstring("listings.common.language_missing"),
													Type.bitstring("Language not specified"),
												],
												[
													Type.bitstring("listings.common.locale_missing"),
													Type.bitstring("Locale not set"),
												],
												[
													Type.bitstring("listings.common.optional"),
													Type.bitstring("(optional)"),
												],
												[
													Type.bitstring("listings.common.profile_fallback"),
													Type.bitstring("Your profile"),
												],
												[
													Type.bitstring("listings.discovery.all_languages"),
													Type.bitstring("All languages"),
												],
												[
													Type.bitstring("listings.discovery.language"),
													Type.bitstring("Language"),
												],
												[
													Type.bitstring("listings.discovery.language_filter"),
													Type.bitstring("Language: %{locale}"),
												],
												[
													Type.bitstring("listings.flash.created"),
													Type.bitstring(
														"Screening scenario created. Add the questions applicants should answer.",
													),
												],
												[
													Type.bitstring("listings.flash.updated"),
													Type.bitstring("Listing details updated."),
												],
												[
													Type.bitstring("listings.form.back_to_account"),
													Type.bitstring("%{account} listings"),
												],
												[
													Type.bitstring("listings.form.description"),
													Type.bitstring(
														"Set the opportunity context used to test screening. New scenarios stay private as drafts until a separate publication workflow is added.",
													),
												],
												[
													Type.bitstring("listings.form.error.create"),
													Type.bitstring(
														"We could not create this listing. Review the highlighted fields.",
													),
												],
												[
													Type.bitstring("listings.form.error.update"),
													Type.bitstring(
														"We could not update this listing. Review the highlighted fields.",
													),
												],
												[
													Type.bitstring("listings.form.eyebrow.edit"),
													Type.bitstring("Listing details"),
												],
												[
													Type.bitstring("listings.form.eyebrow.new"),
													Type.bitstring("New draft listing"),
												],
												[
													Type.bitstring("listings.form.heading.edit"),
													Type.bitstring("Edit screening scenario"),
												],
												[
													Type.bitstring("listings.form.heading.new"),
													Type.bitstring("Create a new listing"),
												],
												[
													Type.bitstring("listings.form.kind.help"),
													Type.bitstring(
														"Used to present the scenario consistently across listing surfaces.",
													),
												],
												[
													Type.bitstring("listings.form.kind.label"),
													Type.bitstring("Opportunity type"),
												],
												[
													Type.bitstring("listings.form.locale.help"),
													Type.bitstring(
														"Choose the language and region applicants will use for this listing.",
													),
												],
												[
													Type.bitstring("listings.form.locale.invalid_option"),
													Type.bitstring("Invalid locale: %{locale}"),
												],
												[
													Type.bitstring("listings.form.locale.label"),
													Type.bitstring("Listing locale"),
												],
												[
													Type.bitstring(
														"listings.form.locale_locked.description",
													),
													Type.bitstring(
														"This listing already owns or uses screening questions. Keep this locale aligned, or create a new scenario for another locale.",
													),
												],
												[
													Type.bitstring("listings.form.locale_locked.heading"),
													Type.bitstring("Locale locked."),
												],
												[
													Type.bitstring(
														"listings.form.locale_notice.description",
													),
													Type.bitstring(
														"The listing locale automatically filters reusable questions and keeps applicant-facing copy aligned. Create another listing when you need to test a different locale.",
													),
												],
												[
													Type.bitstring("listings.form.locale_notice.heading"),
													Type.bitstring("One locale per scenario"),
												],
												[
													Type.bitstring("listings.form.page_title"),
													Type.bitstring("Listing details — Leaply"),
												],
												[
													Type.bitstring("listings.form.submit.edit"),
													Type.bitstring("Save listing"),
												],
												[
													Type.bitstring("listings.form.submit.new"),
													Type.bitstring("Create and configure screening"),
												],
												[
													Type.bitstring("listings.form.summary.help"),
													Type.bitstring(
														"Add a short note about the applicant scenario or screening behavior you are testing.",
													),
												],
												[
													Type.bitstring("listings.form.summary.label"),
													Type.bitstring("Scenario summary"),
												],
												[
													Type.bitstring("listings.form.title.help"),
													Type.bitstring(
														"Use a descriptive name so you can distinguish this scenario in the workspace.",
													),
												],
												[
													Type.bitstring("listings.form.title.label"),
													Type.bitstring("Listing title"),
												],
												[
													Type.bitstring("listings.kind.bursary"),
													Type.bitstring("Bursary"),
												],
												[
													Type.bitstring("listings.kind.event"),
													Type.bitstring("Event"),
												],
												[
													Type.bitstring("listings.kind.internship"),
													Type.bitstring("Internship"),
												],
												[
													Type.bitstring("listings.kind.job"),
													Type.bitstring("Job"),
												],
												[
													Type.bitstring("listings.kind.learnership"),
													Type.bitstring("Learnership"),
												],
												[
													Type.bitstring("listings.kind.opportunity"),
													Type.bitstring("Opportunity"),
												],
												[
													Type.bitstring("listings.kind.other"),
													Type.bitstring("Other"),
												],
												[
													Type.bitstring("listings.kind.scholarship"),
													Type.bitstring("Scholarship"),
												],
												[
													Type.bitstring("listings.kind.survey"),
													Type.bitstring("Survey"),
												],
												[
													Type.bitstring("listings.shell.managed_listings"),
													Type.bitstring("Managed listings"),
												],
												[
													Type.bitstring("listings.state.archived"),
													Type.bitstring("Archived"),
												],
												[
													Type.bitstring("listings.state.closed"),
													Type.bitstring("Closed"),
												],
												[
													Type.bitstring("listings.state.complete"),
													Type.bitstring("Complete"),
												],
												[
													Type.bitstring("listings.state.draft"),
													Type.bitstring("Draft"),
												],
												[
													Type.bitstring("listings.state.open"),
													Type.bitstring("Open"),
												],
												[
													Type.bitstring("listings.state.published"),
													Type.bitstring("Published"),
												],
												[
													Type.bitstring("listings.state.unknown"),
													Type.bitstring("Unknown"),
												],
												[
													Type.bitstring("listings.validation.locale.invalid"),
													Type.bitstring("is invalid"),
												],
												[
													Type.bitstring("listings.validation.locale.locked"),
													Type.bitstring(
														"can't be changed after screening questions are configured",
													),
												],
												[
													Type.bitstring("listings.workspace.back_to_accounts"),
													Type.bitstring("Managed accounts"),
												],
												[
													Type.bitstring("listings.workspace.description"),
													Type.bitstring(
														"Configure the questions applicants answer, then review submitted applications when tracking is enabled.",
													),
												],
												[
													Type.bitstring("listings.workspace.edit_action"),
													Type.bitstring("Edit listing"),
												],
												[
													Type.bitstring("listings.workspace.empty.action"),
													Type.bitstring("Create your first listing"),
												],
												[
													Type.bitstring(
														"listings.workspace.empty.description",
													),
													Type.bitstring(
														"Create a private scenario, choose its locale, then build the screening flow applicants will complete.",
													),
												],
												[
													Type.bitstring("listings.workspace.empty.heading"),
													Type.bitstring("No listings for this account yet"),
												],
												[
													Type.bitstring("listings.workspace.eyebrow"),
													Type.bitstring("Listing management"),
												],
												[
													Type.bitstring("listings.workspace.heading"),
													Type.bitstring("%{account} — Listings"),
												],
												[
													Type.bitstring("listings.workspace.new_action"),
													Type.bitstring("New Listing"),
												],
												[
													Type.bitstring("listings.workspace.page_title"),
													Type.bitstring("Account Listings"),
												],
												[
													Type.bitstring(
														"listings.workspace.screening.access_required",
													),
													Type.bitstring(
														"A listing manager or account administrator must configure screening.",
													),
												],
												[
													Type.bitstring("listings.workspace.screening.action"),
													Type.bitstring("Configure screening"),
												],
												[
													Type.bitstring(
														"listings.workspace.screening.description",
													),
													Type.bitstring(
														"Build the question flow applicants complete for this listing.",
													),
												],
												[
													Type.bitstring(
														"listings.workspace.screening.heading",
													),
													Type.bitstring("Screening questions"),
												],
												[
													Type.bitstring("listings.workspace.summary_empty"),
													Type.bitstring(
														"No listing summary has been added yet.",
													),
												],
												[
													Type.bitstring(
														"listings.workspace.tracker.access_required",
													),
													Type.bitstring(
														"Listing manager or screener access is required to view applicants",
													),
												],
												[
													Type.bitstring("listings.workspace.tracker.action"),
													Type.bitstring("View applicants"),
												],
												[
													Type.bitstring("listings.workspace.tracker.disabled"),
													Type.bitstring(
														"Applicant tracking is not enabled for this listing",
													),
												],
												[
													Type.bitstring("requirements.generic.failure"),
													Type.bitstring(
														"You don't meet one of this opportunity's eligibility requirements.",
													),
												],
												[
													Type.bitstring("requirements.generic.unverified"),
													Type.bitstring(
														"We couldn't verify one of this opportunity's eligibility requirements yet.",
													),
												],
												[
													Type.bitstring(
														"requirements.minimum-qualification.failure",
													),
													Type.bitstring(
														"You don't meet this opportunity's minimum qualification requirement.",
													),
												],
												[
													Type.bitstring(
														"requirements.minimum-qualification.unverified",
													),
													Type.bitstring(
														"We couldn't verify your minimum qualification yet.",
													),
												],
												[
													Type.bitstring(
														"requirements.open-to-opportunities.failure",
													),
													Type.bitstring(
														"Your profile must show that you are open to opportunities.",
													),
												],
												[
													Type.bitstring(
														"requirements.open-to-opportunities.unverified",
													),
													Type.bitstring(
														"We couldn't verify whether your profile shows that you are open to opportunities yet.",
													),
												],
											]),
										],
									]),
								],
								[
									Type.bitstring("screening"),
									Type.map([
										[
											Type.atom("plural"),
											Type.map([
												[
													Type.bitstring("screening.admin.page.one"),
													Type.tuple([
														Type.bitstring("screening.admin.page.many"),
														Type.map([
															[
																Type.integer(0n),
																Type.bitstring("Page %{page} of %{count}"),
															],
															[
																Type.integer(1n),
																Type.bitstring("Page %{page} of %{count}"),
															],
														]),
													]),
												],
												[
													Type.bitstring("screening.count.available_result"),
													Type.tuple([
														Type.bitstring("screening.count.available_results"),
														Type.map([
															[
																Type.integer(0n),
																Type.bitstring("%{count} available result"),
															],
															[
																Type.integer(1n),
																Type.bitstring("%{count} available results"),
															],
														]),
													]),
												],
												[
													Type.bitstring("screening.count.configured_question"),
													Type.tuple([
														Type.bitstring(
															"screening.count.configured_questions",
														),
														Type.map([
															[
																Type.integer(0n),
																Type.bitstring("%{count} configured question"),
															],
															[
																Type.integer(1n),
																Type.bitstring("%{count} configured questions"),
															],
														]),
													]),
												],
												[
													Type.bitstring("screening.count.group"),
													Type.tuple([
														Type.bitstring("screening.count.groups"),
														Type.map([
															[
																Type.integer(0n),
																Type.bitstring("%{count} group"),
															],
															[
																Type.integer(1n),
																Type.bitstring("%{count} groups"),
															],
														]),
													]),
												],
												[
													Type.bitstring("screening.count.matching_question"),
													Type.tuple([
														Type.bitstring(
															"screening.count.matching_questions",
														),
														Type.map([
															[
																Type.integer(0n),
																Type.bitstring("%{count} matching question"),
															],
															[
																Type.integer(1n),
																Type.bitstring("%{count} matching questions"),
															],
														]),
													]),
												],
												[
													Type.bitstring("screening.count.question"),
													Type.tuple([
														Type.bitstring("screening.count.questions"),
														Type.map([
															[
																Type.integer(0n),
																Type.bitstring("%{count} question"),
															],
															[
																Type.integer(1n),
																Type.bitstring("%{count} questions"),
															],
														]),
													]),
												],
												[
													Type.bitstring("screening.count.total_question"),
													Type.tuple([
														Type.bitstring("screening.count.total_questions"),
														Type.map([
															[
																Type.integer(0n),
																Type.bitstring("%{count} total"),
															],
															[
																Type.integer(1n),
																Type.bitstring("%{count} total"),
															],
														]),
													]),
												],
												[
													Type.bitstring("screening.eligibility.rule_count"),
													Type.tuple([
														Type.bitstring("screening.eligibility.rules_count"),
														Type.map([
															[
																Type.integer(0n),
																Type.bitstring("%{count} eligibility rule"),
															],
															[
																Type.integer(1n),
																Type.bitstring("%{count} eligibility rules"),
															],
														]),
													]),
												],
											]),
										],
										[
											Type.atom("singular"),
											Type.map([
												[
													Type.bitstring("screening.action.add"),
													Type.bitstring("Add"),
												],
												[
													Type.bitstring("screening.action.add_group"),
													Type.bitstring("Add group"),
												],
												[
													Type.bitstring("screening.action.adding"),
													Type.bitstring("Adding…"),
												],
												[
													Type.bitstring("screening.action.apply"),
													Type.bitstring("Apply"),
												],
												[
													Type.bitstring("screening.action.clear"),
													Type.bitstring("Clear"),
												],
												[
													Type.bitstring("screening.action.create_and_add"),
													Type.bitstring("Create and add question"),
												],
												[
													Type.bitstring("screening.action.creating"),
													Type.bitstring("Creating…"),
												],
												[
													Type.bitstring(
														"screening.action.deactivate_question",
													),
													Type.bitstring("Deactivate question"),
												],
												[
													Type.bitstring("screening.action.delete_group"),
													Type.bitstring("Delete group"),
												],
												[
													Type.bitstring("screening.action.discard_draft"),
													Type.bitstring("Discard draft"),
												],
												[
													Type.bitstring("screening.action.drag_question"),
													Type.bitstring("Reorder question"),
												],
												[
													Type.bitstring("screening.action.make_primary"),
													Type.bitstring("Make primary"),
												],
												[
													Type.bitstring("screening.action.manage_eligibility"),
													Type.bitstring("Manage eligibility"),
												],
												[
													Type.bitstring(
														"screening.action.manage_system_questions",
													),
													Type.bitstring("Manage system questions"),
												],
												[
													Type.bitstring("screening.action.move_down"),
													Type.bitstring("Move down"),
												],
												[
													Type.bitstring("screening.action.move_up"),
													Type.bitstring("Move up"),
												],
												[
													Type.bitstring(
														"screening.action.reactivate_question",
													),
													Type.bitstring("Reactivate question"),
												],
												[
													Type.bitstring("screening.action.remove"),
													Type.bitstring("Remove"),
												],
												[
													Type.bitstring("screening.action.remove_from_group"),
													Type.bitstring("Remove question from this group"),
												],
												[
													Type.bitstring("screening.action.save_changes"),
													Type.bitstring("Save changes"),
												],
												[
													Type.bitstring(
														"screening.action.save_prompt_settings",
													),
													Type.bitstring("Save settings"),
												],
												[
													Type.bitstring("screening.action.save_wording"),
													Type.bitstring("Save wording"),
												],
												[
													Type.bitstring("screening.action.saving"),
													Type.bitstring("Saving…"),
												],
												[
													Type.bitstring("screening.action.search"),
													Type.bitstring("Search"),
												],
												[
													Type.bitstring("screening.admin.add_option"),
													Type.bitstring("Add option"),
												],
												[
													Type.bitstring("screening.admin.additional_settings"),
													Type.bitstring("Additional saved settings"),
												],
												[
													Type.bitstring(
														"screening.admin.additional_settings_help",
													),
													Type.bitstring(
														"These settings are preserved when you save. The current answer control may not use them.",
													),
												],
												[
													Type.bitstring("screening.admin.all_locales"),
													Type.bitstring("All locales"),
												],
												[
													Type.bitstring("screening.admin.availability"),
													Type.bitstring("Availability for new question sets"),
												],
												[
													Type.bitstring("screening.admin.availability_help"),
													Type.bitstring(
														"Inactive questions remain usable in existing question sets and keep their saved answers. Reactivating offers the same question for new sets again.",
													),
												],
												[
													Type.bitstring("screening.admin.back_to_app"),
													Type.bitstring("Back to Leaply"),
												],
												[
													Type.bitstring("screening.admin.cancel"),
													Type.bitstring("Cancel"),
												],
												[
													Type.bitstring("screening.admin.choice_options_help"),
													Type.bitstring(
														"One option per line as stable_key | Applicant label.",
													),
												],
												[
													Type.bitstring(
														"screening.admin.choice_options_placeholder",
													),
													Type.bitstring("yes | Yes\nno | No"),
												],
												[
													Type.bitstring("screening.admin.choice_rows_help"),
													Type.bitstring(
														"Add an applicant-facing label and a unique, stable key for each option. Suggested keys can be edited before saving. Existing labels and keys stay fixed once the question has attachments or answers.",
													),
												],
												[
													Type.bitstring("screening.admin.choose_locale"),
													Type.bitstring("Choose an available locale"),
												],
												[
													Type.bitstring("screening.admin.clear_filters"),
													Type.bitstring("Clear filters"),
												],
												[
													Type.bitstring("screening.admin.config.max"),
													Type.bitstring("Maximum value"),
												],
												[
													Type.bitstring("screening.admin.config.max_length"),
													Type.bitstring("Maximum characters"),
												],
												[
													Type.bitstring("screening.admin.config.min"),
													Type.bitstring("Minimum value"),
												],
												[
													Type.bitstring("screening.admin.config.min_length"),
													Type.bitstring("Minimum characters"),
												],
												[
													Type.bitstring(
														"screening.admin.configuration_edit_help",
													),
													Type.bitstring(
														"Leave a limit blank to use the default. New limits apply when answers are submitted or updated; existing saved answers stay unchanged.",
													),
												],
												[
													Type.bitstring(
														"screening.admin.configuration_heading",
													),
													Type.bitstring("View saved configuration"),
												],
												[
													Type.bitstring("screening.admin.confirm_deactivate"),
													Type.bitstring("Confirm deactivation"),
												],
												[
													Type.bitstring("screening.admin.create_eyebrow"),
													Type.bitstring("New library item"),
												],
												[
													Type.bitstring("screening.admin.create_heading"),
													Type.bitstring("Create system question"),
												],
												[
													Type.bitstring("screening.admin.create_locale_help"),
													Type.bitstring(
														"Choose the locale this question is authored for. Listing teams only see questions matching their listing locale.",
													),
												],
												[
													Type.bitstring("screening.admin.description"),
													Type.bitstring(
														"Create reusable, locale-specific questions that listing teams can discover before authoring duplicates.",
													),
												],
												[
													Type.bitstring("screening.admin.detail_heading"),
													Type.bitstring("System question"),
												],
												[
													Type.bitstring("screening.admin.draft_failed"),
													Type.bitstring(
														"The form could not be updated. Your input is still here. Try the form action again when your connection returns.",
													),
												],
												[
													Type.bitstring("screening.admin.edit_heading"),
													Type.bitstring("Edit question definition"),
												],
												[
													Type.bitstring("screening.admin.edit_wording"),
													Type.bitstring("Edit question"),
												],
												[
													Type.bitstring("screening.admin.empty_help"),
													Type.bitstring(
														"Broaden the locale, status, or search filters, or create a new library item.",
													),
												],
												[
													Type.bitstring("screening.admin.empty_library"),
													Type.bitstring("Your system library is empty"),
												],
												[
													Type.bitstring("screening.admin.empty_library_help"),
													Type.bitstring(
														"Create the first reusable question for listing teams to use across Leaply.",
													),
												],
												[
													Type.bitstring("screening.admin.empty_title"),
													Type.bitstring(
														"No system questions match these filters",
													),
												],
												[
													Type.bitstring("screening.admin.eyebrow"),
													Type.bitstring("Shared screening library"),
												],
												[
													Type.bitstring("screening.admin.filters_eyebrow"),
													Type.bitstring("Library controls"),
												],
												[
													Type.bitstring("screening.admin.filters_heading"),
													Type.bitstring("Find system questions"),
												],
												[
													Type.bitstring("screening.admin.filters_help"),
													Type.bitstring(
														"These filters only change this admin library. They never change your profile or application language.",
													),
												],
												[
													Type.bitstring("screening.admin.heading"),
													Type.bitstring("System questions"),
												],
												[
													Type.bitstring("screening.admin.help_placeholder"),
													Type.bitstring(
														"Add context shown below the question",
													),
												],
												[
													Type.bitstring("screening.admin.home"),
													Type.bitstring("Leaply admin"),
												],
												[
													Type.bitstring("screening.admin.identity_heading"),
													Type.bitstring("Fixed answer identity"),
												],
												[
													Type.bitstring("screening.admin.length_limits"),
													Type.bitstring("Character limits"),
												],
												[
													Type.bitstring("screening.admin.library_heading"),
													Type.bitstring("Reusable questions"),
												],
												[
													Type.bitstring("screening.admin.locale_label"),
													Type.bitstring("Locale"),
												],
												[
													Type.bitstring("screening.admin.navigation"),
													Type.bitstring("Employee navigation"),
												],
												[
													Type.bitstring("screening.admin.new_question"),
													Type.bitstring("New question"),
												],
												[
													Type.bitstring("screening.admin.no_configuration"),
													Type.bitstring(
														"This answer type has no additional settings.",
													),
												],
												[
													Type.bitstring("screening.admin.number_limits"),
													Type.bitstring("Number limits"),
												],
												[
													Type.bitstring("screening.admin.operations"),
													Type.bitstring("Leaply Operations"),
												],
												[
													Type.bitstring("screening.admin.option_key"),
													Type.bitstring("Option %{number} key"),
												],
												[
													Type.bitstring("screening.admin.option_label"),
													Type.bitstring("Option %{number} label"),
												],
												[
													Type.bitstring("screening.admin.page_title"),
													Type.bitstring("System screening questions"),
												],
												[
													Type.bitstring("screening.admin.pending"),
													Type.bitstring("Submitting… Please wait."),
												],
												[
													Type.bitstring("screening.admin.preview_empty_label"),
													Type.bitstring("Your question will appear here"),
												],
												[
													Type.bitstring("screening.admin.preview_heading"),
													Type.bitstring("Preview"),
												],
												[
													Type.bitstring("screening.admin.preview_help"),
													Type.bitstring(
														"Try the question as an applicant would see it. Preview answers are not saved. Whether an answer is required is set by the listing.",
													),
												],
												[
													Type.bitstring("screening.admin.questions"),
													Type.bitstring("Questions"),
												],
												[
													Type.bitstring("screening.admin.rejected_response"),
													Type.bitstring(
														"The question was not saved because validation failed. Your input is still here. Submit again to review the validation errors.",
													),
												],
												[
													Type.bitstring("screening.admin.remove"),
													Type.bitstring("Remove"),
												],
												[
													Type.bitstring("screening.admin.remove_option"),
													Type.bitstring("Remove option %{number}"),
												],
												[
													Type.bitstring("screening.admin.search_label"),
													Type.bitstring("Search"),
												],
												[
													Type.bitstring("screening.admin.search_placeholder"),
													Type.bitstring("Wording, help text, or question UID"),
												],
												[
													Type.bitstring("screening.admin.settings_heading"),
													Type.bitstring("Answer settings"),
												],
												[
													Type.bitstring("screening.admin.shared_edit_help"),
													Type.bitstring(
														"Changes are shared wherever this question is used. Review the preview before saving.",
													),
												],
												[
													Type.bitstring("screening.admin.skip_to_content"),
													Type.bitstring("Skip to main content"),
												],
												[
													Type.bitstring("screening.admin.stable"),
													Type.bitstring("stable"),
												],
												[
													Type.bitstring(
														"screening.admin.stable_identity_help",
													),
													Type.bitstring(
														"Locale and answer type are fixed after creation. Answer settings can be edited while preserving existing answers and choice keys.",
													),
												],
												[
													Type.bitstring("screening.admin.status_active"),
													Type.bitstring("Active only"),
												],
												[
													Type.bitstring("screening.admin.status_all"),
													Type.bitstring("Active and inactive"),
												],
												[
													Type.bitstring("screening.admin.status_inactive"),
													Type.bitstring("Inactive only"),
												],
												[
													Type.bitstring("screening.admin.status_label"),
													Type.bitstring("Status"),
												],
												[
													Type.bitstring("screening.admin.uid"),
													Type.bitstring("Question UID"),
												],
												[
													Type.bitstring("screening.admin.unknown_outcome"),
													Type.bitstring(
														"We could not confirm the result. Your input is still here, and submitting again is blocked. Use the Questions breadcrumb to check whether the change was saved before starting another request.",
													),
												],
												[
													Type.bitstring("screening.admin.update_answer_type"),
													Type.bitstring("Update answer type"),
												],
												[
													Type.bitstring("screening.admin.update_preview"),
													Type.bitstring("Update preview"),
												],
												[
													Type.bitstring(
														"screening.admin.validation.configuration_bounds",
													),
													Type.bitstring(
														"Enter limits within the supported range, with the minimum no greater than the maximum.",
													),
												],
												[
													Type.bitstring(
														"screening.admin.validation.configuration_fields",
													),
													Type.bitstring(
														"Only the supported settings for this answer type can be edited.",
													),
												],
												[
													Type.bitstring(
														"screening.admin.validation.configuration_in_use",
													),
													Type.bitstring(
														"This question is in use. You can add options, but keep existing options and their keys, labels, and order unchanged.",
													),
												],
												[
													Type.bitstring(
														"screening.admin.validation.configuration_limits",
													),
													Type.bitstring(
														"Enter valid limits: the minimum must not exceed the maximum or the supported range.",
													),
												],
												[
													Type.bitstring(
														"screening.admin.validation.configuration_unsupported",
													),
													Type.bitstring(
														"Additional saved settings cannot be changed through this editor.",
													),
												],
												[
													Type.bitstring("screening.admin.validation.heading"),
													Type.bitstring("Review the question details"),
												],
												[
													Type.bitstring("screening.admin.validation.intent"),
													Type.bitstring(
														"Choose a form action to continue. The question has not been saved.",
													),
												],
												[
													Type.bitstring(
														"screening.admin.validation.locale_unavailable",
													),
													Type.bitstring(
														"Choose a locale available in this library.",
													),
												],
												[
													Type.bitstring(
														"screening.admin.validation.option_key",
													),
													Type.bitstring(
														"Enter a non-empty key that is unique in this question.",
													),
												],
												[
													Type.bitstring(
														"screening.admin.validation.option_label",
													),
													Type.bitstring("Enter an option label."),
												],
												[
													Type.bitstring("screening.admin.validation.stale"),
													Type.bitstring(
														"This question changed while you were editing. Reload it and review the latest values before saving.",
													),
												],
												[
													Type.bitstring(
														"screening.admin.validation.stale_question",
													),
													Type.bitstring(
														"This question changed since you opened it. Reload the question and review the latest values before saving.",
													),
												],
												[
													Type.bitstring(
														"screening.admin.validation.system_question_required",
													),
													Type.bitstring("Select a system question to edit."),
												],
												[
													Type.bitstring("screening.admin.wording_placeholder"),
													Type.bitstring("What should every applicant answer?"),
												],
												[
													Type.bitstring("screening.answer_kind.boolean"),
													Type.bitstring("Yes or no"),
												],
												[
													Type.bitstring("screening.answer_kind.choice"),
													Type.bitstring("Multiple choice"),
												],
												[
													Type.bitstring("screening.answer_kind.date"),
													Type.bitstring("Date"),
												],
												[
													Type.bitstring("screening.answer_kind.email"),
													Type.bitstring("Email address"),
												],
												[
													Type.bitstring("screening.answer_kind.file"),
													Type.bitstring("File upload"),
												],
												[
													Type.bitstring(
														"screening.answer_kind.file_non_primary",
													),
													Type.bitstring(
														"File upload (non-primary flows only)",
													),
												],
												[
													Type.bitstring("screening.answer_kind.number"),
													Type.bitstring("Number"),
												],
												[
													Type.bitstring("screening.answer_kind.phone"),
													Type.bitstring("Phone number"),
												],
												[
													Type.bitstring("screening.answer_kind.string"),
													Type.bitstring("Single-line text"),
												],
												[
													Type.bitstring("screening.answer_kind.text"),
													Type.bitstring("Paragraph text"),
												],
												[
													Type.bitstring("screening.answer_kind.unknown"),
													Type.bitstring("Question"),
												],
												[
													Type.bitstring("screening.choice.fallback"),
													Type.bitstring("Choice"),
												],
												[
													Type.bitstring("screening.common.no"),
													Type.bitstring("No"),
												],
												[
													Type.bitstring("screening.common.optional"),
													Type.bitstring("optional"),
												],
												[
													Type.bitstring("screening.common.yes"),
													Type.bitstring("Yes"),
												],
												[
													Type.bitstring("screening.condition.always_show"),
													Type.bitstring("Always show this question"),
												],
												[
													Type.bitstring(
														"screening.condition.available_choice_keys",
													),
													Type.bitstring("Available choice keys"),
												],
												[
													Type.bitstring(
														"screening.condition.boolean_placeholder",
													),
													Type.bitstring(
														"For yes/no questions, use true or false",
													),
												],
												[
													Type.bitstring("screening.condition.choose_source"),
													Type.bitstring("Choose an earlier question first"),
												],
												[
													Type.bitstring("screening.condition.choose_value"),
													Type.bitstring("Choose a value"),
												],
												[
													Type.bitstring(
														"screening.condition.earlier_question",
													),
													Type.bitstring("Earlier question"),
												],
												[
													Type.bitstring("screening.condition.no_value_needed"),
													Type.bitstring(
														"No comparison value is needed for this rule.",
													),
												],
												[
													Type.bitstring("screening.condition.operator_label"),
													Type.bitstring("Comparison"),
												],
												[
													Type.bitstring("screening.condition.saved_heading"),
													Type.bitstring("When applicants see this question"),
												],
												[
													Type.bitstring("screening.condition.saved_summary"),
													Type.bitstring(
														"Earlier question: %{question}. %{condition}",
													),
												],
												[
													Type.bitstring("screening.condition.source_label"),
													Type.bitstring("Show only after"),
												],
												[
													Type.bitstring("screening.condition.summary.always"),
													Type.bitstring("Always shown"),
												],
												[
													Type.bitstring(
														"screening.condition.summary.conditional",
													),
													Type.bitstring("Conditional visibility"),
												],
												[
													Type.bitstring(
														"screening.condition.summary.contains",
													),
													Type.bitstring(
														"Shown when the earlier answer contains %{value}",
													),
												],
												[
													Type.bitstring("screening.condition.summary.eq"),
													Type.bitstring(
														"Shown when the earlier answer is %{value}",
													),
												],
												[
													Type.bitstring("screening.condition.summary.exists"),
													Type.bitstring(
														"Shown after the selected question is answered",
													),
												],
												[
													Type.bitstring("screening.condition.summary.in"),
													Type.bitstring(
														"Shown when the earlier answer is one of %{value}",
													),
												],
												[
													Type.bitstring("screening.condition.summary.neq"),
													Type.bitstring(
														"Shown when the earlier answer is not %{value}",
													),
												],
												[
													Type.bitstring(
														"screening.condition.summary.not_exists",
													),
													Type.bitstring(
														"Shown while the selected question is unanswered",
													),
												],
												[
													Type.bitstring("screening.condition.value_help"),
													Type.bitstring(
														"For “one of”, separate values with commas. Choice rules use the stable keys shown below. “Has any answer” and “has no answer” do not need a value.",
													),
												],
												[
													Type.bitstring("screening.condition.value_label"),
													Type.bitstring("Comparison value"),
												],
												[
													Type.bitstring(
														"screening.condition.value_placeholder",
													),
													Type.bitstring("Enter the comparison value"),
												],
												[
													Type.bitstring(
														"screening.condition.values_placeholder",
													),
													Type.bitstring("Separate typed values with commas"),
												],
												[
													Type.bitstring(
														"screening.condition.visibility_heading",
													),
													Type.bitstring("When to show this question"),
												],
												[
													Type.bitstring("screening.confirm.group_delete"),
													Type.bitstring(
														"Delete the %{group} group and its %{question_count}? Reusable questions stay available.",
													),
												],
												[
													Type.bitstring(
														"screening.confirm.group_delete_primary",
													),
													Type.bitstring(
														"Delete the primary %{group} group and its %{question_count}? Future applications will have no saved primary screening flow until you configure one. Reusable questions stay available.",
													),
												],
												[
													Type.bitstring("screening.confirm.group_discard"),
													Type.bitstring(
														"Discard the %{group} draft group? It has not been saved yet.",
													),
												],
												[
													Type.bitstring("screening.confirm.group_primary"),
													Type.bitstring(
														"Make %{group} the primary application flow? The current primary group will be replaced for future applicants.",
													),
												],
												[
													Type.bitstring("screening.confirm.prompt_remove"),
													Type.bitstring(
														"Remove “%{question}” from %{group}? This removes it from this group only; the reusable question stays available.",
													),
												],
												[
													Type.bitstring(
														"screening.confirm.prompt_remove_last",
													),
													Type.bitstring(
														"Remove “%{question}” from %{group}? This is the last configured question, so the group will return to draft state. The reusable question stays available.",
													),
												],
												[
													Type.bitstring(
														"screening.confirm.question_deactivate",
													),
													Type.bitstring(
														"Deactivate “%{question}”? It will no longer be offered for new prompt groups, while existing prompt and answer history stays available.",
													),
												],
												[
													Type.bitstring(
														"screening.confirm.question_deactivate_fallback",
													),
													Type.bitstring(
														"Deactivate this question? Existing prompt and answer history stays available.",
													),
												],
												[
													Type.bitstring(
														"screening.current_eligibility.generic_failure",
													),
													Type.bitstring(
														"Your current information no longer meets this opportunity's screening conditions.",
													),
												],
												[
													Type.bitstring(
														"screening.current_eligibility.prompt_failure",
													),
													Type.bitstring(
														'Your current answer to "%{question}" no longer meets this opportunity\'s screening conditions.',
													),
												],
												[
													Type.bitstring("screening.eligibility.add_rule"),
													Type.bitstring("Add eligibility rule"),
												],
												[
													Type.bitstring("screening.eligibility.empty"),
													Type.bitstring(
														"No eligibility rule uses this answer. The question collects information without screening anyone out.",
													),
												],
												[
													Type.bitstring("screening.eligibility.heading"),
													Type.bitstring("Eligibility rules"),
												],
												[
													Type.bitstring("screening.eligibility.help"),
													Type.bitstring(
														"Every rule must pass for an applicant to meet this group’s requirements.",
													),
												],
												[
													Type.bitstring("screening.eligibility.move_down"),
													Type.bitstring("Move rule down"),
												],
												[
													Type.bitstring("screening.eligibility.move_up"),
													Type.bitstring("Move rule up"),
												],
												[
													Type.bitstring(
														"screening.eligibility.required_notice",
													),
													Type.bitstring(
														"Questions with eligibility rules are required automatically. Applicants are never shown which answer caused an unsuccessful screening result.",
													),
												],
												[
													Type.bitstring("screening.eligibility.rule"),
													Type.bitstring("Rule"),
												],
												[
													Type.bitstring("screening.eligibility.rules_label"),
													Type.bitstring("rules"),
												],
												[
													Type.bitstring(
														"screening.eligibility_management.active",
													),
													Type.bitstring("Active"),
												],
												[
													Type.bitstring(
														"screening.eligibility_management.all_phases",
													),
													Type.bitstring("View all phases"),
												],
												[
													Type.bitstring(
														"screening.eligibility_management.applicant_fallback",
													),
													Type.bitstring("Applicant"),
												],
												[
													Type.bitstring(
														"screening.eligibility_management.applied",
													),
													Type.bitstring("Applied"),
												],
												[
													Type.bitstring(
														"screening.eligibility_management.back",
													),
													Type.bitstring("Back to screening setup"),
												],
												[
													Type.bitstring(
														"screening.eligibility_management.changed",
													),
													Type.bitstring("Eligibility updated"),
												],
												[
													Type.bitstring(
														"screening.eligibility_management.empty_help",
													),
													Type.bitstring(
														"Active applications will appear here. Pending interest remains visible in the summary above.",
													),
												],
												[
													Type.bitstring(
														"screening.eligibility_management.empty_title",
													),
													Type.bitstring("No current applications"),
												],
												[
													Type.bitstring(
														"screening.eligibility_management.eyebrow",
													),
													Type.bitstring("Screening operations"),
												],
												[
													Type.bitstring(
														"screening.eligibility_management.heading",
													),
													Type.bitstring("Eligibility outcomes"),
												],
												[
													Type.bitstring(
														"screening.eligibility_management.ineligible",
													),
													Type.bitstring("Currently ineligible"),
												],
												[
													Type.bitstring(
														"screening.eligibility_management.no_phase",
													),
													Type.bitstring("No phase"),
												],
												[
													Type.bitstring(
														"screening.eligibility_management.not_available",
													),
													Type.bitstring("Not available"),
												],
												[
													Type.bitstring(
														"screening.eligibility_management.not_overrideable",
													),
													Type.bitstring(
														"Only active, currently ineligible applications can be overridden.",
													),
												],
												[
													Type.bitstring(
														"screening.eligibility_management.outcomes_heading",
													),
													Type.bitstring("Current application outcomes"),
												],
												[
													Type.bitstring(
														"screening.eligibility_management.outcomes_help",
													),
													Type.bitstring(
														"Review pending and active applications. Active applicants remain visible when their current eligibility changes.",
													),
												],
												[
													Type.bitstring(
														"screening.eligibility_management.override_action",
													),
													Type.bitstring("Force eligibility"),
												],
												[
													Type.bitstring(
														"screening.eligibility_management.override_failed",
													),
													Type.bitstring(
														"We could not save the eligibility override.",
													),
												],
												[
													Type.bitstring(
														"screening.eligibility_management.override_saved",
													),
													Type.bitstring("Eligibility override saved."),
												],
												[
													Type.bitstring(
														"screening.eligibility_management.page_title",
													),
													Type.bitstring("Screening eligibility"),
												],
												[
													Type.bitstring(
														"screening.eligibility_management.pending",
													),
													Type.bitstring("Pending"),
												],
												[
													Type.bitstring(
														"screening.eligibility_management.phase",
													),
													Type.bitstring("Phase"),
												],
												[
													Type.bitstring(
														"screening.eligibility_management.reason_label",
													),
													Type.bitstring("Internal override reason"),
												],
												[
													Type.bitstring(
														"screening.eligibility_management.reason_placeholder",
													),
													Type.bitstring(
														"Explain why this applicant should be treated as eligible",
													),
												],
												[
													Type.bitstring(
														"screening.eligibility_management.reason_required",
													),
													Type.bitstring(
														"Enter an internal reason before forcing eligibility.",
													),
												],
												[
													Type.bitstring(
														"screening.eligibility_management.status_currently_ineligible",
													),
													Type.bitstring("Active · currently ineligible"),
												],
												[
													Type.bitstring(
														"screening.eligibility_management.status_eligible",
													),
													Type.bitstring("Eligible"),
												],
												[
													Type.bitstring(
														"screening.eligibility_management.status_not_evaluated",
													),
													Type.bitstring("Not evaluated"),
												],
												[
													Type.bitstring(
														"screening.eligibility_management.status_overridden",
													),
													Type.bitstring("Eligible · manually reviewed"),
												],
												[
													Type.bitstring(
														"screening.eligibility_management.summary",
													),
													Type.bitstring("Eligibility summary"),
												],
												[
													Type.bitstring("screening.error.access_unverified"),
													Type.bitstring(
														"Your access could not be verified. Refresh the page and try again.",
													),
												],
												[
													Type.bitstring("screening.error.action_unsupported"),
													Type.bitstring(
														"That screening action is not supported.",
													),
												],
												[
													Type.bitstring("screening.error.group_invalid"),
													Type.bitstring("Choose a valid prompt group."),
												],
												[
													Type.bitstring("screening.error.group_missing"),
													Type.bitstring("That prompt group no longer exists."),
												],
												[
													Type.bitstring("screening.error.prompt_move_failed"),
													Type.bitstring("Unable to move that prompt."),
												],
												[
													Type.bitstring(
														"screening.error.prompt_remove_failed",
													),
													Type.bitstring("Unable to remove that prompt."),
												],
												[
													Type.bitstring(
														"screening.error.prompt_update_failed",
													),
													Type.bitstring(
														"Unable to save those prompt settings.",
													),
												],
												[
													Type.bitstring(
														"screening.error.question_uid_missing",
													),
													Type.bitstring(
														"Question not found for the selected UID.",
													),
												],
												[
													Type.bitstring(
														"screening.error.question_unavailable",
													),
													Type.bitstring(
														"Question not found or unavailable for this listing.",
													),
												],
												[
													Type.bitstring(
														"screening.error.question_update_failed",
													),
													Type.bitstring(
														"Unable to update that reusable question.",
													),
												],
												[
													Type.bitstring("screening.error.request_failed"),
													Type.bitstring("Unable to complete request."),
												],
												[
													Type.bitstring("screening.error.search_failed"),
													Type.bitstring("Unable to search questions."),
												],
												[
													Type.bitstring("screening.error.update_timeout"),
													Type.bitstring(
														"The update is taking longer than expected. Please wait, or refresh to verify the saved state before trying again.",
													),
												],
												[
													Type.bitstring("screening.filter.active_label"),
													Type.bitstring("active"),
												],
												[
													Type.bitstring("screening.filter.add"),
													Type.bitstring("Add answer filter"),
												],
												[
													Type.bitstring("screening.filter.choose_question"),
													Type.bitstring("Choose a screening question"),
												],
												[
													Type.bitstring("screening.filter.clear_all"),
													Type.bitstring("Clear all answer filters"),
												],
												[
													Type.bitstring("screening.filter.empty"),
													Type.bitstring(
														"No screening-answer filter is active.",
													),
												],
												[
													Type.bitstring("screening.filter.heading"),
													Type.bitstring("Screening answers"),
												],
												[
													Type.bitstring("screening.filter.help"),
													Type.bitstring(
														"Match applications against the answers submitted with this listing. Multiple filters must all match and only disclosed answers are searched.",
													),
												],
												[
													Type.bitstring("screening.filter.item_label"),
													Type.bitstring("Answer filter"),
												],
												[
													Type.bitstring("screening.filter.question_label"),
													Type.bitstring("Question"),
												],
												[
													Type.bitstring("screening.flash.group_deleted"),
													Type.bitstring(
														"%{group} was deleted. Its reusable questions are still available.",
													),
												],
												[
													Type.bitstring(
														"screening.flash.group_draft_discarded",
													),
													Type.bitstring("%{group} draft was discarded."),
												],
												[
													Type.bitstring("screening.flash.group_primary"),
													Type.bitstring(
														"%{group} is now the primary application flow.",
													),
												],
												[
													Type.bitstring("screening.flash.group_ready"),
													Type.bitstring(
														"%{group} is ready. Add a question to save it.",
													),
												],
												[
													Type.bitstring("screening.flash.prompt_added"),
													Type.bitstring("Prompt added to %{group}."),
												],
												[
													Type.bitstring("screening.flash.prompt_moved"),
													Type.bitstring("Prompt order updated."),
												],
												[
													Type.bitstring("screening.flash.prompt_removed"),
													Type.bitstring("Prompt removed."),
												],
												[
													Type.bitstring("screening.flash.prompt_updated"),
													Type.bitstring("Prompt settings saved."),
												],
												[
													Type.bitstring("screening.flash.question_created"),
													Type.bitstring(
														"Question created and added to %{group}.",
													),
												],
												[
													Type.bitstring("screening.flash.question_updated"),
													Type.bitstring(
														"Question wording updated everywhere this reusable question appears.",
													),
												],
												[
													Type.bitstring("screening.flash.system_created"),
													Type.bitstring("System question created."),
												],
												[
													Type.bitstring("screening.flash.system_deactivated"),
													Type.bitstring(
														"System question deactivated. Existing prompt history is preserved.",
													),
												],
												[
													Type.bitstring("screening.flash.system_reactivated"),
													Type.bitstring(
														"System question reactivated for future prompt authoring.",
													),
												],
												[
													Type.bitstring("screening.flash.system_updated"),
													Type.bitstring("System question updated."),
												],
												[
													Type.bitstring("screening.flow.empty_help"),
													Type.bitstring(
														"Search the shared library or create the first question above.",
													),
												],
												[
													Type.bitstring("screening.flow.empty_title"),
													Type.bitstring("No questions in this group"),
												],
												[
													Type.bitstring("screening.flow.eyebrow"),
													Type.bitstring("Flow order"),
												],
												[
													Type.bitstring("screening.flow.heading"),
													Type.bitstring("Configured questions"),
												],
												[
													Type.bitstring("screening.group.add_another"),
													Type.bitstring("Add another group"),
												],
												[
													Type.bitstring("screening.group.application"),
													Type.bitstring("Application"),
												],
												[
													Type.bitstring("screening.group.fallback"),
													Type.bitstring("Group"),
												],
												[
													Type.bitstring("screening.group.manage"),
													Type.bitstring("Manage question groups"),
												],
												[
													Type.bitstring("screening.group.name_help"),
													Type.bitstring(
														"The group appears immediately as a draft and is saved with its first question.",
													),
												],
												[
													Type.bitstring("screening.group.name_label"),
													Type.bitstring("Group name"),
												],
												[
													Type.bitstring("screening.group.name_placeholder"),
													Type.bitstring("Interview questions"),
												],
												[
													Type.bitstring("screening.group.order_help"),
													Type.bitstring(
														"Applicants answer these questions from top to bottom.",
													),
												],
												[
													Type.bitstring("screening.group.prompt_group"),
													Type.bitstring("Prompt group"),
												],
												[
													Type.bitstring("screening.groups.aria_label"),
													Type.bitstring("Prompt groups"),
												],
												[
													Type.bitstring("screening.groups.eyebrow"),
													Type.bitstring("Question sets"),
												],
												[
													Type.bitstring("screening.groups.heading"),
													Type.bitstring("Prompt groups"),
												],
												[
													Type.bitstring("screening.library.description"),
													Type.bitstring("System questions appear first."),
												],
												[
													Type.bitstring("screening.library.heading"),
													Type.bitstring("Add a reusable question"),
												],
												[
													Type.bitstring("screening.library.no_results"),
													Type.bitstring(
														"No reusable question matched. Try different wording or create a scoped question below.",
													),
												],
												[
													Type.bitstring(
														"screening.library.results_aria_label",
													),
													Type.bitstring("Reusable questions"),
												],
												[
													Type.bitstring("screening.library.search_help"),
													Type.bitstring(
														"Matches appear as you type. Select a question to add it.",
													),
												],
												[
													Type.bitstring("screening.library.search_label"),
													Type.bitstring("Search reusable questions"),
												],
												[
													Type.bitstring(
														"screening.library.search_placeholder",
													),
													Type.bitstring("Find a question"),
												],
												[
													Type.bitstring("screening.library.searching"),
													Type.bitstring("Searching the question library…"),
												],
												[
													Type.bitstring("screening.listing.back"),
													Type.bitstring("Back to managed listings"),
												],
												[
													Type.bitstring("screening.listing.description"),
													Type.bitstring(
														"Add questions and set the answers applicants need to qualify.",
													),
												],
												[
													Type.bitstring("screening.listing.eyebrow"),
													Type.bitstring("Screening authoring"),
												],
												[
													Type.bitstring("screening.listing.fallback"),
													Type.bitstring("Listing"),
												],
												[
													Type.bitstring("screening.listing.language_help"),
													Type.bitstring(
														"Questions are matched automatically to this listing.",
													),
												],
												[
													Type.bitstring("screening.listing.language_label"),
													Type.bitstring("Listing language"),
												],
												[
													Type.bitstring("screening.listing.no_primary_help"),
													Type.bitstring(
														"Add the first question to the Application group, or make another saved group primary before applicants respond.",
													),
												],
												[
													Type.bitstring("screening.listing.no_primary_title"),
													Type.bitstring(
														"No saved primary application flow yet",
													),
												],
												[
													Type.bitstring("screening.listing.page_title"),
													Type.bitstring("Screening setup"),
												],
												[
													Type.bitstring("screening.locale.fallback"),
													Type.bitstring("Locale"),
												],
												[
													Type.bitstring("screening.operator.contains"),
													Type.bitstring("Answer contains (text questions)"),
												],
												[
													Type.bitstring("screening.operator.eq"),
													Type.bitstring("Answer equals"),
												],
												[
													Type.bitstring("screening.operator.exists"),
													Type.bitstring("Has any answer"),
												],
												[
													Type.bitstring("screening.operator.gt"),
													Type.bitstring("Answer is greater than"),
												],
												[
													Type.bitstring("screening.operator.gte"),
													Type.bitstring("Answer is at least"),
												],
												[
													Type.bitstring("screening.operator.in"),
													Type.bitstring("Answer is one of"),
												],
												[
													Type.bitstring("screening.operator.lt"),
													Type.bitstring("Answer is less than"),
												],
												[
													Type.bitstring("screening.operator.lte"),
													Type.bitstring("Answer is at most"),
												],
												[
													Type.bitstring("screening.operator.neq"),
													Type.bitstring("Answer does not equal"),
												],
												[
													Type.bitstring("screening.operator.not_contains"),
													Type.bitstring("Answer does not contain"),
												],
												[
													Type.bitstring("screening.operator.not_exists"),
													Type.bitstring("Has no answer"),
												],
												[
													Type.bitstring("screening.operator.not_in"),
													Type.bitstring("Answer is none of"),
												],
												[
													Type.bitstring("screening.pagination.aria_label"),
													Type.bitstring("System question pagination"),
												],
												[
													Type.bitstring("screening.pagination.next"),
													Type.bitstring("Next"),
												],
												[
													Type.bitstring("screening.pagination.previous"),
													Type.bitstring("Previous"),
												],
												[
													Type.bitstring("screening.pagination.summary"),
													Type.bitstring("Page %{page} of %{total_pages}"),
												],
												[
													Type.bitstring("screening.phase.back"),
													Type.bitstring("Listing screening"),
												],
												[
													Type.bitstring("screening.phase.empty_help"),
													Type.bitstring(
														"Create the first set from listing screening.",
													),
												],
												[
													Type.bitstring("screening.phase.empty_title"),
													Type.bitstring(
														"No question sets have been configured",
													),
												],
												[
													Type.bitstring("screening.phase.eyebrow"),
													Type.bitstring("Tracker phase"),
												],
												[
													Type.bitstring("screening.phase.fallback"),
													Type.bitstring("Phase"),
												],
												[
													Type.bitstring("screening.phase.manage_sets"),
													Type.bitstring("Manage listing question sets"),
												],
												[
													Type.bitstring("screening.phase.page_title"),
													Type.bitstring("Phase screening setup"),
												],
												[
													Type.bitstring("screening.phase.preview_eyebrow"),
													Type.bitstring("Read-only preview"),
												],
												[
													Type.bitstring("screening.phase.sets_heading"),
													Type.bitstring("Listing question sets"),
												],
												[
													Type.bitstring("screening.phase.unconfigured_help"),
													Type.bitstring(
														"Question sets are currently owned by the listing. This page intentionally stays read-only until the tracker data contract defines which set a phase references.",
													),
												],
												[
													Type.bitstring("screening.phase.unconfigured_title"),
													Type.bitstring(
														"Phase attachment is not configured yet",
													),
												],
												[
													Type.bitstring("screening.prompt.optional_help"),
													Type.bitstring(
														"Questions require an answer by default. Enable this when applicants may continue without answering.",
													),
												],
												[
													Type.bitstring("screening.prompt.optional_label"),
													Type.bitstring("Optional question"),
												],
												[
													Type.bitstring("screening.prompt.reorder_help"),
													Type.bitstring(
														"Drag to reorder, or focus this handle and use the Up and Down arrow keys.",
													),
												],
												[
													Type.bitstring("screening.prompt.required_legend"),
													Type.bitstring("Required question"),
												],
												[
													Type.bitstring("screening.prompt.settings_heading"),
													Type.bitstring("Settings"),
												],
												[
													Type.bitstring(
														"screening.question.answer_type_label",
													),
													Type.bitstring("Answer type"),
												],
												[
													Type.bitstring("screening.question.choice_only"),
													Type.bitstring("choice type only"),
												],
												[
													Type.bitstring(
														"screening.question.choice_options_help",
													),
													Type.bitstring(
														"One option per line. Use stable_key | Applicant label when integrations need a stable value.",
													),
												],
												[
													Type.bitstring(
														"screening.question.choice_options_label",
													),
													Type.bitstring("Choice options"),
												],
												[
													Type.bitstring(
														"screening.question.choice_options_placeholder",
													),
													Type.bitstring("Yes\nNo\nother | Something else"),
												],
												[
													Type.bitstring("screening.question.create_heading"),
													Type.bitstring("Create a question"),
												],
												[
													Type.bitstring("screening.question.edit_wording"),
													Type.bitstring("Edit question wording"),
												],
												[
													Type.bitstring(
														"screening.question.edit_wording_help",
													),
													Type.bitstring(
														"Wording and help update wherever this question appears in this listing. Answer type and saved answers remain unchanged.",
													),
												],
												[
													Type.bitstring("screening.question.help_label"),
													Type.bitstring("Supporting help"),
												],
												[
													Type.bitstring("screening.question.help_placeholder"),
													Type.bitstring(
														"Add context or instructions shown beneath the question",
													),
												],
												[
													Type.bitstring("screening.question.optional_group"),
													Type.bitstring("Make this question optional"),
												],
												[
													Type.bitstring(
														"screening.question.optional_group_help",
													),
													Type.bitstring(
														"Questions require an answer by default. Enable this only when applicants may skip it.",
													),
												],
												[
													Type.bitstring("screening.question.options_label"),
													Type.bitstring("Options"),
												],
												[
													Type.bitstring("screening.question.reuse_account"),
													Type.bitstring("This account"),
												],
												[
													Type.bitstring(
														"screening.question.reuse_account_help",
													),
													Type.bitstring(
														"Future listings for this account may reuse the answer.",
													),
												],
												[
													Type.bitstring("screening.question.reuse_label"),
													Type.bitstring("Answer reuse"),
												],
												[
													Type.bitstring("screening.question.reuse_listing"),
													Type.bitstring("This listing"),
												],
												[
													Type.bitstring(
														"screening.question.reuse_listing_help",
													),
													Type.bitstring(
														"Answers stay local to this opportunity.",
													),
												],
												[
													Type.bitstring("screening.question.this"),
													Type.bitstring("this question"),
												],
												[
													Type.bitstring("screening.question.wording_label"),
													Type.bitstring("Question wording"),
												],
												[
													Type.bitstring(
														"screening.question.wording_placeholder",
													),
													Type.bitstring(
														"What would you like applicants to answer?",
													),
												],
												[
													Type.bitstring("screening.requirement.add"),
													Type.bitstring("Set a requirement"),
												],
												[
													Type.bitstring("screening.requirement.heading"),
													Type.bitstring("Requirement"),
												],
												[
													Type.bitstring("screening.requirement.help"),
													Type.bitstring(
														"Set an answer applicants must meet to qualify, or leave this question without a requirement.",
													),
												],
												[
													Type.bitstring("screening.requirement.locked"),
													Type.bitstring(
														"These requirements are managed by Leaply administrators and cannot be changed here.",
													),
												],
												[
													Type.bitstring("screening.requirement.remove"),
													Type.bitstring("Remove requirement"),
												],
												[
													Type.bitstring(
														"screening.requirement.required_notice",
													),
													Type.bitstring(
														"Questions with a requirement need an answer. Applicants are never shown which answer caused an unsuccessful screening result.",
													),
												],
												[
													Type.bitstring(
														"screening.requirement.summary.configured",
													),
													Type.bitstring("Requirement configured."),
												],
												[
													Type.bitstring(
														"screening.requirement.summary.contains",
													),
													Type.bitstring(
														"Requirement: answer contains %{value}.",
													),
												],
												[
													Type.bitstring("screening.requirement.summary.eq"),
													Type.bitstring(
														"Requirement: answer equals %{value}.",
													),
												],
												[
													Type.bitstring("screening.requirement.summary.gt"),
													Type.bitstring(
														"Requirement: answer is greater than %{value}.",
													),
												],
												[
													Type.bitstring("screening.requirement.summary.gte"),
													Type.bitstring(
														"Requirement: answer is at least %{value}.",
													),
												],
												[
													Type.bitstring("screening.requirement.summary.in"),
													Type.bitstring(
														"Requirement: answer is one of %{value}.",
													),
												],
												[
													Type.bitstring("screening.requirement.summary.lt"),
													Type.bitstring(
														"Requirement: answer is less than %{value}.",
													),
												],
												[
													Type.bitstring("screening.requirement.summary.lte"),
													Type.bitstring(
														"Requirement: answer is at most %{value}.",
													),
												],
												[
													Type.bitstring("screening.requirement.summary.neq"),
													Type.bitstring(
														"Requirement: answer does not equal %{value}.",
													),
												],
												[
													Type.bitstring(
														"screening.requirement.summary.not_contains",
													),
													Type.bitstring(
														"Requirement: answer does not contain %{value}.",
													),
												],
												[
													Type.bitstring(
														"screening.requirement.summary.not_in",
													),
													Type.bitstring(
														"Requirement: answer is none of %{value}.",
													),
												],
												[
													Type.bitstring("screening.response.choose_answer"),
													Type.bitstring("Choose an answer"),
												],
												[
													Type.bitstring(
														"screening.response.constraint.length_range",
													),
													Type.bitstring("Character count: %{min}–%{max}."),
												],
												[
													Type.bitstring(
														"screening.response.constraint.max_length",
													),
													Type.bitstring("Character limit: %{max}."),
												],
												[
													Type.bitstring(
														"screening.response.constraint.number_max",
													),
													Type.bitstring("Maximum %{max}."),
												],
												[
													Type.bitstring(
														"screening.response.constraint.number_min",
													),
													Type.bitstring("Minimum %{min}."),
												],
												[
													Type.bitstring(
														"screening.response.constraint.number_range",
													),
													Type.bitstring("Between %{min} and %{max}."),
												],
												[
													Type.bitstring("screening.response.file_unavailable"),
													Type.bitstring(
														"File answers are not available in the current response flow.",
													),
												],
												[
													Type.bitstring("screening.scope.account"),
													Type.bitstring("Account"),
												],
												[
													Type.bitstring("screening.scope.listing"),
													Type.bitstring("Listing"),
												],
												[
													Type.bitstring("screening.scope.system"),
													Type.bitstring("System"),
												],
												[
													Type.bitstring("screening.scope.unknown"),
													Type.bitstring("Unknown scope"),
												],
												[
													Type.bitstring("screening.status.active"),
													Type.bitstring("Active"),
												],
												[
													Type.bitstring("screening.status.conditional"),
													Type.bitstring("Conditional"),
												],
												[
													Type.bitstring("screening.status.draft_group"),
													Type.bitstring("Draft group"),
												],
												[
													Type.bitstring("screening.status.inactive"),
													Type.bitstring("Inactive"),
												],
												[
													Type.bitstring("screening.status.inactive_history"),
													Type.bitstring("Inactive history"),
												],
												[
													Type.bitstring("screening.status.primary"),
													Type.bitstring("Primary"),
												],
												[
													Type.bitstring(
														"screening.status.primary_after_first",
													),
													Type.bitstring(
														"Will become primary with its first question",
													),
												],
												[
													Type.bitstring("screening.status.primary_flow"),
													Type.bitstring("Primary application flow"),
												],
												[
													Type.bitstring("screening.status.required"),
													Type.bitstring("Required"),
												],
												[
													Type.bitstring("screening.status.unsaved"),
													Type.bitstring("unsaved"),
												],
												[
													Type.bitstring("screening.status.will_be_primary"),
													Type.bitstring("Will be primary"),
												],
												[
													Type.bitstring(
														"screening.tracker.currently_ineligible",
													),
													Type.bitstring("Currently ineligible"),
												],
												[
													Type.bitstring("screening.tracker.ineligible_since"),
													Type.bitstring(
														"Screening eligibility changed on %{date}. This application remains active.",
													),
												],
												[
													Type.bitstring(
														"screening.tracker.ineligible_since_terminal",
													),
													Type.bitstring(
														"Screening eligibility changed on %{date}.",
													),
												],
												[
													Type.bitstring(
														"screening.validation.choice.keys_duplicate",
													),
													Type.bitstring(
														"contains duplicate choice option keys",
													),
												],
												[
													Type.bitstring(
														"screening.validation.choice.option_invalid",
													),
													Type.bitstring("contains an invalid choice option"),
												],
												[
													Type.bitstring(
														"screening.validation.choice.options_required",
													),
													Type.bitstring(
														"must include at least one keyed choice option",
													),
												],
												[
													Type.bitstring(
														"screening.validation.condition.earlier_question",
													),
													Type.bitstring(
														"must reference an earlier question in the same group",
													),
												],
												[
													Type.bitstring(
														"screening.validation.condition.earlier_question_uid",
													),
													Type.bitstring(
														"must reference an earlier question by UID",
													),
												],
												[
													Type.bitstring(
														"screening.validation.condition.invalid",
													),
													Type.bitstring(
														"Choose a valid earlier question and visibility rule.",
													),
												],
												[
													Type.bitstring(
														"screening.validation.configuration.object",
													),
													Type.bitstring("must be an object"),
												],
												[
													Type.bitstring(
														"screening.validation.eligibility_conditions.invalid",
													),
													Type.bitstring(
														"contains invalid eligibility conditions",
													),
												],
												[
													Type.bitstring(
														"screening.validation.eligibility_conditions.required",
													),
													Type.bitstring(
														"must be required when eligibility conditions are configured",
													),
												],
												[
													Type.bitstring(
														"screening.validation.field.account_id",
													),
													Type.bitstring("Account"),
												],
												[
													Type.bitstring(
														"screening.validation.field.answer_kind",
													),
													Type.bitstring("Answer type"),
												],
												[
													Type.bitstring("screening.validation.field.base"),
													Type.bitstring("Request"),
												],
												[
													Type.bitstring(
														"screening.validation.field.configuration",
													),
													Type.bitstring("Configuration"),
												],
												[
													Type.bitstring(
														"screening.validation.field.group_key",
													),
													Type.bitstring("Group"),
												],
												[
													Type.bitstring(
														"screening.validation.field.help_text",
													),
													Type.bitstring("Supporting help"),
												],
												[
													Type.bitstring("screening.validation.field.label"),
													Type.bitstring("Question wording"),
												],
												[
													Type.bitstring(
														"screening.validation.field.listing_id",
													),
													Type.bitstring("Listing"),
												],
												[
													Type.bitstring("screening.validation.field.locale"),
													Type.bitstring("Locale"),
												],
												[
													Type.bitstring("screening.validation.field.logic"),
													Type.bitstring("Visibility rule"),
												],
												[
													Type.bitstring("screening.validation.field.position"),
													Type.bitstring("Position"),
												],
												[
													Type.bitstring("screening.validation.field.primary"),
													Type.bitstring("Primary flow"),
												],
												[
													Type.bitstring(
														"screening.validation.field.question_id",
													),
													Type.bitstring("Question"),
												],
												[
													Type.bitstring("screening.validation.field.scope"),
													Type.bitstring("Answer reuse"),
												],
												[
													Type.bitstring("screening.validation.group.blank"),
													Type.bitstring("can't be blank"),
												],
												[
													Type.bitstring(
														"screening.validation.group.change_after_started",
													),
													Type.bitstring(
														"cannot be changed after applicants have started this group",
													),
												],
												[
													Type.bitstring(
														"screening.validation.group.delete_after_started",
													),
													Type.bitstring(
														"cannot be deleted after applicants have started this group",
													),
												],
												[
													Type.bitstring(
														"screening.validation.group.delete_primary_after_listing_started",
													),
													Type.bitstring(
														"cannot be deleted after applicants have started this listing",
													),
												],
												[
													Type.bitstring("screening.validation.group.missing"),
													Type.bitstring("does not exist"),
												],
												[
													Type.bitstring(
														"screening.validation.group.primary_after_listing_started",
													),
													Type.bitstring(
														"cannot be changed after applicants have started this listing",
													),
												],
												[
													Type.bitstring(
														"screening.validation.group.prompt_required",
													),
													Type.bitstring("must contain a prompt first"),
												],
												[
													Type.bitstring(
														"screening.validation.group_name.blank",
													),
													Type.bitstring("Group name can't be blank."),
												],
												[
													Type.bitstring(
														"screening.validation.group_name.taken",
													),
													Type.bitstring(
														"A group with that name already exists.",
													),
												],
												[
													Type.bitstring(
														"screening.validation.group_name.too_long",
													),
													Type.bitstring(
														"Group name must be 80 characters or fewer.",
													),
												],
												[
													Type.bitstring(
														"screening.validation.listing.missing",
													),
													Type.bitstring(
														"does not identify an existing listing",
													),
												],
												[
													Type.bitstring("screening.validation.locale.invalid"),
													Type.bitstring("is invalid"),
												],
												[
													Type.bitstring(
														"screening.validation.locale.listing_mismatch",
													),
													Type.bitstring(
														"%{question_locale} does not match listing locale %{listing_locale}",
													),
												],
												[
													Type.bitstring(
														"screening.validation.primary.already_exists",
													),
													Type.bitstring(
														"another group is already primary for this listing",
													),
												],
												[
													Type.bitstring(
														"screening.validation.primary.file_unsupported",
													),
													Type.bitstring(
														"file questions are not supported in the primary flow",
													),
												],
												[
													Type.bitstring(
														"screening.validation.primary.group_mismatch",
													),
													Type.bitstring(
														"must match every prompt in this group",
													),
												],
												[
													Type.bitstring(
														"screening.validation.primary.inconsistent",
													),
													Type.bitstring(
														"group has inconsistent primary values",
													),
												],
												[
													Type.bitstring("screening.validation.prompt.missing"),
													Type.bitstring("prompt not found"),
												],
												[
													Type.bitstring(
														"screening.validation.prompt.move_after_started",
													),
													Type.bitstring(
														"cannot be changed after applicants have started this group",
													),
												],
												[
													Type.bitstring(
														"screening.validation.prompt.object_required",
													),
													Type.bitstring("must be an object"),
												],
												[
													Type.bitstring(
														"screening.validation.prompt.remove_after_started",
													),
													Type.bitstring(
														"cannot remove prompts after applicants have started this group",
													),
												],
												[
													Type.bitstring(
														"screening.validation.question.duplicate_in_group",
													),
													Type.bitstring("is already in this prompt group"),
												],
												[
													Type.bitstring(
														"screening.validation.question.editable_fields_only",
													),
													Type.bitstring(
														"Only question wording and help text can be updated here.",
													),
												],
												[
													Type.bitstring(
														"screening.validation.question.inactive",
													),
													Type.bitstring(
														"question is inactive and cannot be added to new prompts",
													),
												],
												[
													Type.bitstring(
														"screening.validation.question.locale_mismatch",
													),
													Type.bitstring(
														"question locale %{question_locale} does not match listing locale %{listing_locale}",
													),
												],
												[
													Type.bitstring(
														"screening.validation.question.missing",
													),
													Type.bitstring("question not found"),
												],
												[
													Type.bitstring(
														"screening.validation.question.object_required",
													),
													Type.bitstring(
														"Question details must be submitted as an object.",
													),
												],
												[
													Type.bitstring(
														"screening.validation.question.outside_boundary",
													),
													Type.bitstring(
														"is outside this listing's reuse boundary",
													),
												],
												[
													Type.bitstring(
														"screening.validation.question.semantics_immutable",
													),
													Type.bitstring(
														"is immutable; create a new question for new semantics",
													),
												],
												[
													Type.bitstring(
														"screening.validation.scope.boundary_mismatch",
													),
													Type.bitstring(
														"does not match the question reuse boundary",
													),
												],
												[
													Type.bitstring(
														"screening.validation.scope.employee_required",
													),
													Type.bitstring(
														"system-scoped questions require a Leaply employee role",
													),
												],
												[
													Type.bitstring(
														"screening.validation.scope.immutable",
													),
													Type.bitstring(
														"cannot be changed after a question has been created",
													),
												],
											]),
										],
									]),
								],
								[
									Type.bitstring("shared"),
									Type.map([
										[Type.atom("plural"), Type.map([])],
										[
											Type.atom("singular"),
											Type.map([
												[
													Type.bitstring("shared.locale.en_GB"),
													Type.bitstring("English (United Kingdom)"),
												],
												[
													Type.bitstring("shared.locale.en_NG"),
													Type.bitstring("English (Nigeria)"),
												],
												[
													Type.bitstring("shared.locale.en_US"),
													Type.bitstring("English (United States)"),
												],
												[
													Type.bitstring("shared.locale.en_ZA"),
													Type.bitstring("English (South Africa)"),
												],
												[
													Type.bitstring(
														"shared.navigation.academic-catalogue",
													),
													Type.bitstring("Academic catalogue"),
												],
												[
													Type.bitstring("shared.navigation.admin"),
													Type.bitstring("Admin"),
												],
												[
													Type.bitstring("shared.navigation.admin_menu"),
													Type.bitstring("Admin menu"),
												],
												[
													Type.bitstring("shared.navigation.administration"),
													Type.bitstring("Administration"),
												],
												[
													Type.bitstring("shared.navigation.applications"),
													Type.bitstring("My applications"),
												],
												[
													Type.bitstring("shared.navigation.breadcrumbs"),
													Type.bitstring("Breadcrumbs"),
												],
												[
													Type.bitstring("shared.navigation.data-browser"),
													Type.bitstring("Data browser"),
												],
												[
													Type.bitstring("shared.navigation.design-system"),
													Type.bitstring("Design system"),
												],
												[
													Type.bitstring("shared.navigation.documentation"),
													Type.bitstring("Documentation"),
												],
												[
													Type.bitstring("shared.navigation.handbooks"),
													Type.bitstring("Faculty handbooks"),
												],
												[
													Type.bitstring("shared.navigation.home"),
													Type.bitstring("Leaply home"),
												],
												[
													Type.bitstring("shared.navigation.identity-reviews"),
													Type.bitstring("Identity reviews"),
												],
												[
													Type.bitstring(
														"shared.navigation.institution-reviews",
													),
													Type.bitstring("Institution reviews"),
												],
												[
													Type.bitstring("shared.navigation.logout"),
													Type.bitstring("Log out"),
												],
												[
													Type.bitstring("shared.navigation.managed-listings"),
													Type.bitstring("Managed listings"),
												],
												[
													Type.bitstring("shared.navigation.menu"),
													Type.bitstring("Leaply menu"),
												],
												[
													Type.bitstring("shared.navigation.opportunities"),
													Type.bitstring("Opportunities"),
												],
												[
													Type.bitstring("shared.navigation.personal"),
													Type.bitstring("Personal"),
												],
												[
													Type.bitstring("shared.navigation.professional"),
													Type.bitstring("Professional profile"),
												],
												[
													Type.bitstring("shared.navigation.settings"),
													Type.bitstring("Settings"),
												],
												[
													Type.bitstring("shared.navigation.signed_in"),
													Type.bitstring("Signed in"),
												],
												[
													Type.bitstring("shared.navigation.system-questions"),
													Type.bitstring("System questions"),
												],
												[
													Type.bitstring("shared.navigation.tools"),
													Type.bitstring("Tools"),
												],
												[
													Type.bitstring("shared.navigation.work"),
													Type.bitstring("Work"),
												],
												[
													Type.bitstring("shared.theme.dark"),
													Type.bitstring("Dark"),
												],
												[
													Type.bitstring("shared.theme.light"),
													Type.bitstring("Light"),
												],
												[
													Type.bitstring("shared.theme.switch_to_dark"),
													Type.bitstring("Switch to dark mode"),
												],
												[
													Type.bitstring("shared.theme.switch_to_light"),
													Type.bitstring("Switch to light mode"),
												],
											]),
										],
									]),
								],
								[
									Type.bitstring("tracker"),
									Type.map([
										[
											Type.atom("plural"),
											Type.map([
												[
													Type.bitstring("tracker.count.application"),
													Type.tuple([
														Type.bitstring("tracker.count.applications"),
														Type.map([
															[
																Type.integer(0n),
																Type.bitstring("%{count} application"),
															],
															[
																Type.integer(1n),
																Type.bitstring("%{count} applications"),
															],
														]),
													]),
												],
											]),
										],
										[
											Type.atom("singular"),
											Type.map([
												[
													Type.bitstring("tracker.action.view_profile"),
													Type.bitstring("View profile"),
												],
												[
													Type.bitstring("tracker.empty.applications"),
													Type.bitstring(
														"No visible applicants or respondents for this listing.",
													),
												],
												[
													Type.bitstring("tracker.fallback.account"),
													Type.bitstring("Account"),
												],
												[
													Type.bitstring("tracker.fallback.applicant"),
													Type.bitstring("Applicant"),
												],
												[
													Type.bitstring("tracker.fallback.title"),
													Type.bitstring("Tracker"),
												],
												[
													Type.bitstring("tracker.filter.apply"),
													Type.bitstring("Apply filters"),
												],
												[
													Type.bitstring("tracker.filter.search_label"),
													Type.bitstring("Search"),
												],
												[
													Type.bitstring("tracker.filter.search_placeholder"),
													Type.bitstring("Search visible names"),
												],
												[
													Type.bitstring("tracker.filter.state_label"),
													Type.bitstring("State"),
												],
												[
													Type.bitstring("tracker.mode.applicants"),
													Type.bitstring("Applicants"),
												],
												[
													Type.bitstring("tracker.mode.applications"),
													Type.bitstring("Applications"),
												],
												[
													Type.bitstring("tracker.mode.respondents"),
													Type.bitstring("Respondents"),
												],
												[
													Type.bitstring("tracker.mode.screening"),
													Type.bitstring("Respondents with screening"),
												],
												[
													Type.bitstring("tracker.notice.applicant"),
													Type.bitstring(
														"Profile details are visible for these applicants.",
													),
												],
												[
													Type.bitstring("tracker.notice.mixed"),
													Type.bitstring(
														"Profile and screening visibility follows the grant recorded on each application.",
													),
												],
												[
													Type.bitstring("tracker.notice.respondent"),
													Type.bitstring(
														"Only basic respondent details are visible.",
													),
												],
												[
													Type.bitstring("tracker.notice.screening"),
													Type.bitstring(
														"Screening answers are visible for these respondents.",
													),
												],
												[
													Type.bitstring("tracker.pagination.next"),
													Type.bitstring("Next"),
												],
												[
													Type.bitstring("tracker.pagination.page"),
													Type.bitstring("Page %{page} of %{total}"),
												],
												[
													Type.bitstring("tracker.pagination.previous"),
													Type.bitstring("Previous"),
												],
												[
													Type.bitstring("tracker.phase.all"),
													Type.bitstring("All phases"),
												],
												[
													Type.bitstring("tracker.phase.heading"),
													Type.bitstring("Phases"),
												],
												[
													Type.bitstring("tracker.phase.hide_hidden"),
													Type.bitstring("Hide hidden phases"),
												],
												[
													Type.bitstring("tracker.phase.show_hidden"),
													Type.bitstring("Show hidden phases"),
												],
												[
													Type.bitstring("tracker.sort.application_time"),
													Type.bitstring("Sorted by application time"),
												],
												[
													Type.bitstring("tracker.sort.phase_movement"),
													Type.bitstring("Sorted by phase movement"),
												],
												[
													Type.bitstring("tracker.state.active"),
													Type.bitstring("Active"),
												],
												[
													Type.bitstring("tracker.state.all"),
													Type.bitstring("All"),
												],
												[
													Type.bitstring("tracker.state.not_set"),
													Type.bitstring("Not set"),
												],
												[
													Type.bitstring("tracker.state.successful"),
													Type.bitstring("Successful"),
												],
												[
													Type.bitstring("tracker.state.unsuccessful"),
													Type.bitstring("Unsuccessful"),
												],
												[
													Type.bitstring("tracker.state.withdrawn"),
													Type.bitstring("Withdrawn"),
												],
											]),
										],
									]),
								],
							]),
							context.vars.domain_0,
							Type.map([[Type.atom("singular"), Type.map([])]]),
						),
						Type.variablePattern("catalog_3"),
						context,
					);
					Interpreter.updateVarsToMatchedValues(context);
					Interpreter.matchOperator(
						Elixir_Map["get/3"](
							Elixir_Map["get/3"](
								context.vars.catalog_3,
								Type.atom("singular"),
								Type.map([]),
							),
							context.vars.key_1,
							context.vars.key_1,
						),
						Type.variablePattern("value_4"),
						context,
					);
					Interpreter.updateVarsToMatchedValues(context);
					return Elixir_LeaplyWeb_Hologram_Helpers_CatalogText["interpolate/2"](
						context.vars.value_4,
						context.vars.bindings_2,
					);
				},
			},
		],
	);

	Interpreter.defineElixirFunction(
		"LeaplyWeb.Hologram.Helpers.CatalogText",
		"interpolate",
		2,
		"private",
		[
			{
				params: (context) => [Type.variablePattern("text_0"), Type.list([])],
				guards: [],
				body: (context) => {
					return context.vars.text_0;
				},
			},
			{
				params: (context) => [
					Type.variablePattern("text_0"),
					Type.consPattern(
						Type.tuple([
							Type.variablePattern("key_1"),
							Type.variablePattern("value_2"),
						]),
						Type.variablePattern("bindings_3"),
					),
				],
				guards: [],
				body: (context) => {
					Interpreter.matchOperator(
						Type.bitstring([
							Type.bitstringSegment(Type.string("%{"), { type: "binary" }),
							Type.bitstringSegment(
								Erlang["atom_to_binary/1"](context.vars.key_1),
								{ type: "binary" },
							),
							Type.bitstringSegment(Type.string("}"), { type: "binary" }),
						]),
						Type.variablePattern("placeholder_4"),
						context,
					);
					Interpreter.updateVarsToMatchedValues(context);
					return Elixir_LeaplyWeb_Hologram_Helpers_CatalogText["interpolate/2"](
						Elixir_String["replace/3"](
							context.vars.text_0,
							context.vars.placeholder_4,
							Elixir_String_Chars["to_string/1"](context.vars.value_2),
						),
						context.vars.bindings_3,
					);
				},
			},
		],
	);

	Interpreter.defineElixirFunction(
		"LeaplyWeb.Hologram.Helpers.ReturnToQuery",
		"append",
		2,
		"public",
		[
			{
				params: (context) => [
					Type.variablePattern("path_0"),
					Type.variablePattern("return_to_1"),
				],
				guards: [
					(context) =>
						Erlang["andalso/2"](
							(context) =>
								Erlang["andalso/2"](
									(context) => Erlang["is_binary/1"](context.vars.path_0),
									(context) => Erlang["is_binary/1"](context.vars.return_to_1),
									context,
								),
							(context) =>
								Erlang["/=/2"](context.vars.return_to_1, Type.bitstring("")),
							context,
						),
				],
				body: (context) => {
					Interpreter.matchOperator(
						Interpreter.case(
							Elixir_String["contains?/2"](
								context.vars.path_0,
								Type.bitstring("?"),
							),
							[
								{
									match: Type.variablePattern("x_2"),
									guards: [
										(context) =>
											Erlang["orelse/2"](
												(context) =>
													Erlang["=:=/2"](context.vars.x_2, Type.atom("false")),
												(context) =>
													Erlang["=:=/2"](context.vars.x_2, Type.atom("nil")),
												context,
											),
									],
									body: (context) => {
										return Type.bitstring("?");
									},
								},
								{
									match: Type.matchPlaceholder(),
									guards: [],
									body: (context) => {
										return Type.bitstring("&");
									},
								},
							],
							context,
						),
						Type.variablePattern("separator_3"),
						context,
					);
					Interpreter.updateVarsToMatchedValues(context);
					return Type.bitstring([
						Type.bitstringSegment(context.vars.path_0, { type: "binary" }),
						Type.bitstringSegment(context.vars.separator_3, { type: "binary" }),
						Type.bitstringSegment(Type.string("return_to="), {
							type: "binary",
						}),
						Type.bitstringSegment(
							Elixir_LeaplyWeb_Hologram_Helpers_ReturnToQuery[
								"encode_www_form/1"
							](context.vars.return_to_1),
							{ type: "binary" },
						),
					]);
				},
			},
			{
				params: (context) => [
					Type.variablePattern("path_0"),
					Type.matchPlaceholder(),
				],
				guards: [(context) => Erlang["is_binary/1"](context.vars.path_0)],
				body: (context) => {
					return context.vars.path_0;
				},
			},
		],
	);

	Interpreter.defineElixirFunction(
		"LeaplyWeb.Hologram.Helpers.ReturnToQuery",
		"encode_byte",
		1,
		"private",
		[
			{
				params: (context) => [Type.integer(32n)],
				guards: [],
				body: (context) => {
					return Type.bitstring("+");
				},
			},
			{
				params: (context) => [Type.variablePattern("byte_0")],
				guards: [],
				body: (context) => {
					return Interpreter.case(
						Elixir_LeaplyWeb_Hologram_Helpers_ReturnToQuery["unreserved?/1"](
							context.vars.byte_0,
						),
						[
							{
								match: Type.variablePattern("x_1"),
								guards: [
									(context) =>
										Erlang["orelse/2"](
											(context) =>
												Erlang["=:=/2"](context.vars.x_1, Type.atom("false")),
											(context) =>
												Erlang["=:=/2"](context.vars.x_1, Type.atom("nil")),
											context,
										),
								],
								body: (context) => {
									return Type.bitstring([
										Type.bitstringSegment(Type.string("%"), { type: "binary" }),
										Type.bitstringSegment(
											Elixir_LeaplyWeb_Hologram_Helpers_ReturnToQuery[
												"hex_digit/1"
											](
												Erlang["div/2"](context.vars.byte_0, Type.integer(16n)),
											),
											{ type: "integer" },
										),
										Type.bitstringSegment(
											Elixir_LeaplyWeb_Hologram_Helpers_ReturnToQuery[
												"hex_digit/1"
											](
												Erlang["rem/2"](context.vars.byte_0, Type.integer(16n)),
											),
											{ type: "integer" },
										),
									]);
								},
							},
							{
								match: Type.matchPlaceholder(),
								guards: [],
								body: (context) => {
									return Type.bitstring([
										Type.bitstringSegment(context.vars.byte_0, {
											type: "integer",
										}),
									]);
								},
							},
						],
						context,
					);
				},
			},
		],
	);

	Interpreter.defineElixirFunction(
		"LeaplyWeb.Hologram.Helpers.ReturnToQuery",
		"encode_www_form",
		1,
		"private",
		[
			{
				params: (context) => [Type.bitstringPattern([])],
				guards: [],
				body: (context) => {
					return Type.bitstring("");
				},
			},
			{
				params: (context) => [
					Type.bitstringPattern([
						Type.bitstringSegment(Type.variablePattern("byte_0"), {
							type: "integer",
						}),
						Type.bitstringSegment(Type.variablePattern("rest_1"), {
							type: "binary",
						}),
					]),
				],
				guards: [],
				body: (context) => {
					return Type.bitstring([
						Type.bitstringSegment(
							Elixir_LeaplyWeb_Hologram_Helpers_ReturnToQuery["encode_byte/1"](
								context.vars.byte_0,
							),
							{ type: "binary" },
						),
						Type.bitstringSegment(
							Elixir_LeaplyWeb_Hologram_Helpers_ReturnToQuery[
								"encode_www_form/1"
							](context.vars.rest_1),
							{ type: "binary" },
						),
					]);
				},
			},
		],
	);

	Interpreter.defineElixirFunction(
		"LeaplyWeb.Hologram.Helpers.ReturnToQuery",
		"hex_digit",
		1,
		"private",
		[
			{
				params: (context) => [Type.variablePattern("value_0")],
				guards: [
					(context) => Erlang["</2"](context.vars.value_0, Type.integer(10n)),
				],
				body: (context) => {
					return Erlang["+/2"](Type.integer(48n), context.vars.value_0);
				},
			},
			{
				params: (context) => [Type.variablePattern("value_0")],
				guards: [],
				body: (context) => {
					return Erlang["-/2"](
						Erlang["+/2"](Type.integer(65n), context.vars.value_0),
						Type.integer(10n),
					);
				},
			},
		],
	);

	Interpreter.defineElixirFunction(
		"LeaplyWeb.Hologram.Helpers.ReturnToQuery",
		"unreserved?",
		1,
		"private",
		[
			{
				params: (context) => [Type.variablePattern("byte_0")],
				guards: [],
				body: (context) => {
					return Interpreter.case(
						Interpreter.case(
							Interpreter.case(
								Interpreter.case(
									Interpreter.case(
										Interpreter.case(
											Interpreter.case(
												Erlang[">=/2"](context.vars.byte_0, Type.integer(65n)),
												[
													{
														match: Type.atom("false"),
														guards: [],
														body: (context) => {
															return Type.atom("false");
														},
													},
													{
														match: Type.atom("true"),
														guards: [],
														body: (context) => {
															return Erlang["=</2"](
																context.vars.byte_0,
																Type.integer(90n),
															);
														},
													},
												],
												context,
											),
											[
												{
													match: Type.atom("false"),
													guards: [],
													body: (context) => {
														return Interpreter.case(
															Erlang[">=/2"](
																context.vars.byte_0,
																Type.integer(97n),
															),
															[
																{
																	match: Type.atom("false"),
																	guards: [],
																	body: (context) => {
																		return Type.atom("false");
																	},
																},
																{
																	match: Type.atom("true"),
																	guards: [],
																	body: (context) => {
																		return Erlang["=</2"](
																			context.vars.byte_0,
																			Type.integer(122n),
																		);
																	},
																},
															],
															context,
														);
													},
												},
												{
													match: Type.atom("true"),
													guards: [],
													body: (context) => {
														return Type.atom("true");
													},
												},
											],
											context,
										),
										[
											{
												match: Type.atom("false"),
												guards: [],
												body: (context) => {
													return Interpreter.case(
														Erlang[">=/2"](
															context.vars.byte_0,
															Type.integer(48n),
														),
														[
															{
																match: Type.atom("false"),
																guards: [],
																body: (context) => {
																	return Type.atom("false");
																},
															},
															{
																match: Type.atom("true"),
																guards: [],
																body: (context) => {
																	return Erlang["=</2"](
																		context.vars.byte_0,
																		Type.integer(57n),
																	);
																},
															},
														],
														context,
													);
												},
											},
											{
												match: Type.atom("true"),
												guards: [],
												body: (context) => {
													return Type.atom("true");
												},
											},
										],
										context,
									),
									[
										{
											match: Type.atom("false"),
											guards: [],
											body: (context) => {
												return Erlang["==/2"](
													context.vars.byte_0,
													Type.integer(45n),
												);
											},
										},
										{
											match: Type.atom("true"),
											guards: [],
											body: (context) => {
												return Type.atom("true");
											},
										},
									],
									context,
								),
								[
									{
										match: Type.atom("false"),
										guards: [],
										body: (context) => {
											return Erlang["==/2"](
												context.vars.byte_0,
												Type.integer(95n),
											);
										},
									},
									{
										match: Type.atom("true"),
										guards: [],
										body: (context) => {
											return Type.atom("true");
										},
									},
								],
								context,
							),
							[
								{
									match: Type.atom("false"),
									guards: [],
									body: (context) => {
										return Erlang["==/2"](
											context.vars.byte_0,
											Type.integer(46n),
										);
									},
								},
								{
									match: Type.atom("true"),
									guards: [],
									body: (context) => {
										return Type.atom("true");
									},
								},
							],
							context,
						),
						[
							{
								match: Type.atom("false"),
								guards: [],
								body: (context) => {
									return Erlang["==/2"](
										context.vars.byte_0,
										Type.integer(126n),
									);
								},
							},
							{
								match: Type.atom("true"),
								guards: [],
								body: (context) => {
									return Type.atom("true");
								},
							},
						],
						context,
					);
				},
			},
		],
	);

	Interpreter.defineElixirFunction(
		"LeaplyWeb.Hologram.Helpers.ThemeText",
		"get",
		1,
		"public",
		[
			{
				params: (context) => [Type.variablePattern("key_0")],
				guards: [],
				body: (context) => {
					return Elixir_Map["get/3"](
						Type.map([
							[Type.bitstring("shared.theme.dark"), Type.bitstring("Dark")],
							[Type.bitstring("shared.theme.light"), Type.bitstring("Light")],
							[
								Type.bitstring("shared.theme.switch_to_dark"),
								Type.bitstring("Switch to dark mode"),
							],
							[
								Type.bitstring("shared.theme.switch_to_light"),
								Type.bitstring("Switch to light mode"),
							],
						]),
						context.vars.key_0,
						context.vars.key_0,
					);
				},
			},
		],
	);

	Interpreter.defineElixirFunction(
		"LeaplyWeb.Hologram.Layouts.RootLayout",
		"__props__",
		0,
		"public",
		[
			{
				params: (context) => [],
				guards: [],
				body: (context) => {
					return Elixir_Enum["reverse/1"](
						Type.list([
							Type.tuple([
								Type.atom("show_global_flash"),
								Type.atom("boolean"),
								Type.list([
									Type.tuple([Type.atom("default"), Type.atom("true")]),
								]),
							]),
							Type.tuple([
								Type.atom("flash_error"),
								Type.atom("string"),
								Type.list([
									Type.tuple([Type.atom("default"), Type.atom("nil")]),
								]),
							]),
							Type.tuple([
								Type.atom("flash_info"),
								Type.atom("string"),
								Type.list([
									Type.tuple([Type.atom("default"), Type.atom("nil")]),
								]),
							]),
							Type.tuple([
								Type.atom("csrf_token"),
								Type.atom("string"),
								Type.list([
									Type.tuple([Type.atom("default"), Type.atom("nil")]),
									Type.tuple([
										Type.atom("from_context"),
										Type.tuple([
											Type.atom("Elixir.Hologram.Runtime"),
											Type.atom("csrf_token"),
										]),
									]),
								]),
							]),
							Type.tuple([
								Type.atom("structured_metadata"),
								Type.atom("map"),
								Type.list([
									Type.tuple([Type.atom("default"), Type.atom("nil")]),
								]),
							]),
							Type.tuple([
								Type.atom("profile_location"),
								Type.atom("string"),
								Type.list([
									Type.tuple([Type.atom("default"), Type.atom("nil")]),
									Type.tuple([
										Type.atom("from_context"),
										Type.tuple([
											Type.atom("Elixir.LeaplyWeb.ProfileLocation"),
											Type.atom("url"),
										]),
									]),
								]),
							]),
							Type.tuple([
								Type.atom("robots"),
								Type.atom("string"),
								Type.list([
									Type.tuple([Type.atom("default"), Type.atom("nil")]),
								]),
							]),
							Type.tuple([
								Type.atom("open_graph_image"),
								Type.atom("string"),
								Type.list([
									Type.tuple([Type.atom("default"), Type.atom("nil")]),
								]),
							]),
							Type.tuple([
								Type.atom("open_graph_url"),
								Type.atom("string"),
								Type.list([
									Type.tuple([Type.atom("default"), Type.atom("nil")]),
								]),
							]),
							Type.tuple([
								Type.atom("open_graph_description"),
								Type.atom("string"),
								Type.list([
									Type.tuple([Type.atom("default"), Type.atom("nil")]),
								]),
							]),
							Type.tuple([
								Type.atom("open_graph_title"),
								Type.atom("string"),
								Type.list([
									Type.tuple([Type.atom("default"), Type.atom("nil")]),
								]),
							]),
							Type.tuple([
								Type.atom("canonical_url"),
								Type.atom("string"),
								Type.list([
									Type.tuple([Type.atom("default"), Type.atom("nil")]),
								]),
							]),
							Type.tuple([
								Type.atom("page_description"),
								Type.atom("string"),
								Type.list([
									Type.tuple([Type.atom("default"), Type.atom("nil")]),
								]),
							]),
							Type.tuple([
								Type.atom("interface_context"),
								Type.atom("string"),
								Type.list([
									Type.tuple([
										Type.atom("default"),
										Type.bitstring("applicant"),
									]),
								]),
							]),
							Type.tuple([
								Type.atom("page_title"),
								Type.atom("string"),
								Type.list([
									Type.tuple([Type.atom("default"), Type.bitstring("Leaply")]),
								]),
							]),
							Type.tuple([
								Type.atom("navigation"),
								Type.atom("map"),
								Type.list([
									Type.tuple([Type.atom("default"), Type.atom("nil")]),
									Type.tuple([
										Type.atom("from_context"),
										Type.tuple([
											Type.atom("Elixir.LeaplyWeb.ApplicationNavigation"),
											Type.atom("navigation"),
										]),
									]),
								]),
							]),
						]),
					);
				},
			},
		],
	);

	Interpreter.defineElixirFunction(
		"LeaplyWeb.Hologram.Layouts.RootLayout",
		"action",
		3,
		"public",
		[
			{
				params: (context) => [
					Type.atom("restore_profile_location"),
					Type.matchPlaceholder(),
					Type.variablePattern("component_1"),
				],
				guards: [],
				body: (context) => {
					Elixir_Hologram_JS["exec/1"](
						Type.bitstring(
							'document.dispatchEvent(new CustomEvent("leaply:profile-location-ready"));\n',
						),
					);
					return context.vars.component_1;
				},
			},
		],
	);

	Interpreter.defineElixirFunction(
		"LeaplyWeb.Hologram.Layouts.RootLayout",
		"template",
		0,
		"public",
		[
			{
				params: (context) => [],
				guards: [],
				body: (context) => {
					globalThis.hologram.return = Type.anonymousFunction(
						1,
						[
							{
								params: (context) => [Type.variablePattern("vars_0")],
								guards: [],
								body: (context) => {
									Interpreter.matchOperator(
										context.vars.vars_0,
										Type.matchPlaceholder(),
										context,
									);
									Interpreter.updateVarsToMatchedValues(context);
									return Type.list([
										Type.tuple([Type.atom("doctype"), Type.bitstring("html")]),
										Type.tuple([Type.atom("text"), Type.bitstring("\n")]),
										Type.tuple([
											Type.atom("element"),
											Type.bitstring("html"),
											Type.list([
												Type.tuple([
													Type.bitstring("lang"),
													Type.list([
														Type.tuple([
															Type.atom("text"),
															Type.bitstring("en"),
														]),
													]),
												]),
												Type.tuple([
													Type.bitstring("data-interface-context"),
													Type.list([
														Type.tuple([
															Type.atom("expression"),
															Type.tuple([
																Interpreter.dotOperator(
																	context.vars.vars_0,
																	Type.atom("interface_context"),
																),
															]),
														]),
													]),
												]),
												Type.tuple([
													Type.bitstring("data-theme"),
													Type.list([
														Type.tuple([
															Type.atom("expression"),
															Type.tuple([
																Type.bitstring([
																	Type.bitstringSegment(
																		Type.string("leaply-"),
																		{ type: "binary" },
																	),
																	Type.bitstringSegment(
																		Elixir_String_Chars["to_string/1"](
																			Interpreter.dotOperator(
																				context.vars.vars_0,
																				Type.atom("interface_context"),
																			),
																		),
																		{ type: "binary" },
																	),
																	Type.bitstringSegment(Type.string("-light"), {
																		type: "binary",
																	}),
																]),
															]),
														]),
													]),
												]),
											]),
											Type.list([
												Type.tuple([Type.atom("text"), Type.bitstring("\n  ")]),
												Type.tuple([
													Type.atom("element"),
													Type.bitstring("head"),
													Type.list([]),
													Type.list([
														Type.tuple([
															Type.atom("text"),
															Type.bitstring("\n    "),
														]),
														Type.tuple([
															Type.atom("element"),
															Type.bitstring("meta"),
															Type.list([
																Type.tuple([
																	Type.bitstring("charset"),
																	Type.list([
																		Type.tuple([
																			Type.atom("text"),
																			Type.bitstring("utf-8"),
																		]),
																	]),
																]),
															]),
															Type.list([]),
														]),
														Type.tuple([
															Type.atom("text"),
															Type.bitstring("\n    "),
														]),
														Type.tuple([
															Type.atom("element"),
															Type.bitstring("meta"),
															Type.list([
																Type.tuple([
																	Type.bitstring("name"),
																	Type.list([
																		Type.tuple([
																			Type.atom("text"),
																			Type.bitstring("viewport"),
																		]),
																	]),
																]),
																Type.tuple([
																	Type.bitstring("content"),
																	Type.list([
																		Type.tuple([
																			Type.atom("text"),
																			Type.bitstring(
																				"width=device-width, initial-scale=1",
																			),
																		]),
																	]),
																]),
															]),
															Type.list([]),
														]),
														Type.tuple([
															Type.atom("text"),
															Type.bitstring("\n    "),
														]),
														Type.tuple([
															Type.atom("element"),
															Type.bitstring("meta"),
															Type.list([
																Type.tuple([
																	Type.bitstring("name"),
																	Type.list([
																		Type.tuple([
																			Type.atom("text"),
																			Type.bitstring("csrf-token"),
																		]),
																	]),
																]),
																Type.tuple([
																	Type.bitstring("content"),
																	Type.list([
																		Type.tuple([
																			Type.atom("expression"),
																			Type.tuple([
																				Interpreter.dotOperator(
																					context.vars.vars_0,
																					Type.atom("csrf_token"),
																				),
																			]),
																		]),
																	]),
																]),
															]),
															Type.list([]),
														]),
														Type.tuple([
															Type.atom("text"),
															Type.bitstring("\n    "),
														]),
														Type.tuple([
															Type.atom("element"),
															Type.bitstring("meta"),
															Type.list([
																Type.tuple([
																	Type.bitstring("name"),
																	Type.list([
																		Type.tuple([
																			Type.atom("text"),
																			Type.bitstring("color-scheme"),
																		]),
																	]),
																]),
																Type.tuple([
																	Type.bitstring("content"),
																	Type.list([
																		Type.tuple([
																			Type.atom("text"),
																			Type.bitstring("light dark"),
																		]),
																	]),
																]),
															]),
															Type.list([]),
														]),
														Type.tuple([
															Type.atom("text"),
															Type.bitstring("\n    "),
														]),
														Type.tuple([
															Type.atom("element"),
															Type.bitstring("meta"),
															Type.list([
																Type.tuple([
																	Type.bitstring("id"),
																	Type.list([
																		Type.tuple([
																			Type.atom("text"),
																			Type.bitstring("theme-color"),
																		]),
																	]),
																]),
																Type.tuple([
																	Type.bitstring("name"),
																	Type.list([
																		Type.tuple([
																			Type.atom("text"),
																			Type.bitstring("theme-color"),
																		]),
																	]),
																]),
																Type.tuple([
																	Type.bitstring("content"),
																	Type.list([
																		Type.tuple([
																			Type.atom("text"),
																			Type.bitstring("#F7F8FC"),
																		]),
																	]),
																]),
															]),
															Type.list([]),
														]),
														Type.tuple([
															Type.atom("text"),
															Type.bitstring("\n\n    "),
														]),
														Type.tuple([
															Type.atom("element"),
															Type.bitstring("title"),
															Type.list([]),
															Type.list([
																Type.tuple([
																	Type.atom("expression"),
																	Type.tuple([
																		Interpreter.dotOperator(
																			context.vars.vars_0,
																			Type.atom("page_title"),
																		),
																	]),
																]),
															]),
														]),
														Type.tuple([
															Type.atom("text"),
															Type.bitstring("\n\n    "),
														]),
														Interpreter.case(
															Interpreter.dotOperator(
																context.vars.vars_0,
																Type.atom("page_description"),
															),
															[
																{
																	match: Type.variablePattern("x_1"),
																	guards: [
																		(context) =>
																			Erlang["orelse/2"](
																				(context) =>
																					Erlang["=:=/2"](
																						context.vars.x_1,
																						Type.atom("false"),
																					),
																				(context) =>
																					Erlang["=:=/2"](
																						context.vars.x_1,
																						Type.atom("nil"),
																					),
																				context,
																			),
																	],
																	body: (context) => {
																		return Type.atom("nil");
																	},
																},
																{
																	match: Type.matchPlaceholder(),
																	guards: [],
																	body: (context) => {
																		return Type.list([
																			Type.tuple([
																				Type.atom("text"),
																				Type.bitstring("\n      "),
																			]),
																			Type.tuple([
																				Type.atom("element"),
																				Type.bitstring("meta"),
																				Type.list([
																					Type.tuple([
																						Type.bitstring("name"),
																						Type.list([
																							Type.tuple([
																								Type.atom("text"),
																								Type.bitstring("description"),
																							]),
																						]),
																					]),
																					Type.tuple([
																						Type.bitstring("content"),
																						Type.list([
																							Type.tuple([
																								Type.atom("expression"),
																								Type.tuple([
																									Interpreter.dotOperator(
																										context.vars.vars_0,
																										Type.atom(
																											"page_description",
																										),
																									),
																								]),
																							]),
																						]),
																					]),
																				]),
																				Type.list([]),
																			]),
																			Type.tuple([
																				Type.atom("text"),
																				Type.bitstring("\n    "),
																			]),
																		]);
																	},
																},
															],
															context,
														),
														Type.tuple([
															Type.atom("text"),
															Type.bitstring("\n\n    "),
														]),
														Interpreter.case(
															Interpreter.dotOperator(
																context.vars.vars_0,
																Type.atom("canonical_url"),
															),
															[
																{
																	match: Type.variablePattern("x_2"),
																	guards: [
																		(context) =>
																			Erlang["orelse/2"](
																				(context) =>
																					Erlang["=:=/2"](
																						context.vars.x_2,
																						Type.atom("false"),
																					),
																				(context) =>
																					Erlang["=:=/2"](
																						context.vars.x_2,
																						Type.atom("nil"),
																					),
																				context,
																			),
																	],
																	body: (context) => {
																		return Type.atom("nil");
																	},
																},
																{
																	match: Type.matchPlaceholder(),
																	guards: [],
																	body: (context) => {
																		return Type.list([
																			Type.tuple([
																				Type.atom("text"),
																				Type.bitstring("\n      "),
																			]),
																			Type.tuple([
																				Type.atom("element"),
																				Type.bitstring("link"),
																				Type.list([
																					Type.tuple([
																						Type.bitstring("rel"),
																						Type.list([
																							Type.tuple([
																								Type.atom("text"),
																								Type.bitstring("canonical"),
																							]),
																						]),
																					]),
																					Type.tuple([
																						Type.bitstring("href"),
																						Type.list([
																							Type.tuple([
																								Type.atom("expression"),
																								Type.tuple([
																									Interpreter.dotOperator(
																										context.vars.vars_0,
																										Type.atom("canonical_url"),
																									),
																								]),
																							]),
																						]),
																					]),
																				]),
																				Type.list([]),
																			]),
																			Type.tuple([
																				Type.atom("text"),
																				Type.bitstring("\n    "),
																			]),
																		]);
																	},
																},
															],
															context,
														),
														Type.tuple([
															Type.atom("text"),
															Type.bitstring("\n\n    "),
														]),
														Interpreter.case(
															Interpreter.dotOperator(
																context.vars.vars_0,
																Type.atom("open_graph_title"),
															),
															[
																{
																	match: Type.variablePattern("x_3"),
																	guards: [
																		(context) =>
																			Erlang["orelse/2"](
																				(context) =>
																					Erlang["=:=/2"](
																						context.vars.x_3,
																						Type.atom("false"),
																					),
																				(context) =>
																					Erlang["=:=/2"](
																						context.vars.x_3,
																						Type.atom("nil"),
																					),
																				context,
																			),
																	],
																	body: (context) => {
																		return Type.atom("nil");
																	},
																},
																{
																	match: Type.matchPlaceholder(),
																	guards: [],
																	body: (context) => {
																		return Type.list([
																			Type.tuple([
																				Type.atom("text"),
																				Type.bitstring("\n      "),
																			]),
																			Type.tuple([
																				Type.atom("element"),
																				Type.bitstring("meta"),
																				Type.list([
																					Type.tuple([
																						Type.bitstring("property"),
																						Type.list([
																							Type.tuple([
																								Type.atom("text"),
																								Type.bitstring("og:title"),
																							]),
																						]),
																					]),
																					Type.tuple([
																						Type.bitstring("content"),
																						Type.list([
																							Type.tuple([
																								Type.atom("expression"),
																								Type.tuple([
																									Interpreter.dotOperator(
																										context.vars.vars_0,
																										Type.atom(
																											"open_graph_title",
																										),
																									),
																								]),
																							]),
																						]),
																					]),
																				]),
																				Type.list([]),
																			]),
																			Type.tuple([
																				Type.atom("text"),
																				Type.bitstring("\n    "),
																			]),
																		]);
																	},
																},
															],
															context,
														),
														Type.tuple([
															Type.atom("text"),
															Type.bitstring("\n\n    "),
														]),
														Interpreter.case(
															Interpreter.dotOperator(
																context.vars.vars_0,
																Type.atom("open_graph_description"),
															),
															[
																{
																	match: Type.variablePattern("x_4"),
																	guards: [
																		(context) =>
																			Erlang["orelse/2"](
																				(context) =>
																					Erlang["=:=/2"](
																						context.vars.x_4,
																						Type.atom("false"),
																					),
																				(context) =>
																					Erlang["=:=/2"](
																						context.vars.x_4,
																						Type.atom("nil"),
																					),
																				context,
																			),
																	],
																	body: (context) => {
																		return Type.atom("nil");
																	},
																},
																{
																	match: Type.matchPlaceholder(),
																	guards: [],
																	body: (context) => {
																		return Type.list([
																			Type.tuple([
																				Type.atom("text"),
																				Type.bitstring("\n      "),
																			]),
																			Type.tuple([
																				Type.atom("element"),
																				Type.bitstring("meta"),
																				Type.list([
																					Type.tuple([
																						Type.bitstring("property"),
																						Type.list([
																							Type.tuple([
																								Type.atom("text"),
																								Type.bitstring(
																									"og:description",
																								),
																							]),
																						]),
																					]),
																					Type.tuple([
																						Type.bitstring("content"),
																						Type.list([
																							Type.tuple([
																								Type.atom("expression"),
																								Type.tuple([
																									Interpreter.dotOperator(
																										context.vars.vars_0,
																										Type.atom(
																											"open_graph_description",
																										),
																									),
																								]),
																							]),
																						]),
																					]),
																				]),
																				Type.list([]),
																			]),
																			Type.tuple([
																				Type.atom("text"),
																				Type.bitstring("\n    "),
																			]),
																		]);
																	},
																},
															],
															context,
														),
														Type.tuple([
															Type.atom("text"),
															Type.bitstring("\n\n    "),
														]),
														Interpreter.case(
															Interpreter.dotOperator(
																context.vars.vars_0,
																Type.atom("open_graph_url"),
															),
															[
																{
																	match: Type.variablePattern("x_5"),
																	guards: [
																		(context) =>
																			Erlang["orelse/2"](
																				(context) =>
																					Erlang["=:=/2"](
																						context.vars.x_5,
																						Type.atom("false"),
																					),
																				(context) =>
																					Erlang["=:=/2"](
																						context.vars.x_5,
																						Type.atom("nil"),
																					),
																				context,
																			),
																	],
																	body: (context) => {
																		return Type.atom("nil");
																	},
																},
																{
																	match: Type.matchPlaceholder(),
																	guards: [],
																	body: (context) => {
																		return Type.list([
																			Type.tuple([
																				Type.atom("text"),
																				Type.bitstring("\n      "),
																			]),
																			Type.tuple([
																				Type.atom("element"),
																				Type.bitstring("meta"),
																				Type.list([
																					Type.tuple([
																						Type.bitstring("property"),
																						Type.list([
																							Type.tuple([
																								Type.atom("text"),
																								Type.bitstring("og:url"),
																							]),
																						]),
																					]),
																					Type.tuple([
																						Type.bitstring("content"),
																						Type.list([
																							Type.tuple([
																								Type.atom("expression"),
																								Type.tuple([
																									Interpreter.dotOperator(
																										context.vars.vars_0,
																										Type.atom("open_graph_url"),
																									),
																								]),
																							]),
																						]),
																					]),
																				]),
																				Type.list([]),
																			]),
																			Type.tuple([
																				Type.atom("text"),
																				Type.bitstring("\n    "),
																			]),
																		]);
																	},
																},
															],
															context,
														),
														Type.tuple([
															Type.atom("text"),
															Type.bitstring("\n\n    "),
														]),
														Interpreter.case(
															Interpreter.dotOperator(
																context.vars.vars_0,
																Type.atom("open_graph_image"),
															),
															[
																{
																	match: Type.variablePattern("x_6"),
																	guards: [
																		(context) =>
																			Erlang["orelse/2"](
																				(context) =>
																					Erlang["=:=/2"](
																						context.vars.x_6,
																						Type.atom("false"),
																					),
																				(context) =>
																					Erlang["=:=/2"](
																						context.vars.x_6,
																						Type.atom("nil"),
																					),
																				context,
																			),
																	],
																	body: (context) => {
																		return Type.atom("nil");
																	},
																},
																{
																	match: Type.matchPlaceholder(),
																	guards: [],
																	body: (context) => {
																		return Type.list([
																			Type.tuple([
																				Type.atom("text"),
																				Type.bitstring("\n      "),
																			]),
																			Type.tuple([
																				Type.atom("element"),
																				Type.bitstring("meta"),
																				Type.list([
																					Type.tuple([
																						Type.bitstring("property"),
																						Type.list([
																							Type.tuple([
																								Type.atom("text"),
																								Type.bitstring("og:image"),
																							]),
																						]),
																					]),
																					Type.tuple([
																						Type.bitstring("content"),
																						Type.list([
																							Type.tuple([
																								Type.atom("expression"),
																								Type.tuple([
																									Interpreter.dotOperator(
																										context.vars.vars_0,
																										Type.atom(
																											"open_graph_image",
																										),
																									),
																								]),
																							]),
																						]),
																					]),
																				]),
																				Type.list([]),
																			]),
																			Type.tuple([
																				Type.atom("text"),
																				Type.bitstring("\n    "),
																			]),
																		]);
																	},
																},
															],
															context,
														),
														Type.tuple([
															Type.atom("text"),
															Type.bitstring("\n\n    "),
														]),
														Interpreter.case(
															Interpreter.dotOperator(
																context.vars.vars_0,
																Type.atom("robots"),
															),
															[
																{
																	match: Type.variablePattern("x_7"),
																	guards: [
																		(context) =>
																			Erlang["orelse/2"](
																				(context) =>
																					Erlang["=:=/2"](
																						context.vars.x_7,
																						Type.atom("false"),
																					),
																				(context) =>
																					Erlang["=:=/2"](
																						context.vars.x_7,
																						Type.atom("nil"),
																					),
																				context,
																			),
																	],
																	body: (context) => {
																		return Type.atom("nil");
																	},
																},
																{
																	match: Type.matchPlaceholder(),
																	guards: [],
																	body: (context) => {
																		return Type.list([
																			Type.tuple([
																				Type.atom("text"),
																				Type.bitstring("\n      "),
																			]),
																			Type.tuple([
																				Type.atom("element"),
																				Type.bitstring("meta"),
																				Type.list([
																					Type.tuple([
																						Type.bitstring("name"),
																						Type.list([
																							Type.tuple([
																								Type.atom("text"),
																								Type.bitstring("robots"),
																							]),
																						]),
																					]),
																					Type.tuple([
																						Type.bitstring("content"),
																						Type.list([
																							Type.tuple([
																								Type.atom("expression"),
																								Type.tuple([
																									Interpreter.dotOperator(
																										context.vars.vars_0,
																										Type.atom("robots"),
																									),
																								]),
																							]),
																						]),
																					]),
																				]),
																				Type.list([]),
																			]),
																			Type.tuple([
																				Type.atom("text"),
																				Type.bitstring("\n    "),
																			]),
																		]);
																	},
																},
															],
															context,
														),
														Type.tuple([
															Type.atom("text"),
															Type.bitstring("\n\n    "),
														]),
														Interpreter.case(
															Interpreter.dotOperator(
																context.vars.vars_0,
																Type.atom("structured_metadata_json"),
															),
															[
																{
																	match: Type.variablePattern("x_8"),
																	guards: [
																		(context) =>
																			Erlang["orelse/2"](
																				(context) =>
																					Erlang["=:=/2"](
																						context.vars.x_8,
																						Type.atom("false"),
																					),
																				(context) =>
																					Erlang["=:=/2"](
																						context.vars.x_8,
																						Type.atom("nil"),
																					),
																				context,
																			),
																	],
																	body: (context) => {
																		return Type.atom("nil");
																	},
																},
																{
																	match: Type.matchPlaceholder(),
																	guards: [],
																	body: (context) => {
																		return Type.list([
																			Type.tuple([
																				Type.atom("text"),
																				Type.bitstring("\n      "),
																			]),
																			Type.tuple([
																				Type.atom("component"),
																				Type.atom(
																					"Elixir.LeaplyWeb.Hologram.Components.Head.StructuredData",
																				),
																				Type.list([
																					Type.tuple([
																						Type.bitstring("json"),
																						Type.list([
																							Type.tuple([
																								Type.atom("expression"),
																								Type.tuple([
																									Interpreter.dotOperator(
																										context.vars.vars_0,
																										Type.atom(
																											"structured_metadata_json",
																										),
																									),
																								]),
																							]),
																						]),
																					]),
																				]),
																				Type.list([]),
																			]),
																			Type.tuple([
																				Type.atom("text"),
																				Type.bitstring("\n    "),
																			]),
																		]);
																	},
																},
															],
															context,
														),
														Type.tuple([
															Type.atom("text"),
															Type.bitstring("\n\n    "),
														]),
														Type.tuple([
															Type.atom("element"),
															Type.bitstring("script"),
															Type.list([]),
															Type.list([
																Type.tuple([
																	Type.atom("text"),
																	Type.bitstring(
																		'\n      (function () {\n        var storedTheme = null;\n        try { storedTheme = window.localStorage.getItem("leaply:theme"); } catch (_error) {}\n        var mode = storedTheme === "light" || storedTheme === "dark"\n          ? storedTheme\n          : (window.matchMedia("(prefers-color-scheme: dark)").matches ? "dark" : "light");\n        var path = window.location.pathname;\n        var adminPath = path === "/design-system" || path === "/admin" || path.indexOf("/admin/") === 0 || path === "/docs" || path.indexOf("/docs/") === 0;\n        var recruiterPath = path === "/accounts" || path.indexOf("/accounts/") === 0 || path === "/tracker" || path.indexOf("/tracker/") === 0 || new RegExp("^/listings/[^/]+/(screening|phases/[^/]+/screening)(/|$)").test(path);\n        var context = adminPath ? "admin" : (recruiterPath ? "recruiter" : "applicant");\n        var root = document.documentElement;\n        root.classList.toggle("dark", mode === "dark");\n        root.dataset.interfaceContext = context;\n        root.dataset.themeMode = mode;\n        root.dataset.theme = "leaply-" + context + "-" + mode;\n        root.style.colorScheme = mode;\n        var lightColor = context === "recruiter" ? "#F4F7FB" : "#F7F8FC";\n        var darkColor = context === "recruiter" ? "#0B1220" : "#080D19";\n        document.getElementById("theme-color").setAttribute("content", mode === "dark" ? darkColor : lightColor);\n      })();\n    ',
																	),
																]),
															]),
														]),
														Type.tuple([
															Type.atom("text"),
															Type.bitstring("\n    "),
														]),
														Type.tuple([
															Type.atom("element"),
															Type.bitstring("link"),
															Type.list([
																Type.tuple([
																	Type.bitstring("rel"),
																	Type.list([
																		Type.tuple([
																			Type.atom("text"),
																			Type.bitstring("stylesheet"),
																		]),
																	]),
																]),
																Type.tuple([
																	Type.bitstring("href"),
																	Type.list([
																		Type.tuple([
																			Type.atom("text"),
																			Type.bitstring("/assets/css/app.css"),
																		]),
																	]),
																]),
															]),
															Type.list([]),
														]),
														Type.tuple([
															Type.atom("text"),
															Type.bitstring("\n    "),
														]),
														Type.tuple([
															Type.atom("element"),
															Type.bitstring("script"),
															Type.list([
																Type.tuple([
																	Type.bitstring("defer"),
																	Type.list([]),
																]),
																Type.tuple([
																	Type.bitstring("type"),
																	Type.list([
																		Type.tuple([
																			Type.atom("text"),
																			Type.bitstring("text/javascript"),
																		]),
																	]),
																]),
																Type.tuple([
																	Type.bitstring("src"),
																	Type.list([
																		Type.tuple([
																			Type.atom("text"),
																			Type.bitstring("/assets/js/app.js"),
																		]),
																	]),
																]),
															]),
															Type.list([]),
														]),
														Type.tuple([
															Type.atom("text"),
															Type.bitstring("\n  "),
														]),
													]),
												]),
												Type.tuple([
													Type.atom("text"),
													Type.bitstring("\n\n  "),
												]),
												Type.tuple([
													Type.atom("element"),
													Type.bitstring("body"),
													Type.list([
														Type.tuple([
															Type.bitstring("data-profile-location"),
															Type.list([
																Type.tuple([
																	Type.atom("expression"),
																	Type.tuple([
																		Interpreter.dotOperator(
																			context.vars.vars_0,
																			Type.atom("profile_location"),
																		),
																	]),
																]),
															]),
														]),
														Type.tuple([
															Type.bitstring("class"),
															Type.list([
																Type.tuple([
																	Type.atom("text"),
																	Type.bitstring(
																		"min-h-screen bg-app-canvas font-sans text-app-ink antialiased transition-colors duration-200 motion-reduce:transition-none",
																	),
																]),
															]),
														]),
													]),
													Type.list([
														Type.tuple([
															Type.atom("text"),
															Type.bitstring("\n    "),
														]),
														Interpreter.case(
															Interpreter.dotOperator(
																context.vars.vars_0,
																Type.atom("show_global_flash"),
															),
															[
																{
																	match: Type.variablePattern("x_9"),
																	guards: [
																		(context) =>
																			Erlang["orelse/2"](
																				(context) =>
																					Erlang["=:=/2"](
																						context.vars.x_9,
																						Type.atom("false"),
																					),
																				(context) =>
																					Erlang["=:=/2"](
																						context.vars.x_9,
																						Type.atom("nil"),
																					),
																				context,
																			),
																	],
																	body: (context) => {
																		return Type.atom("nil");
																	},
																},
																{
																	match: Type.matchPlaceholder(),
																	guards: [],
																	body: (context) => {
																		return Type.list([
																			Type.tuple([
																				Type.atom("text"),
																				Type.bitstring("\n      "),
																			]),
																			Type.tuple([
																				Type.atom("element"),
																				Type.bitstring("div"),
																				Type.list([
																					Type.tuple([
																						Type.bitstring("class"),
																						Type.list([
																							Type.tuple([
																								Type.atom("text"),
																								Type.bitstring(
																									"fixed right-4 top-4 z-50 space-y-2",
																								),
																							]),
																						]),
																					]),
																					Type.tuple([
																						Type.bitstring("aria-live"),
																						Type.list([
																							Type.tuple([
																								Type.atom("text"),
																								Type.bitstring("polite"),
																							]),
																						]),
																					]),
																					Type.tuple([
																						Type.bitstring("id"),
																						Type.list([
																							Type.tuple([
																								Type.atom("text"),
																								Type.bitstring(
																									"flash-container",
																								),
																							]),
																						]),
																					]),
																				]),
																				Type.list([
																					Type.tuple([
																						Type.atom("text"),
																						Type.bitstring("\n        "),
																					]),
																					Interpreter.case(
																						Interpreter.dotOperator(
																							context.vars.vars_0,
																							Type.atom("flash_info"),
																						),
																						[
																							{
																								match:
																									Type.variablePattern("x_10"),
																								guards: [
																									(context) =>
																										Erlang["orelse/2"](
																											(context) =>
																												Erlang["=:=/2"](
																													context.vars.x_10,
																													Type.atom("false"),
																												),
																											(context) =>
																												Erlang["=:=/2"](
																													context.vars.x_10,
																													Type.atom("nil"),
																												),
																											context,
																										),
																								],
																								body: (context) => {
																									return Type.atom("nil");
																								},
																							},
																							{
																								match: Type.matchPlaceholder(),
																								guards: [],
																								body: (context) => {
																									return Type.list([
																										Type.tuple([
																											Type.atom("text"),
																											Type.bitstring(
																												"\n          ",
																											),
																										]),
																										Type.tuple([
																											Type.atom("element"),
																											Type.bitstring("div"),
																											Type.list([
																												Type.tuple([
																													Type.bitstring(
																														"class",
																													),
																													Type.list([
																														Type.tuple([
																															Type.atom("text"),
																															Type.bitstring(
																																"rounded-md border border-blue-200 bg-blue-50 px-3 py-2 text-sm text-blue-900 dark:border-blue-900/40 dark:bg-blue-950/40 dark:text-blue-100",
																															),
																														]),
																													]),
																												]),
																												Type.tuple([
																													Type.bitstring("id"),
																													Type.list([
																														Type.tuple([
																															Type.atom("text"),
																															Type.bitstring(
																																"flash-info",
																															),
																														]),
																													]),
																												]),
																											]),
																											Type.list([
																												Type.tuple([
																													Type.atom("text"),
																													Type.bitstring(
																														"\n            ",
																													),
																												]),
																												Type.tuple([
																													Type.atom(
																														"expression",
																													),
																													Type.tuple([
																														Interpreter.dotOperator(
																															context.vars
																																.vars_0,
																															Type.atom(
																																"flash_info",
																															),
																														),
																													]),
																												]),
																												Type.tuple([
																													Type.atom("text"),
																													Type.bitstring(
																														"\n          ",
																													),
																												]),
																											]),
																										]),
																										Type.tuple([
																											Type.atom("text"),
																											Type.bitstring(
																												"\n        ",
																											),
																										]),
																									]);
																								},
																							},
																						],
																						context,
																					),
																					Type.tuple([
																						Type.atom("text"),
																						Type.bitstring("\n\n        "),
																					]),
																					Interpreter.case(
																						Interpreter.dotOperator(
																							context.vars.vars_0,
																							Type.atom("flash_error"),
																						),
																						[
																							{
																								match:
																									Type.variablePattern("x_11"),
																								guards: [
																									(context) =>
																										Erlang["orelse/2"](
																											(context) =>
																												Erlang["=:=/2"](
																													context.vars.x_11,
																													Type.atom("false"),
																												),
																											(context) =>
																												Erlang["=:=/2"](
																													context.vars.x_11,
																													Type.atom("nil"),
																												),
																											context,
																										),
																								],
																								body: (context) => {
																									return Type.atom("nil");
																								},
																							},
																							{
																								match: Type.matchPlaceholder(),
																								guards: [],
																								body: (context) => {
																									return Type.list([
																										Type.tuple([
																											Type.atom("text"),
																											Type.bitstring(
																												"\n          ",
																											),
																										]),
																										Type.tuple([
																											Type.atom("element"),
																											Type.bitstring("div"),
																											Type.list([
																												Type.tuple([
																													Type.bitstring(
																														"class",
																													),
																													Type.list([
																														Type.tuple([
																															Type.atom("text"),
																															Type.bitstring(
																																"rounded-md border border-red-200 bg-red-50 px-3 py-2 text-sm text-red-900 dark:border-red-900/40 dark:bg-red-950/40 dark:text-red-100",
																															),
																														]),
																													]),
																												]),
																												Type.tuple([
																													Type.bitstring("id"),
																													Type.list([
																														Type.tuple([
																															Type.atom("text"),
																															Type.bitstring(
																																"flash-error",
																															),
																														]),
																													]),
																												]),
																											]),
																											Type.list([
																												Type.tuple([
																													Type.atom("text"),
																													Type.bitstring(
																														"\n            ",
																													),
																												]),
																												Type.tuple([
																													Type.atom(
																														"expression",
																													),
																													Type.tuple([
																														Interpreter.dotOperator(
																															context.vars
																																.vars_0,
																															Type.atom(
																																"flash_error",
																															),
																														),
																													]),
																												]),
																												Type.tuple([
																													Type.atom("text"),
																													Type.bitstring(
																														"\n          ",
																													),
																												]),
																											]),
																										]),
																										Type.tuple([
																											Type.atom("text"),
																											Type.bitstring(
																												"\n        ",
																											),
																										]),
																									]);
																								},
																							},
																						],
																						context,
																					),
																					Type.tuple([
																						Type.atom("text"),
																						Type.bitstring("\n      "),
																					]),
																				]),
																			]),
																			Type.tuple([
																				Type.atom("text"),
																				Type.bitstring("\n    "),
																			]),
																		]);
																	},
																},
															],
															context,
														),
														Type.tuple([
															Type.atom("text"),
															Type.bitstring("\n\n    "),
														]),
														Interpreter.case(
															Interpreter.case(
																Interpreter.dotOperator(
																	context.vars.vars_0,
																	Type.atom("navigation"),
																),
																[
																	{
																		match: Type.variablePattern("x_12"),
																		guards: [
																			(context) =>
																				Erlang["orelse/2"](
																					(context) =>
																						Erlang["=:=/2"](
																							context.vars.x_12,
																							Type.atom("false"),
																						),
																					(context) =>
																						Erlang["=:=/2"](
																							context.vars.x_12,
																							Type.atom("nil"),
																						),
																					context,
																				),
																		],
																		body: (context) => {
																			return context.vars.x_12;
																		},
																	},
																	{
																		match: Type.matchPlaceholder(),
																		guards: [],
																		body: (context) => {
																			return Interpreter.dotOperator(
																				Interpreter.dotOperator(
																					context.vars.vars_0,
																					Type.atom("navigation"),
																				),
																				Type.atom("admin_bar?"),
																			);
																		},
																	},
																],
																context,
															),
															[
																{
																	match: Type.variablePattern("x_13"),
																	guards: [
																		(context) =>
																			Erlang["orelse/2"](
																				(context) =>
																					Erlang["=:=/2"](
																						context.vars.x_13,
																						Type.atom("false"),
																					),
																				(context) =>
																					Erlang["=:=/2"](
																						context.vars.x_13,
																						Type.atom("nil"),
																					),
																				context,
																			),
																	],
																	body: (context) => {
																		return Type.atom("nil");
																	},
																},
																{
																	match: Type.matchPlaceholder(),
																	guards: [],
																	body: (context) => {
																		return Type.list([
																			Type.tuple([
																				Type.atom("component"),
																				Type.atom(
																					"Elixir.LeaplyWeb.Hologram.Components.ApplicationBar",
																				),
																				Type.list([
																					Type.tuple([
																						Type.bitstring("cid"),
																						Type.list([
																							Type.tuple([
																								Type.atom("text"),
																								Type.bitstring(
																									"application-bar",
																								),
																							]),
																						]),
																					]),
																				]),
																				Type.list([]),
																			]),
																		]);
																	},
																},
															],
															context,
														),
														Type.tuple([
															Type.atom("text"),
															Type.bitstring("\n    "),
														]),
														Type.tuple([
															Type.atom("element"),
															Type.bitstring("slot"),
															Type.list([]),
															Type.list([]),
														]),
														Type.tuple([
															Type.atom("text"),
															Type.bitstring("\n    "),
														]),
														Type.tuple([
															Type.atom("component"),
															Type.atom("Elixir.Hologram.UI.Runtime"),
															Type.list([]),
															Type.list([]),
														]),
														Type.tuple([
															Type.atom("text"),
															Type.bitstring("\n  "),
														]),
													]),
												]),
												Type.tuple([Type.atom("text"), Type.bitstring("\n")]),
											]),
										]),
									]);
								},
							},
						],
						context,
					);
					Interpreter.updateVarsToMatchedValues(context);
					return globalThis.hologram.return;
				},
			},
		],
	);

	Interpreter.defineElixirFunction(
		"LeaplyWeb.Hologram.Pages.Listings.DetailPage",
		"__layout_module__",
		0,
		"public",
		[
			{
				params: (context) => [],
				guards: [],
				body: (context) => {
					return Type.atom("Elixir.LeaplyWeb.Hologram.Layouts.RootLayout");
				},
			},
		],
	);

	Interpreter.defineElixirFunction(
		"LeaplyWeb.Hologram.Pages.Listings.DetailPage",
		"__layout_props__",
		0,
		"public",
		[
			{
				params: (context) => [],
				guards: [],
				body: (context) => {
					return Type.list([
						Type.tuple([
							Type.atom("page_title"),
							Type.bitstring("Opportunity — Leaply"),
						]),
						Type.tuple([Type.atom("robots"), Type.bitstring("index,follow")]),
					]);
				},
			},
		],
	);

	Interpreter.defineElixirFunction(
		"LeaplyWeb.Hologram.Pages.Listings.DetailPage",
		"__params__",
		0,
		"public",
		[
			{
				params: (context) => [],
				guards: [],
				body: (context) => {
					return Elixir_Enum["reverse/1"](Type.list([]));
				},
			},
		],
	);

	Interpreter.defineElixirFunction(
		"LeaplyWeb.Hologram.Pages.Listings.DetailPage",
		"__route__",
		0,
		"public",
		[
			{
				params: (context) => [],
				guards: [],
				body: (context) => {
					return Type.bitstring("/_hologram/listings/detail");
				},
			},
		],
	);

	Interpreter.defineElixirFunction(
		"LeaplyWeb.Hologram.Pages.Listings.DetailPage",
		"lifecycle_class",
		1,
		"public",
		[
			{
				params: (context) => [Type.bitstring("open")],
				guards: [],
				body: (context) => {
					return Type.bitstring(
						"bg-emerald-50 text-emerald-700 ring-emerald-600/15 dark:bg-emerald-950/70 dark:text-emerald-200 dark:ring-emerald-400/25",
					);
				},
			},
			{
				params: (context) => [Type.bitstring("upcoming")],
				guards: [],
				body: (context) => {
					return Type.bitstring(
						"bg-blue-50 text-blue-700 ring-blue-600/15 dark:bg-blue-950/70 dark:text-blue-200 dark:ring-blue-400/25",
					);
				},
			},
			{
				params: (context) => [Type.matchPlaceholder()],
				guards: [],
				body: (context) => {
					return Type.bitstring(
						"bg-slate-100 text-slate-600 ring-slate-500/15 dark:bg-slate-800 dark:text-slate-200 dark:ring-slate-400/25",
					);
				},
			},
		],
	);

	Interpreter.defineElixirFunction(
		"LeaplyWeb.Hologram.Pages.Listings.DetailPage",
		"listings_text",
		1,
		"public",
		[
			{
				params: (context) => [Type.variablePattern("key_0")],
				guards: [],
				body: (context) => {
					return Elixir_LeaplyWeb_Hologram_Helpers_CatalogText["get/2"](
						Type.bitstring("listings"),
						context.vars.key_0,
					);
				},
			},
		],
	);

	Interpreter.defineElixirFunction(
		"LeaplyWeb.Hologram.Pages.Listings.DetailPage",
		"primary_action_class",
		1,
		"public",
		[
			{
				params: (context) => [Type.atom("true")],
				guards: [],
				body: (context) => {
					return Type.bitstring(
						"inline-flex min-h-12 w-full items-center justify-center rounded-md bg-gradient-to-r from-blue-500 to-violet-500 px-5 text-sm font-bold text-white shadow-[0_12px_28px_rgba(79,70,229,0.24)] transition hover:-translate-y-0.5 hover:shadow-[0_16px_34px_rgba(79,70,229,0.30)] focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-violet-500 motion-reduce:transform-none",
					);
				},
			},
			{
				params: (context) => [Type.atom("false")],
				guards: [],
				body: (context) => {
					return Type.bitstring(
						"inline-flex min-h-12 w-full cursor-not-allowed items-center justify-center rounded-md bg-slate-100 px-5 text-sm font-bold text-slate-500 dark:bg-slate-800 dark:text-slate-400",
					);
				},
			},
		],
	);

	Interpreter.defineElixirFunction(
		"LeaplyWeb.Hologram.Pages.Listings.DetailPage",
		"question_expectation",
		1,
		"public",
		[
			{
				params: (context) => [Type.atom("nil")],
				guards: [],
				body: (context) => {
					return Type.bitstring("Application questions are being prepared");
				},
			},
			{
				params: (context) => [Type.integer(0n)],
				guards: [],
				body: (context) => {
					return Type.bitstring("No additional application questions");
				},
			},
			{
				params: (context) => [Type.integer(1n)],
				guards: [],
				body: (context) => {
					return Type.bitstring("Up to 1 application question");
				},
			},
			{
				params: (context) => [Type.variablePattern("count_0")],
				guards: [],
				body: (context) => {
					return Type.bitstring([
						Type.bitstringSegment(Type.string("Up to "), { type: "binary" }),
						Type.bitstringSegment(
							Elixir_String_Chars["to_string/1"](context.vars.count_0),
							{ type: "binary" },
						),
						Type.bitstringSegment(Type.string(" application questions"), {
							type: "binary",
						}),
					]);
				},
			},
		],
	);

	Interpreter.defineElixirFunction(
		"LeaplyWeb.Hologram.Pages.Listings.DetailPage",
		"requirement_expectation",
		1,
		"public",
		[
			{
				params: (context) => [Type.integer(0n)],
				guards: [],
				body: (context) => {
					return Type.bitstring("No automated eligibility checks");
				},
			},
			{
				params: (context) => [Type.integer(1n)],
				guards: [],
				body: (context) => {
					return Type.bitstring("1 eligibility requirement");
				},
			},
			{
				params: (context) => [Type.variablePattern("count_0")],
				guards: [],
				body: (context) => {
					return Type.bitstring([
						Type.bitstringSegment(
							Elixir_String_Chars["to_string/1"](context.vars.count_0),
							{ type: "binary" },
						),
						Type.bitstringSegment(Type.string(" eligibility requirements"), {
							type: "binary",
						}),
					]);
				},
			},
		],
	);

	Interpreter.defineElixirFunction(
		"LeaplyWeb.Hologram.Pages.Listings.DetailPage",
		"template",
		0,
		"public",
		[
			{
				params: (context) => [],
				guards: [],
				body: (context) => {
					globalThis.hologram.return = Type.anonymousFunction(
						1,
						[
							{
								params: (context) => [Type.variablePattern("vars_0")],
								guards: [],
								body: (context) => {
									Interpreter.matchOperator(
										context.vars.vars_0,
										Type.matchPlaceholder(),
										context,
									);
									Interpreter.updateVarsToMatchedValues(context);
									return Type.list([
										Type.tuple([
											Type.atom("element"),
											Type.bitstring("div"),
											Type.list([
												Type.tuple([
													Type.bitstring("class"),
													Type.list([
														Type.tuple([
															Type.atom("text"),
															Type.bitstring(
																"min-h-screen bg-[linear-gradient(180deg,#F4F7FF_0%,#FAFBFF_30%,#FFFFFF_72%)] pb-[calc(7rem+env(safe-area-inset-bottom))] lg:pb-0 dark:bg-[linear-gradient(180deg,#0D1526_0%,#080D19_45%,#080D19_100%)]",
															),
														]),
													]),
												]),
												Type.tuple([
													Type.bitstring("id"),
													Type.list([
														Type.tuple([
															Type.atom("text"),
															Type.bitstring("listing-detail-page"),
														]),
													]),
												]),
											]),
											Type.list([
												Type.tuple([Type.atom("text"), Type.bitstring("\n  ")]),
												Type.tuple([
													Type.atom("component"),
													Type.atom(
														"Elixir.LeaplyWeb.Hologram.Components.ApplicantShell",
													),
													Type.list([
														Type.tuple([
															Type.bitstring("active_section"),
															Type.list([
																Type.tuple([
																	Type.atom("text"),
																	Type.bitstring("listings"),
																]),
															]),
														]),
														Type.tuple([
															Type.bitstring("authenticated"),
															Type.list([
																Type.tuple([
																	Type.atom("expression"),
																	Type.tuple([
																		Interpreter.dotOperator(
																			context.vars.vars_0,
																			Type.atom("authenticated"),
																		),
																	]),
																]),
															]),
														]),
														Type.tuple([
															Type.bitstring("csrf_token"),
															Type.list([
																Type.tuple([
																	Type.atom("expression"),
																	Type.tuple([
																		Interpreter.dotOperator(
																			context.vars.vars_0,
																			Type.atom("csrf_token"),
																		),
																	]),
																]),
															]),
														]),
														Type.tuple([
															Type.bitstring("display_name"),
															Type.list([
																Type.tuple([
																	Type.atom("expression"),
																	Type.tuple([
																		Interpreter.dotOperator(
																			context.vars.vars_0,
																			Type.atom("display_name"),
																		),
																	]),
																]),
															]),
														]),
													]),
													Type.list([]),
												]),
												Type.tuple([
													Type.atom("text"),
													Type.bitstring("\n\n  "),
												]),
												Type.tuple([
													Type.atom("element"),
													Type.bitstring("main"),
													Type.list([
														Type.tuple([
															Type.bitstring("id"),
															Type.list([
																Type.tuple([
																	Type.atom("text"),
																	Type.bitstring("main-content"),
																]),
															]),
														]),
														Type.tuple([
															Type.bitstring("tabindex"),
															Type.list([
																Type.tuple([
																	Type.atom("text"),
																	Type.bitstring("-1"),
																]),
															]),
														]),
														Type.tuple([
															Type.bitstring("class"),
															Type.list([
																Type.tuple([
																	Type.atom("text"),
																	Type.bitstring(
																		"mx-auto w-full max-w-app px-4 py-6 sm:px-6 sm:py-8 lg:px-8 lg:py-12 2xl:px-10",
																	),
																]),
															]),
														]),
													]),
													Type.list([
														Type.tuple([
															Type.atom("text"),
															Type.bitstring("\n    "),
														]),
														Type.tuple([
															Type.atom("element"),
															Type.bitstring("a"),
															Type.list([
																Type.tuple([
																	Type.bitstring("href"),
																	Type.list([
																		Type.tuple([
																			Type.atom("text"),
																			Type.bitstring("/listings"),
																		]),
																	]),
																]),
																Type.tuple([
																	Type.bitstring("class"),
																	Type.list([
																		Type.tuple([
																			Type.atom("text"),
																			Type.bitstring(
																				"inline-flex min-h-11 items-center gap-2 rounded-md text-sm font-semibold text-app-muted transition hover:text-blue-700 focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-blue-500 dark:hover:text-blue-300",
																			),
																		]),
																	]),
																]),
															]),
															Type.list([
																Type.tuple([
																	Type.atom("text"),
																	Type.bitstring("\n      "),
																]),
																Type.tuple([
																	Type.atom("element"),
																	Type.bitstring("span"),
																	Type.list([
																		Type.tuple([
																			Type.bitstring("class"),
																			Type.list([
																				Type.tuple([
																					Type.atom("text"),
																					Type.bitstring(
																						"hero-arrow-left h-4 w-4",
																					),
																				]),
																			]),
																		]),
																		Type.tuple([
																			Type.bitstring("aria-hidden"),
																			Type.list([
																				Type.tuple([
																					Type.atom("text"),
																					Type.bitstring("true"),
																				]),
																			]),
																		]),
																	]),
																	Type.list([]),
																]),
																Type.tuple([
																	Type.atom("text"),
																	Type.bitstring(
																		"\n      Back to opportunities\n    ",
																	),
																]),
															]),
														]),
														Type.tuple([
															Type.atom("text"),
															Type.bitstring("\n\n    "),
														]),
														Type.tuple([
															Type.atom("element"),
															Type.bitstring("div"),
															Type.list([
																Type.tuple([
																	Type.bitstring("class"),
																	Type.list([
																		Type.tuple([
																			Type.atom("text"),
																			Type.bitstring(
																				"mt-6 grid gap-8 lg:grid-cols-[minmax(0,1fr)_340px] lg:items-start 2xl:grid-cols-[minmax(0,1fr)_400px]",
																			),
																		]),
																	]),
																]),
															]),
															Type.list([
																Type.tuple([
																	Type.atom("text"),
																	Type.bitstring("\n      "),
																]),
																Type.tuple([
																	Type.atom("element"),
																	Type.bitstring("div"),
																	Type.list([
																		Type.tuple([
																			Type.bitstring("class"),
																			Type.list([
																				Type.tuple([
																					Type.atom("text"),
																					Type.bitstring("min-w-0 space-y-7"),
																				]),
																			]),
																		]),
																	]),
																	Type.list([
																		Type.tuple([
																			Type.atom("text"),
																			Type.bitstring("\n        "),
																		]),
																		Type.tuple([
																			Type.atom("element"),
																			Type.bitstring("section"),
																			Type.list([
																				Type.tuple([
																					Type.bitstring(
																						"data-listing-detail-surface",
																					),
																					Type.list([]),
																				]),
																				Type.tuple([
																					Type.bitstring("class"),
																					Type.list([
																						Type.tuple([
																							Type.atom("text"),
																							Type.bitstring(
																								"overflow-hidden rounded-lg border border-app-border bg-app-surface shadow-[0_24px_70px_rgba(23,28,53,0.09)] dark:shadow-[0_24px_70px_rgba(0,0,0,0.34)]",
																							),
																						]),
																					]),
																				]),
																			]),
																			Type.list([
																				Type.tuple([
																					Type.atom("text"),
																					Type.bitstring("\n          "),
																				]),
																				Type.tuple([
																					Type.atom("element"),
																					Type.bitstring("div"),
																					Type.list([
																						Type.tuple([
																							Type.bitstring("class"),
																							Type.list([
																								Type.tuple([
																									Type.atom("text"),
																									Type.bitstring(
																										"h-1.5 bg-gradient-to-r from-blue-500 via-indigo-500 to-violet-500",
																									),
																								]),
																							]),
																						]),
																					]),
																					Type.list([]),
																				]),
																				Type.tuple([
																					Type.atom("text"),
																					Type.bitstring("\n          "),
																				]),
																				Type.tuple([
																					Type.atom("element"),
																					Type.bitstring("div"),
																					Type.list([
																						Type.tuple([
																							Type.bitstring("class"),
																							Type.list([
																								Type.tuple([
																									Type.atom("text"),
																									Type.bitstring("p-6 sm:p-9"),
																								]),
																							]),
																						]),
																					]),
																					Type.list([
																						Type.tuple([
																							Type.atom("text"),
																							Type.bitstring("\n            "),
																						]),
																						Type.tuple([
																							Type.atom("element"),
																							Type.bitstring("div"),
																							Type.list([
																								Type.tuple([
																									Type.bitstring("class"),
																									Type.list([
																										Type.tuple([
																											Type.atom("text"),
																											Type.bitstring(
																												"flex flex-wrap items-center gap-2",
																											),
																										]),
																									]),
																								]),
																							]),
																							Type.list([
																								Type.tuple([
																									Type.atom("text"),
																									Type.bitstring(
																										"\n              ",
																									),
																								]),
																								Type.tuple([
																									Type.atom("element"),
																									Type.bitstring("span"),
																									Type.list([
																										Type.tuple([
																											Type.bitstring("class"),
																											Type.list([
																												Type.tuple([
																													Type.atom("text"),
																													Type.bitstring(
																														"rounded-full bg-[#171C35] px-3 py-1.5 text-xs font-bold uppercase tracking-[0.14em] text-white",
																													),
																												]),
																											]),
																										]),
																									]),
																									Type.list([
																										Type.tuple([
																											Type.atom("expression"),
																											Type.tuple([
																												Interpreter.dotOperator(
																													Interpreter.dotOperator(
																														context.vars.vars_0,
																														Type.atom("detail"),
																													),
																													Type.atom(
																														"kind_label",
																													),
																												),
																											]),
																										]),
																									]),
																								]),
																								Type.tuple([
																									Type.atom("text"),
																									Type.bitstring(
																										"\n              ",
																									),
																								]),
																								Type.tuple([
																									Type.atom("element"),
																									Type.bitstring("span"),
																									Type.list([
																										Type.tuple([
																											Type.bitstring("class"),
																											Type.list([
																												Type.tuple([
																													Type.atom(
																														"expression",
																													),
																													Type.tuple([
																														Type.bitstring([
																															Type.bitstringSegment(
																																Type.string(
																																	"rounded-full px-3 py-1.5 text-xs font-bold ring-1 ring-inset ",
																																),
																																{
																																	type: "binary",
																																},
																															),
																															Type.bitstringSegment(
																																Elixir_String_Chars[
																																	"to_string/1"
																																](
																																	Elixir_LeaplyWeb_Hologram_Pages_Listings_DetailPage[
																																		"lifecycle_class/1"
																																	](
																																		Interpreter.dotOperator(
																																			Interpreter.dotOperator(
																																				context
																																					.vars
																																					.vars_0,
																																				Type.atom(
																																					"detail",
																																				),
																																			),
																																			Type.atom(
																																				"lifecycle_tone",
																																			),
																																		),
																																	),
																																),
																																{
																																	type: "binary",
																																},
																															),
																														]),
																													]),
																												]),
																											]),
																										]),
																									]),
																									Type.list([
																										Type.tuple([
																											Type.atom("expression"),
																											Type.tuple([
																												Interpreter.dotOperator(
																													Interpreter.dotOperator(
																														context.vars.vars_0,
																														Type.atom("detail"),
																													),
																													Type.atom(
																														"lifecycle_label",
																													),
																												),
																											]),
																										]),
																									]),
																								]),
																								Type.tuple([
																									Type.atom("text"),
																									Type.bitstring(
																										"\n            ",
																									),
																								]),
																							]),
																						]),
																						Type.tuple([
																							Type.atom("text"),
																							Type.bitstring(
																								"\n\n            ",
																							),
																						]),
																						Type.tuple([
																							Type.atom("element"),
																							Type.bitstring("h1"),
																							Type.list([
																								Type.tuple([
																									Type.bitstring("class"),
																									Type.list([
																										Type.tuple([
																											Type.atom("text"),
																											Type.bitstring(
																												"mt-6 max-w-4xl break-words text-3xl font-black leading-tight tracking-[-0.035em] text-app-ink sm:text-5xl",
																											),
																										]),
																									]),
																								]),
																								Type.tuple([
																									Type.bitstring("id"),
																									Type.list([
																										Type.tuple([
																											Type.atom("text"),
																											Type.bitstring(
																												"listing-detail-title",
																											),
																										]),
																									]),
																								]),
																							]),
																							Type.list([
																								Type.tuple([
																									Type.atom("expression"),
																									Type.tuple([
																										Interpreter.dotOperator(
																											Interpreter.dotOperator(
																												context.vars.vars_0,
																												Type.atom("detail"),
																											),
																											Type.atom("title"),
																										),
																									]),
																								]),
																							]),
																						]),
																						Type.tuple([
																							Type.atom("text"),
																							Type.bitstring(
																								"\n\n            ",
																							),
																						]),
																						Type.tuple([
																							Type.atom("element"),
																							Type.bitstring("div"),
																							Type.list([
																								Type.tuple([
																									Type.bitstring("class"),
																									Type.list([
																										Type.tuple([
																											Type.atom("text"),
																											Type.bitstring(
																												"mt-6 flex items-center gap-3",
																											),
																										]),
																									]),
																								]),
																							]),
																							Type.list([
																								Type.tuple([
																									Type.atom("text"),
																									Type.bitstring(
																										"\n              ",
																									),
																								]),
																								Type.tuple([
																									Type.atom("element"),
																									Type.bitstring("span"),
																									Type.list([
																										Type.tuple([
																											Type.bitstring("class"),
																											Type.list([
																												Type.tuple([
																													Type.atom("text"),
																													Type.bitstring(
																														"flex h-11 w-11 items-center justify-center rounded-md bg-[#171C35] text-sm font-bold text-white",
																													),
																												]),
																											]),
																										]),
																									]),
																									Type.list([
																										Type.tuple([
																											Type.atom("expression"),
																											Type.tuple([
																												Interpreter.dotOperator(
																													Interpreter.dotOperator(
																														context.vars.vars_0,
																														Type.atom("detail"),
																													),
																													Type.atom(
																														"publisher_initial",
																													),
																												),
																											]),
																										]),
																									]),
																								]),
																								Type.tuple([
																									Type.atom("text"),
																									Type.bitstring(
																										"\n              ",
																									),
																								]),
																								Type.tuple([
																									Type.atom("element"),
																									Type.bitstring("div"),
																									Type.list([
																										Type.tuple([
																											Type.bitstring("class"),
																											Type.list([
																												Type.tuple([
																													Type.atom("text"),
																													Type.bitstring(
																														"min-w-0",
																													),
																												]),
																											]),
																										]),
																									]),
																									Type.list([
																										Type.tuple([
																											Type.atom("text"),
																											Type.bitstring(
																												"\n                ",
																											),
																										]),
																										Type.tuple([
																											Type.atom("element"),
																											Type.bitstring("p"),
																											Type.list([
																												Type.tuple([
																													Type.bitstring(
																														"class",
																													),
																													Type.list([
																														Type.tuple([
																															Type.atom("text"),
																															Type.bitstring(
																																"break-words text-sm font-bold text-app-ink",
																															),
																														]),
																													]),
																												]),
																											]),
																											Type.list([
																												Type.tuple([
																													Type.atom(
																														"expression",
																													),
																													Type.tuple([
																														Interpreter.dotOperator(
																															Interpreter.dotOperator(
																																context.vars
																																	.vars_0,
																																Type.atom(
																																	"detail",
																																),
																															),
																															Type.atom(
																																"publisher_name",
																															),
																														),
																													]),
																												]),
																											]),
																										]),
																										Type.tuple([
																											Type.atom("text"),
																											Type.bitstring(
																												"\n                ",
																											),
																										]),
																										Type.tuple([
																											Type.atom("element"),
																											Type.bitstring("p"),
																											Type.list([
																												Type.tuple([
																													Type.bitstring(
																														"class",
																													),
																													Type.list([
																														Type.tuple([
																															Type.atom("text"),
																															Type.bitstring(
																																"text-sm text-app-muted",
																															),
																														]),
																													]),
																												]),
																											]),
																											Type.list([
																												Type.tuple([
																													Type.atom("text"),
																													Type.bitstring(
																														"Opportunity publisher",
																													),
																												]),
																											]),
																										]),
																										Type.tuple([
																											Type.atom("text"),
																											Type.bitstring(
																												"\n              ",
																											),
																										]),
																									]),
																								]),
																								Type.tuple([
																									Type.atom("text"),
																									Type.bitstring(
																										"\n            ",
																									),
																								]),
																							]),
																						]),
																						Type.tuple([
																							Type.atom("text"),
																							Type.bitstring(
																								"\n\n            ",
																							),
																						]),
																						Interpreter.case(
																							Interpreter.dotOperator(
																								Interpreter.dotOperator(
																									context.vars.vars_0,
																									Type.atom("detail"),
																								),
																								Type.atom("summary"),
																							),
																							[
																								{
																									match:
																										Type.variablePattern("x_1"),
																									guards: [
																										(context) =>
																											Erlang["orelse/2"](
																												(context) =>
																													Erlang["=:=/2"](
																														context.vars.x_1,
																														Type.atom("false"),
																													),
																												(context) =>
																													Erlang["=:=/2"](
																														context.vars.x_1,
																														Type.atom("nil"),
																													),
																												context,
																											),
																									],
																									body: (context) => {
																										return Type.atom("nil");
																									},
																								},
																								{
																									match:
																										Type.matchPlaceholder(),
																									guards: [],
																									body: (context) => {
																										return Type.list([
																											Type.tuple([
																												Type.atom("text"),
																												Type.bitstring(
																													"\n              ",
																												),
																											]),
																											Type.tuple([
																												Type.atom("element"),
																												Type.bitstring("p"),
																												Type.list([
																													Type.tuple([
																														Type.bitstring(
																															"class",
																														),
																														Type.list([
																															Type.tuple([
																																Type.atom(
																																	"text",
																																),
																																Type.bitstring(
																																	"mt-7 max-w-3xl text-lg leading-8 text-app-muted",
																																),
																															]),
																														]),
																													]),
																												]),
																												Type.list([
																													Type.tuple([
																														Type.atom(
																															"expression",
																														),
																														Type.tuple([
																															Interpreter.dotOperator(
																																Interpreter.dotOperator(
																																	context.vars
																																		.vars_0,
																																	Type.atom(
																																		"detail",
																																	),
																																),
																																Type.atom(
																																	"summary",
																																),
																															),
																														]),
																													]),
																												]),
																											]),
																											Type.tuple([
																												Type.atom("text"),
																												Type.bitstring(
																													"\n            ",
																												),
																											]),
																										]);
																									},
																								},
																							],
																							context,
																						),
																						Type.tuple([
																							Type.atom("text"),
																							Type.bitstring(
																								"\n\n            ",
																							),
																						]),
																						Type.tuple([
																							Type.atom("element"),
																							Type.bitstring("dl"),
																							Type.list([
																								Type.tuple([
																									Type.bitstring("class"),
																									Type.list([
																										Type.tuple([
																											Type.atom("text"),
																											Type.bitstring(
																												"mt-8 grid gap-3 sm:grid-cols-3",
																											),
																										]),
																									]),
																								]),
																							]),
																							Type.list([
																								Type.tuple([
																									Type.atom("text"),
																									Type.bitstring(
																										"\n              ",
																									),
																								]),
																								Type.tuple([
																									Type.atom("element"),
																									Type.bitstring("div"),
																									Type.list([
																										Type.tuple([
																											Type.bitstring("class"),
																											Type.list([
																												Type.tuple([
																													Type.atom("text"),
																													Type.bitstring(
																														"rounded-md bg-app-surface-muted p-4",
																													),
																												]),
																											]),
																										]),
																									]),
																									Type.list([
																										Type.tuple([
																											Type.atom("text"),
																											Type.bitstring(
																												"\n                ",
																											),
																										]),
																										Type.tuple([
																											Type.atom("element"),
																											Type.bitstring("dt"),
																											Type.list([
																												Type.tuple([
																													Type.bitstring(
																														"class",
																													),
																													Type.list([
																														Type.tuple([
																															Type.atom("text"),
																															Type.bitstring(
																																"flex items-center gap-2 text-xs font-bold uppercase tracking-[0.14em] text-app-muted",
																															),
																														]),
																													]),
																												]),
																											]),
																											Type.list([
																												Type.tuple([
																													Type.atom("element"),
																													Type.bitstring(
																														"span",
																													),
																													Type.list([
																														Type.tuple([
																															Type.bitstring(
																																"class",
																															),
																															Type.list([
																																Type.tuple([
																																	Type.atom(
																																		"text",
																																	),
																																	Type.bitstring(
																																		"hero-map-pin h-4 w-4",
																																	),
																																]),
																															]),
																														]),
																														Type.tuple([
																															Type.bitstring(
																																"aria-hidden",
																															),
																															Type.list([
																																Type.tuple([
																																	Type.atom(
																																		"text",
																																	),
																																	Type.bitstring(
																																		"true",
																																	),
																																]),
																															]),
																														]),
																													]),
																													Type.list([]),
																												]),
																												Type.tuple([
																													Type.atom("text"),
																													Type.bitstring(
																														" Location",
																													),
																												]),
																											]),
																										]),
																										Type.tuple([
																											Type.atom("text"),
																											Type.bitstring(
																												"\n                ",
																											),
																										]),
																										Type.tuple([
																											Type.atom("element"),
																											Type.bitstring("dd"),
																											Type.list([
																												Type.tuple([
																													Type.bitstring(
																														"class",
																													),
																													Type.list([
																														Type.tuple([
																															Type.atom("text"),
																															Type.bitstring(
																																"mt-2 break-words text-sm font-semibold text-app-ink",
																															),
																														]),
																													]),
																												]),
																											]),
																											Type.list([
																												Type.tuple([
																													Type.atom(
																														"expression",
																													),
																													Type.tuple([
																														Interpreter.dotOperator(
																															Interpreter.dotOperator(
																																context.vars
																																	.vars_0,
																																Type.atom(
																																	"detail",
																																),
																															),
																															Type.atom(
																																"location_label",
																															),
																														),
																													]),
																												]),
																											]),
																										]),
																										Type.tuple([
																											Type.atom("text"),
																											Type.bitstring(
																												"\n              ",
																											),
																										]),
																									]),
																								]),
																								Type.tuple([
																									Type.atom("text"),
																									Type.bitstring(
																										"\n              ",
																									),
																								]),
																								Type.tuple([
																									Type.atom("element"),
																									Type.bitstring("div"),
																									Type.list([
																										Type.tuple([
																											Type.bitstring("class"),
																											Type.list([
																												Type.tuple([
																													Type.atom("text"),
																													Type.bitstring(
																														"rounded-md bg-app-surface-muted p-4",
																													),
																												]),
																											]),
																										]),
																									]),
																									Type.list([
																										Type.tuple([
																											Type.atom("text"),
																											Type.bitstring(
																												"\n                ",
																											),
																										]),
																										Type.tuple([
																											Type.atom("element"),
																											Type.bitstring("dt"),
																											Type.list([
																												Type.tuple([
																													Type.bitstring(
																														"class",
																													),
																													Type.list([
																														Type.tuple([
																															Type.atom("text"),
																															Type.bitstring(
																																"flex items-center gap-2 text-xs font-bold uppercase tracking-[0.14em] text-app-muted",
																															),
																														]),
																													]),
																												]),
																											]),
																											Type.list([
																												Type.tuple([
																													Type.atom("element"),
																													Type.bitstring(
																														"span",
																													),
																													Type.list([
																														Type.tuple([
																															Type.bitstring(
																																"class",
																															),
																															Type.list([
																																Type.tuple([
																																	Type.atom(
																																		"text",
																																	),
																																	Type.bitstring(
																																		"hero-language h-4 w-4",
																																	),
																																]),
																															]),
																														]),
																														Type.tuple([
																															Type.bitstring(
																																"aria-hidden",
																															),
																															Type.list([
																																Type.tuple([
																																	Type.atom(
																																		"text",
																																	),
																																	Type.bitstring(
																																		"true",
																																	),
																																]),
																															]),
																														]),
																													]),
																													Type.list([]),
																												]),
																												Type.tuple([
																													Type.atom("text"),
																													Type.bitstring(" "),
																												]),
																												Type.tuple([
																													Type.atom(
																														"expression",
																													),
																													Type.tuple([
																														Elixir_LeaplyWeb_Hologram_Pages_Listings_DetailPage[
																															"listings_text/1"
																														](
																															Type.bitstring(
																																"listings.discovery.language",
																															),
																														),
																													]),
																												]),
																											]),
																										]),
																										Type.tuple([
																											Type.atom("text"),
																											Type.bitstring(
																												"\n                ",
																											),
																										]),
																										Type.tuple([
																											Type.atom("element"),
																											Type.bitstring("dd"),
																											Type.list([
																												Type.tuple([
																													Type.bitstring(
																														"class",
																													),
																													Type.list([
																														Type.tuple([
																															Type.atom("text"),
																															Type.bitstring(
																																"mt-2 text-sm font-semibold text-app-ink",
																															),
																														]),
																													]),
																												]),
																											]),
																											Type.list([
																												Type.tuple([
																													Type.atom(
																														"expression",
																													),
																													Type.tuple([
																														Interpreter.dotOperator(
																															Interpreter.dotOperator(
																																context.vars
																																	.vars_0,
																																Type.atom(
																																	"detail",
																																),
																															),
																															Type.atom(
																																"locale_label",
																															),
																														),
																													]),
																												]),
																											]),
																										]),
																										Type.tuple([
																											Type.atom("text"),
																											Type.bitstring(
																												"\n              ",
																											),
																										]),
																									]),
																								]),
																								Type.tuple([
																									Type.atom("text"),
																									Type.bitstring(
																										"\n              ",
																									),
																								]),
																								Type.tuple([
																									Type.atom("element"),
																									Type.bitstring("div"),
																									Type.list([
																										Type.tuple([
																											Type.bitstring("class"),
																											Type.list([
																												Type.tuple([
																													Type.atom("text"),
																													Type.bitstring(
																														"rounded-md bg-app-surface-muted p-4",
																													),
																												]),
																											]),
																										]),
																									]),
																									Type.list([
																										Type.tuple([
																											Type.atom("text"),
																											Type.bitstring(
																												"\n                ",
																											),
																										]),
																										Type.tuple([
																											Type.atom("element"),
																											Type.bitstring("dt"),
																											Type.list([
																												Type.tuple([
																													Type.bitstring(
																														"class",
																													),
																													Type.list([
																														Type.tuple([
																															Type.atom("text"),
																															Type.bitstring(
																																"flex items-center gap-2 text-xs font-bold uppercase tracking-[0.14em] text-app-muted",
																															),
																														]),
																													]),
																												]),
																											]),
																											Type.list([
																												Type.tuple([
																													Type.atom("element"),
																													Type.bitstring(
																														"span",
																													),
																													Type.list([
																														Type.tuple([
																															Type.bitstring(
																																"class",
																															),
																															Type.list([
																																Type.tuple([
																																	Type.atom(
																																		"text",
																																	),
																																	Type.bitstring(
																																		"hero-calendar-days h-4 w-4",
																																	),
																																]),
																															]),
																														]),
																														Type.tuple([
																															Type.bitstring(
																																"aria-hidden",
																															),
																															Type.list([
																																Type.tuple([
																																	Type.atom(
																																		"text",
																																	),
																																	Type.bitstring(
																																		"true",
																																	),
																																]),
																															]),
																														]),
																													]),
																													Type.list([]),
																												]),
																												Type.tuple([
																													Type.atom("text"),
																													Type.bitstring(
																														" Deadline",
																													),
																												]),
																											]),
																										]),
																										Type.tuple([
																											Type.atom("text"),
																											Type.bitstring(
																												"\n                ",
																											),
																										]),
																										Type.tuple([
																											Type.atom("element"),
																											Type.bitstring("dd"),
																											Type.list([
																												Type.tuple([
																													Type.bitstring(
																														"class",
																													),
																													Type.list([
																														Type.tuple([
																															Type.atom("text"),
																															Type.bitstring(
																																"mt-2 text-sm font-semibold text-app-ink",
																															),
																														]),
																													]),
																												]),
																											]),
																											Type.list([
																												Type.tuple([
																													Type.atom(
																														"expression",
																													),
																													Type.tuple([
																														Interpreter.dotOperator(
																															Interpreter.dotOperator(
																																context.vars
																																	.vars_0,
																																Type.atom(
																																	"detail",
																																),
																															),
																															Type.atom(
																																"deadline_label",
																															),
																														),
																													]),
																												]),
																											]),
																										]),
																										Type.tuple([
																											Type.atom("text"),
																											Type.bitstring(
																												"\n              ",
																											),
																										]),
																									]),
																								]),
																								Type.tuple([
																									Type.atom("text"),
																									Type.bitstring(
																										"\n            ",
																									),
																								]),
																							]),
																						]),
																						Type.tuple([
																							Type.atom("text"),
																							Type.bitstring("\n          "),
																						]),
																					]),
																				]),
																				Type.tuple([
																					Type.atom("text"),
																					Type.bitstring("\n        "),
																				]),
																			]),
																		]),
																		Type.tuple([
																			Type.atom("text"),
																			Type.bitstring("\n\n        "),
																		]),
																		Type.tuple([
																			Type.atom("element"),
																			Type.bitstring("section"),
																			Type.list([
																				Type.tuple([
																					Type.bitstring("class"),
																					Type.list([
																						Type.tuple([
																							Type.atom("text"),
																							Type.bitstring(
																								"rounded-lg border border-app-border bg-app-surface p-6 shadow-sm sm:p-9",
																							),
																						]),
																					]),
																				]),
																				Type.tuple([
																					Type.bitstring("aria-labelledby"),
																					Type.list([
																						Type.tuple([
																							Type.atom("text"),
																							Type.bitstring(
																								"about-opportunity",
																							),
																						]),
																					]),
																				]),
																			]),
																			Type.list([
																				Type.tuple([
																					Type.atom("text"),
																					Type.bitstring("\n          "),
																				]),
																				Type.tuple([
																					Type.atom("element"),
																					Type.bitstring("h2"),
																					Type.list([
																						Type.tuple([
																							Type.bitstring("class"),
																							Type.list([
																								Type.tuple([
																									Type.atom("text"),
																									Type.bitstring(
																										"text-2xl font-black tracking-tight text-app-ink",
																									),
																								]),
																							]),
																						]),
																						Type.tuple([
																							Type.bitstring("id"),
																							Type.list([
																								Type.tuple([
																									Type.atom("text"),
																									Type.bitstring(
																										"about-opportunity",
																									),
																								]),
																							]),
																						]),
																					]),
																					Type.list([
																						Type.tuple([
																							Type.atom("text"),
																							Type.bitstring(
																								"About this opportunity",
																							),
																						]),
																					]),
																				]),
																				Type.tuple([
																					Type.atom("text"),
																					Type.bitstring("\n          "),
																				]),
																				Type.tuple([
																					Type.atom("element"),
																					Type.bitstring("div"),
																					Type.list([
																						Type.tuple([
																							Type.bitstring("class"),
																							Type.list([
																								Type.tuple([
																									Type.atom("text"),
																									Type.bitstring(
																										"mt-6 max-w-4xl",
																									),
																								]),
																							]),
																						]),
																					]),
																					Type.list([
																						Type.tuple([
																							Type.atom("text"),
																							Type.bitstring("\n            "),
																						]),
																						Interpreter.case(
																							Erlang[">/2"](
																								Erlang["length/1"](
																									Interpreter.dotOperator(
																										Interpreter.dotOperator(
																											context.vars.vars_0,
																											Type.atom("detail"),
																										),
																										Type.atom("body_blocks"),
																									),
																								),
																								Type.integer(0n),
																							),
																							[
																								{
																									match: Type.atom("false"),
																									guards: [],
																									body: (context) => {
																										return Type.list([
																											Type.tuple([
																												Type.atom("text"),
																												Type.bitstring(
																													"\n              ",
																												),
																											]),
																											Type.tuple([
																												Type.atom("element"),
																												Type.bitstring("p"),
																												Type.list([
																													Type.tuple([
																														Type.bitstring(
																															"class",
																														),
																														Type.list([
																															Type.tuple([
																																Type.atom(
																																	"text",
																																),
																																Type.bitstring(
																																	"leading-8 text-app-muted",
																																),
																															]),
																														]),
																													]),
																												]),
																												Type.list([
																													Type.tuple([
																														Type.atom(
																															"expression",
																														),
																														Type.tuple([
																															Interpreter.dotOperator(
																																Interpreter.dotOperator(
																																	context.vars
																																		.vars_0,
																																	Type.atom(
																																		"detail",
																																	),
																																),
																																Type.atom(
																																	"summary",
																																),
																															),
																														]),
																													]),
																												]),
																											]),
																											Type.tuple([
																												Type.atom("text"),
																												Type.bitstring(
																													"\n            ",
																												),
																											]),
																										]);
																									},
																								},
																								{
																									match: Type.atom("true"),
																									guards: [],
																									body: (context) => {
																										return Type.list([
																											Type.tuple([
																												Type.atom("text"),
																												Type.bitstring(
																													"\n              ",
																												),
																											]),
																											Type.tuple([
																												Type.atom("component"),
																												Type.atom(
																													"Elixir.LeaplyWeb.Hologram.Components.Listings.ListingBody",
																												),
																												Type.list([
																													Type.tuple([
																														Type.bitstring(
																															"blocks",
																														),
																														Type.list([
																															Type.tuple([
																																Type.atom(
																																	"expression",
																																),
																																Type.tuple([
																																	Interpreter.dotOperator(
																																		Interpreter.dotOperator(
																																			context
																																				.vars
																																				.vars_0,
																																			Type.atom(
																																				"detail",
																																			),
																																		),
																																		Type.atom(
																																			"body_blocks",
																																		),
																																	),
																																]),
																															]),
																														]),
																													]),
																												]),
																												Type.list([]),
																											]),
																											Type.tuple([
																												Type.atom("text"),
																												Type.bitstring(
																													"\n            ",
																												),
																											]),
																										]);
																									},
																								},
																							],
																							context,
																						),
																						Type.tuple([
																							Type.atom("text"),
																							Type.bitstring("\n          "),
																						]),
																					]),
																				]),
																				Type.tuple([
																					Type.atom("text"),
																					Type.bitstring("\n        "),
																				]),
																			]),
																		]),
																		Type.tuple([
																			Type.atom("text"),
																			Type.bitstring("\n\n        "),
																		]),
																		Interpreter.case(
																			Erlang[">/2"](
																				Erlang["length/1"](
																					Interpreter.dotOperator(
																						Interpreter.dotOperator(
																							context.vars.vars_0,
																							Type.atom("detail"),
																						),
																						Type.atom("locations"),
																					),
																				),
																				Type.integer(0n),
																			),
																			[
																				{
																					match: Type.atom("false"),
																					guards: [],
																					body: (context) => {
																						return Type.atom("nil");
																					},
																				},
																				{
																					match: Type.atom("true"),
																					guards: [],
																					body: (context) => {
																						return Type.list([
																							Type.tuple([
																								Type.atom("text"),
																								Type.bitstring("\n          "),
																							]),
																							Type.tuple([
																								Type.atom("element"),
																								Type.bitstring("section"),
																								Type.list([
																									Type.tuple([
																										Type.bitstring("class"),
																										Type.list([
																											Type.tuple([
																												Type.atom("text"),
																												Type.bitstring(
																													"rounded-lg border border-app-border bg-app-surface p-6 shadow-sm sm:p-9",
																												),
																											]),
																										]),
																									]),
																									Type.tuple([
																										Type.bitstring(
																											"aria-labelledby",
																										),
																										Type.list([
																											Type.tuple([
																												Type.atom("text"),
																												Type.bitstring(
																													"locations-heading",
																												),
																											]),
																										]),
																									]),
																								]),
																								Type.list([
																									Type.tuple([
																										Type.atom("text"),
																										Type.bitstring(
																											"\n            ",
																										),
																									]),
																									Type.tuple([
																										Type.atom("element"),
																										Type.bitstring("h2"),
																										Type.list([
																											Type.tuple([
																												Type.bitstring("class"),
																												Type.list([
																													Type.tuple([
																														Type.atom("text"),
																														Type.bitstring(
																															"text-2xl font-black tracking-tight text-app-ink",
																														),
																													]),
																												]),
																											]),
																											Type.tuple([
																												Type.bitstring("id"),
																												Type.list([
																													Type.tuple([
																														Type.atom("text"),
																														Type.bitstring(
																															"locations-heading",
																														),
																													]),
																												]),
																											]),
																										]),
																										Type.list([
																											Type.tuple([
																												Type.atom("text"),
																												Type.bitstring(
																													"Where you could join",
																												),
																											]),
																										]),
																									]),
																									Type.tuple([
																										Type.atom("text"),
																										Type.bitstring(
																											"\n            ",
																										),
																									]),
																									Type.tuple([
																										Type.atom("element"),
																										Type.bitstring("div"),
																										Type.list([
																											Type.tuple([
																												Type.bitstring("class"),
																												Type.list([
																													Type.tuple([
																														Type.atom("text"),
																														Type.bitstring(
																															"mt-5 grid gap-3 sm:grid-cols-2",
																														),
																													]),
																												]),
																											]),
																										]),
																										Type.list([
																											Type.tuple([
																												Type.atom("text"),
																												Type.bitstring(
																													"\n              ",
																												),
																											]),
																											Interpreter.comprehension(
																												[
																													{
																														match:
																															Type.variablePattern(
																																"location_2",
																															),
																														guards: [],
																														body: (context) =>
																															Interpreter.dotOperator(
																																Interpreter.dotOperator(
																																	context.vars
																																		.vars_0,
																																	Type.atom(
																																		"detail",
																																	),
																																),
																																Type.atom(
																																	"locations",
																																),
																															),
																													},
																												],
																												[],
																												Type.list([]),
																												false,
																												(context) => {
																													return Type.list([
																														Type.tuple([
																															Type.atom("text"),
																															Type.bitstring(
																																"\n                ",
																															),
																														]),
																														Type.tuple([
																															Type.atom(
																																"element",
																															),
																															Type.bitstring(
																																"div",
																															),
																															Type.list([
																																Type.tuple([
																																	Type.bitstring(
																																		"class",
																																	),
																																	Type.list([
																																		Type.tuple([
																																			Type.atom(
																																				"text",
																																			),
																																			Type.bitstring(
																																				"rounded-md border border-app-border bg-app-surface-muted p-4",
																																			),
																																		]),
																																	]),
																																]),
																															]),
																															Type.list([
																																Type.tuple([
																																	Type.atom(
																																		"text",
																																	),
																																	Type.bitstring(
																																		"\n                  ",
																																	),
																																]),
																																Type.tuple([
																																	Type.atom(
																																		"element",
																																	),
																																	Type.bitstring(
																																		"span",
																																	),
																																	Type.list([
																																		Type.tuple([
																																			Type.bitstring(
																																				"class",
																																			),
																																			Type.list(
																																				[
																																					Type.tuple(
																																						[
																																							Type.atom(
																																								"text",
																																							),
																																							Type.bitstring(
																																								"text-xs font-bold uppercase tracking-[0.14em] text-blue-600 dark:text-blue-300",
																																							),
																																						],
																																					),
																																				],
																																			),
																																		]),
																																	]),
																																	Type.list([
																																		Type.tuple([
																																			Type.atom(
																																				"expression",
																																			),
																																			Type.tuple(
																																				[
																																					Interpreter.dotOperator(
																																						context
																																							.vars
																																							.location_2,
																																						Type.atom(
																																							"type_label",
																																						),
																																					),
																																				],
																																			),
																																		]),
																																	]),
																																]),
																																Type.tuple([
																																	Type.atom(
																																		"text",
																																	),
																																	Type.bitstring(
																																		"\n                  ",
																																	),
																																]),
																																Type.tuple([
																																	Type.atom(
																																		"element",
																																	),
																																	Type.bitstring(
																																		"p",
																																	),
																																	Type.list([
																																		Type.tuple([
																																			Type.bitstring(
																																				"class",
																																			),
																																			Type.list(
																																				[
																																					Type.tuple(
																																						[
																																							Type.atom(
																																								"text",
																																							),
																																							Type.bitstring(
																																								"mt-2 break-words font-bold text-app-ink",
																																							),
																																						],
																																					),
																																				],
																																			),
																																		]),
																																	]),
																																	Type.list([
																																		Type.tuple([
																																			Type.atom(
																																				"expression",
																																			),
																																			Type.tuple(
																																				[
																																					Interpreter.dotOperator(
																																						context
																																							.vars
																																							.location_2,
																																						Type.atom(
																																							"label",
																																						),
																																					),
																																				],
																																			),
																																		]),
																																	]),
																																]),
																																Type.tuple([
																																	Type.atom(
																																		"text",
																																	),
																																	Type.bitstring(
																																		"\n                ",
																																	),
																																]),
																															]),
																														]),
																														Type.tuple([
																															Type.atom("text"),
																															Type.bitstring(
																																"\n              ",
																															),
																														]),
																													]);
																												},
																												context,
																											),
																											Type.tuple([
																												Type.atom("text"),
																												Type.bitstring(
																													"\n            ",
																												),
																											]),
																										]),
																									]),
																									Type.tuple([
																										Type.atom("text"),
																										Type.bitstring(
																											"\n          ",
																										),
																									]),
																								]),
																							]),
																							Type.tuple([
																								Type.atom("text"),
																								Type.bitstring("\n        "),
																							]),
																						]);
																					},
																				},
																			],
																			context,
																		),
																		Type.tuple([
																			Type.atom("text"),
																			Type.bitstring("\n\n        "),
																		]),
																		Type.tuple([
																			Type.atom("element"),
																			Type.bitstring("section"),
																			Type.list([
																				Type.tuple([
																					Type.bitstring("class"),
																					Type.list([
																						Type.tuple([
																							Type.atom("text"),
																							Type.bitstring(
																								"rounded-lg border border-app-border bg-app-surface p-6 shadow-sm sm:p-9",
																							),
																						]),
																					]),
																				]),
																				Type.tuple([
																					Type.bitstring("aria-labelledby"),
																					Type.list([
																						Type.tuple([
																							Type.atom("text"),
																							Type.bitstring(
																								"application-expectations-heading",
																							),
																						]),
																					]),
																				]),
																			]),
																			Type.list([
																				Type.tuple([
																					Type.atom("text"),
																					Type.bitstring("\n          "),
																				]),
																				Type.tuple([
																					Type.atom("element"),
																					Type.bitstring("h2"),
																					Type.list([
																						Type.tuple([
																							Type.bitstring("class"),
																							Type.list([
																								Type.tuple([
																									Type.atom("text"),
																									Type.bitstring(
																										"text-2xl font-black tracking-tight text-app-ink",
																									),
																								]),
																							]),
																						]),
																						Type.tuple([
																							Type.bitstring("id"),
																							Type.list([
																								Type.tuple([
																									Type.atom("text"),
																									Type.bitstring(
																										"application-expectations-heading",
																									),
																								]),
																							]),
																						]),
																					]),
																					Type.list([
																						Type.tuple([
																							Type.atom("text"),
																							Type.bitstring(
																								"What applying involves",
																							),
																						]),
																					]),
																				]),
																				Type.tuple([
																					Type.atom("text"),
																					Type.bitstring("\n          "),
																				]),
																				Type.tuple([
																					Type.atom("element"),
																					Type.bitstring("ul"),
																					Type.list([
																						Type.tuple([
																							Type.bitstring("class"),
																							Type.list([
																								Type.tuple([
																									Type.atom("text"),
																									Type.bitstring(
																										"mt-5 grid gap-3 text-sm leading-6 text-app-muted sm:grid-cols-2",
																									),
																								]),
																							]),
																						]),
																					]),
																					Type.list([
																						Type.tuple([
																							Type.atom("text"),
																							Type.bitstring("\n            "),
																						]),
																						Type.tuple([
																							Type.atom("element"),
																							Type.bitstring("li"),
																							Type.list([
																								Type.tuple([
																									Type.bitstring("class"),
																									Type.list([
																										Type.tuple([
																											Type.atom("text"),
																											Type.bitstring(
																												"flex gap-3 rounded-md bg-app-surface-muted p-4",
																											),
																										]),
																									]),
																								]),
																							]),
																							Type.list([
																								Type.tuple([
																									Type.atom("element"),
																									Type.bitstring("span"),
																									Type.list([
																										Type.tuple([
																											Type.bitstring("class"),
																											Type.list([
																												Type.tuple([
																													Type.atom("text"),
																													Type.bitstring(
																														"hero-chat-bubble-left-right h-5 w-5 shrink-0 text-blue-600 dark:text-blue-400",
																													),
																												]),
																											]),
																										]),
																										Type.tuple([
																											Type.bitstring(
																												"aria-hidden",
																											),
																											Type.list([
																												Type.tuple([
																													Type.atom("text"),
																													Type.bitstring(
																														"true",
																													),
																												]),
																											]),
																										]),
																									]),
																									Type.list([]),
																								]),
																								Type.tuple([
																									Type.atom("expression"),
																									Type.tuple([
																										Elixir_LeaplyWeb_Hologram_Pages_Listings_DetailPage[
																											"question_expectation/1"
																										](
																											Interpreter.dotOperator(
																												Interpreter.dotOperator(
																													Interpreter.dotOperator(
																														context.vars.vars_0,
																														Type.atom("detail"),
																													),
																													Type.atom(
																														"response_expectations",
																													),
																												),
																												Type.atom(
																													"question_count",
																												),
																											),
																										),
																									]),
																								]),
																							]),
																						]),
																						Type.tuple([
																							Type.atom("text"),
																							Type.bitstring("\n            "),
																						]),
																						Type.tuple([
																							Type.atom("element"),
																							Type.bitstring("li"),
																							Type.list([
																								Type.tuple([
																									Type.bitstring("class"),
																									Type.list([
																										Type.tuple([
																											Type.atom("text"),
																											Type.bitstring(
																												"flex gap-3 rounded-md bg-app-surface-muted p-4",
																											),
																										]),
																									]),
																								]),
																							]),
																							Type.list([
																								Type.tuple([
																									Type.atom("element"),
																									Type.bitstring("span"),
																									Type.list([
																										Type.tuple([
																											Type.bitstring("class"),
																											Type.list([
																												Type.tuple([
																													Type.atom("text"),
																													Type.bitstring(
																														"hero-shield-check h-5 w-5 shrink-0 text-blue-600 dark:text-blue-400",
																													),
																												]),
																											]),
																										]),
																										Type.tuple([
																											Type.bitstring(
																												"aria-hidden",
																											),
																											Type.list([
																												Type.tuple([
																													Type.atom("text"),
																													Type.bitstring(
																														"true",
																													),
																												]),
																											]),
																										]),
																									]),
																									Type.list([]),
																								]),
																								Type.tuple([
																									Type.atom("expression"),
																									Type.tuple([
																										Elixir_LeaplyWeb_Hologram_Pages_Listings_DetailPage[
																											"requirement_expectation/1"
																										](
																											Interpreter.dotOperator(
																												Interpreter.dotOperator(
																													Interpreter.dotOperator(
																														context.vars.vars_0,
																														Type.atom("detail"),
																													),
																													Type.atom(
																														"response_expectations",
																													),
																												),
																												Type.atom(
																													"requirement_count",
																												),
																											),
																										),
																									]),
																								]),
																							]),
																						]),
																						Type.tuple([
																							Type.atom("text"),
																							Type.bitstring("\n            "),
																						]),
																						Interpreter.case(
																							Interpreter.dotOperator(
																								Interpreter.dotOperator(
																									Interpreter.dotOperator(
																										context.vars.vars_0,
																										Type.atom("detail"),
																									),
																									Type.atom(
																										"response_expectations",
																									),
																								),
																								Type.atom("profile_required?"),
																							),
																							[
																								{
																									match:
																										Type.variablePattern("x_3"),
																									guards: [
																										(context) =>
																											Erlang["orelse/2"](
																												(context) =>
																													Erlang["=:=/2"](
																														context.vars.x_3,
																														Type.atom("false"),
																													),
																												(context) =>
																													Erlang["=:=/2"](
																														context.vars.x_3,
																														Type.atom("nil"),
																													),
																												context,
																											),
																									],
																									body: (context) => {
																										return Type.atom("nil");
																									},
																								},
																								{
																									match:
																										Type.matchPlaceholder(),
																									guards: [],
																									body: (context) => {
																										return Type.list([
																											Type.tuple([
																												Type.atom("element"),
																												Type.bitstring("li"),
																												Type.list([
																													Type.tuple([
																														Type.bitstring(
																															"class",
																														),
																														Type.list([
																															Type.tuple([
																																Type.atom(
																																	"text",
																																),
																																Type.bitstring(
																																	"flex gap-3 rounded-md bg-app-surface-muted p-4 sm:col-span-2",
																																),
																															]),
																														]),
																													]),
																												]),
																												Type.list([
																													Type.tuple([
																														Type.atom(
																															"element",
																														),
																														Type.bitstring(
																															"span",
																														),
																														Type.list([
																															Type.tuple([
																																Type.bitstring(
																																	"class",
																																),
																																Type.list([
																																	Type.tuple([
																																		Type.atom(
																																			"text",
																																		),
																																		Type.bitstring(
																																			"hero-user-circle h-5 w-5 shrink-0 text-blue-600 dark:text-blue-400",
																																		),
																																	]),
																																]),
																															]),
																															Type.tuple([
																																Type.bitstring(
																																	"aria-hidden",
																																),
																																Type.list([
																																	Type.tuple([
																																		Type.atom(
																																			"text",
																																		),
																																		Type.bitstring(
																																			"true",
																																		),
																																	]),
																																]),
																															]),
																														]),
																														Type.list([]),
																													]),
																													Type.tuple([
																														Type.atom("text"),
																														Type.bitstring(
																															"A completed reusable profile is required before submission.",
																														),
																													]),
																												]),
																											]),
																										]);
																									},
																								},
																							],
																							context,
																						),
																						Type.tuple([
																							Type.atom("text"),
																							Type.bitstring("\n          "),
																						]),
																					]),
																				]),
																				Type.tuple([
																					Type.atom("text"),
																					Type.bitstring("\n        "),
																				]),
																			]),
																		]),
																		Type.tuple([
																			Type.atom("text"),
																			Type.bitstring("\n\n        "),
																		]),
																		Type.tuple([
																			Type.atom("element"),
																			Type.bitstring("section"),
																			Type.list([
																				Type.tuple([
																					Type.bitstring("class"),
																					Type.list([
																						Type.tuple([
																							Type.atom("text"),
																							Type.bitstring(
																								"rounded-lg border border-indigo-100 bg-indigo-50/50 p-6 sm:p-8 dark:border-indigo-900 dark:bg-indigo-950/35",
																							),
																						]),
																					]),
																				]),
																				Type.tuple([
																					Type.bitstring("aria-labelledby"),
																					Type.list([
																						Type.tuple([
																							Type.atom("text"),
																							Type.bitstring("sharing-heading"),
																						]),
																					]),
																				]),
																			]),
																			Type.list([
																				Type.tuple([
																					Type.atom("text"),
																					Type.bitstring("\n          "),
																				]),
																				Type.tuple([
																					Type.atom("element"),
																					Type.bitstring("h2"),
																					Type.list([
																						Type.tuple([
																							Type.bitstring("class"),
																							Type.list([
																								Type.tuple([
																									Type.atom("text"),
																									Type.bitstring(
																										"text-xl font-black tracking-tight text-app-ink",
																									),
																								]),
																							]),
																						]),
																						Type.tuple([
																							Type.bitstring("id"),
																							Type.list([
																								Type.tuple([
																									Type.atom("text"),
																									Type.bitstring(
																										"sharing-heading",
																									),
																								]),
																							]),
																						]),
																					]),
																					Type.list([
																						Type.tuple([
																							Type.atom("text"),
																							Type.bitstring(
																								"You stay in control of what is shared",
																							),
																						]),
																					]),
																				]),
																				Type.tuple([
																					Type.atom("text"),
																					Type.bitstring("\n          "),
																				]),
																				Type.tuple([
																					Type.atom("element"),
																					Type.bitstring("ul"),
																					Type.list([
																						Type.tuple([
																							Type.bitstring("class"),
																							Type.list([
																								Type.tuple([
																									Type.atom("text"),
																									Type.bitstring(
																										"mt-4 space-y-3 text-sm leading-6 text-app-muted",
																									),
																								]),
																							]),
																						]),
																					]),
																					Type.list([
																						Type.tuple([
																							Type.atom("text"),
																							Type.bitstring("\n            "),
																						]),
																						Type.tuple([
																							Type.atom("element"),
																							Type.bitstring("li"),
																							Type.list([
																								Type.tuple([
																									Type.bitstring("class"),
																									Type.list([
																										Type.tuple([
																											Type.atom("text"),
																											Type.bitstring(
																												"flex gap-3",
																											),
																										]),
																									]),
																								]),
																							]),
																							Type.list([
																								Type.tuple([
																									Type.atom("element"),
																									Type.bitstring("span"),
																									Type.list([
																										Type.tuple([
																											Type.bitstring("class"),
																											Type.list([
																												Type.tuple([
																													Type.atom("text"),
																													Type.bitstring(
																														"hero-check-circle h-5 w-5 shrink-0 text-indigo-600",
																													),
																												]),
																											]),
																										]),
																										Type.tuple([
																											Type.bitstring(
																												"aria-hidden",
																											),
																											Type.list([
																												Type.tuple([
																													Type.atom("text"),
																													Type.bitstring(
																														"true",
																													),
																												]),
																											]),
																										]),
																									]),
																									Type.list([]),
																								]),
																								Type.tuple([
																									Type.atom("text"),
																									Type.bitstring(
																										"Your contact details and this application",
																									),
																								]),
																							]),
																						]),
																						Type.tuple([
																							Type.atom("text"),
																							Type.bitstring("\n            "),
																						]),
																						Interpreter.case(
																							Interpreter.dotOperator(
																								Interpreter.dotOperator(
																									context.vars.vars_0,
																									Type.atom("detail"),
																								),
																								Type.atom(
																									"share_profile_projection",
																								),
																							),
																							[
																								{
																									match:
																										Type.variablePattern("x_4"),
																									guards: [
																										(context) =>
																											Erlang["orelse/2"](
																												(context) =>
																													Erlang["=:=/2"](
																														context.vars.x_4,
																														Type.atom("false"),
																													),
																												(context) =>
																													Erlang["=:=/2"](
																														context.vars.x_4,
																														Type.atom("nil"),
																													),
																												context,
																											),
																									],
																									body: (context) => {
																										return Type.atom("nil");
																									},
																								},
																								{
																									match:
																										Type.matchPlaceholder(),
																									guards: [],
																									body: (context) => {
																										return Type.list([
																											Type.tuple([
																												Type.atom("element"),
																												Type.bitstring("li"),
																												Type.list([
																													Type.tuple([
																														Type.bitstring(
																															"class",
																														),
																														Type.list([
																															Type.tuple([
																																Type.atom(
																																	"text",
																																),
																																Type.bitstring(
																																	"flex gap-3",
																																),
																															]),
																														]),
																													]),
																												]),
																												Type.list([
																													Type.tuple([
																														Type.atom(
																															"element",
																														),
																														Type.bitstring(
																															"span",
																														),
																														Type.list([
																															Type.tuple([
																																Type.bitstring(
																																	"class",
																																),
																																Type.list([
																																	Type.tuple([
																																		Type.atom(
																																			"text",
																																		),
																																		Type.bitstring(
																																			"hero-check-circle h-5 w-5 shrink-0 text-indigo-600",
																																		),
																																	]),
																																]),
																															]),
																															Type.tuple([
																																Type.bitstring(
																																	"aria-hidden",
																																),
																																Type.list([
																																	Type.tuple([
																																		Type.atom(
																																			"text",
																																		),
																																		Type.bitstring(
																																			"true",
																																		),
																																	]),
																																]),
																															]),
																														]),
																														Type.list([]),
																													]),
																													Type.tuple([
																														Type.atom("text"),
																														Type.bitstring(
																															"Your reusable Leaply profile",
																														),
																													]),
																												]),
																											]),
																										]);
																									},
																								},
																							],
																							context,
																						),
																						Type.tuple([
																							Type.atom("text"),
																							Type.bitstring("\n            "),
																						]),
																						Interpreter.case(
																							Interpreter.dotOperator(
																								Interpreter.dotOperator(
																									context.vars.vars_0,
																									Type.atom("detail"),
																								),
																								Type.atom(
																									"share_screening_answers",
																								),
																							),
																							[
																								{
																									match:
																										Type.variablePattern("x_5"),
																									guards: [
																										(context) =>
																											Erlang["orelse/2"](
																												(context) =>
																													Erlang["=:=/2"](
																														context.vars.x_5,
																														Type.atom("false"),
																													),
																												(context) =>
																													Erlang["=:=/2"](
																														context.vars.x_5,
																														Type.atom("nil"),
																													),
																												context,
																											),
																									],
																									body: (context) => {
																										return Type.atom("nil");
																									},
																								},
																								{
																									match:
																										Type.matchPlaceholder(),
																									guards: [],
																									body: (context) => {
																										return Type.list([
																											Type.tuple([
																												Type.atom("element"),
																												Type.bitstring("li"),
																												Type.list([
																													Type.tuple([
																														Type.bitstring(
																															"class",
																														),
																														Type.list([
																															Type.tuple([
																																Type.atom(
																																	"text",
																																),
																																Type.bitstring(
																																	"flex gap-3",
																																),
																															]),
																														]),
																													]),
																												]),
																												Type.list([
																													Type.tuple([
																														Type.atom(
																															"element",
																														),
																														Type.bitstring(
																															"span",
																														),
																														Type.list([
																															Type.tuple([
																																Type.bitstring(
																																	"class",
																																),
																																Type.list([
																																	Type.tuple([
																																		Type.atom(
																																			"text",
																																		),
																																		Type.bitstring(
																																			"hero-check-circle h-5 w-5 shrink-0 text-indigo-600",
																																		),
																																	]),
																																]),
																															]),
																															Type.tuple([
																																Type.bitstring(
																																	"aria-hidden",
																																),
																																Type.list([
																																	Type.tuple([
																																		Type.atom(
																																			"text",
																																		),
																																		Type.bitstring(
																																			"true",
																																		),
																																	]),
																																]),
																															]),
																														]),
																														Type.list([]),
																													]),
																													Type.tuple([
																														Type.atom("text"),
																														Type.bitstring(
																															"Your answers for this opportunity",
																														),
																													]),
																												]),
																											]),
																										]);
																									},
																								},
																							],
																							context,
																						),
																						Type.tuple([
																							Type.atom("text"),
																							Type.bitstring("\n          "),
																						]),
																					]),
																				]),
																				Type.tuple([
																					Type.atom("text"),
																					Type.bitstring("\n        "),
																				]),
																			]),
																		]),
																		Type.tuple([
																			Type.atom("text"),
																			Type.bitstring("\n      "),
																		]),
																	]),
																]),
																Type.tuple([
																	Type.atom("text"),
																	Type.bitstring("\n\n      "),
																]),
																Type.tuple([
																	Type.atom("element"),
																	Type.bitstring("aside"),
																	Type.list([
																		Type.tuple([
																			Type.bitstring("class"),
																			Type.list([
																				Type.tuple([
																					Type.atom("text"),
																					Type.bitstring(
																						"hidden lg:sticky lg:top-28 lg:block",
																					),
																				]),
																			]),
																		]),
																	]),
																	Type.list([
																		Type.tuple([
																			Type.atom("text"),
																			Type.bitstring("\n        "),
																		]),
																		Type.tuple([
																			Type.atom("element"),
																			Type.bitstring("div"),
																			Type.list([
																				Type.tuple([
																					Type.bitstring("class"),
																					Type.list([
																						Type.tuple([
																							Type.atom("text"),
																							Type.bitstring(
																								"rounded-lg border border-app-border bg-app-surface p-6 shadow-[0_20px_55px_rgba(23,28,53,0.10)] dark:shadow-[0_20px_55px_rgba(0,0,0,0.34)]",
																							),
																						]),
																					]),
																				]),
																			]),
																			Type.list([
																				Type.tuple([
																					Type.atom("text"),
																					Type.bitstring("\n          "),
																				]),
																				Type.tuple([
																					Type.atom("element"),
																					Type.bitstring("p"),
																					Type.list([
																						Type.tuple([
																							Type.bitstring("class"),
																							Type.list([
																								Type.tuple([
																									Type.atom("text"),
																									Type.bitstring(
																										"text-xs font-bold uppercase tracking-[0.16em] text-app-muted",
																									),
																								]),
																							]),
																						]),
																					]),
																					Type.list([
																						Type.tuple([
																							Type.atom("text"),
																							Type.bitstring("Your next step"),
																						]),
																					]),
																				]),
																				Type.tuple([
																					Type.atom("text"),
																					Type.bitstring("\n          "),
																				]),
																				Type.tuple([
																					Type.atom("element"),
																					Type.bitstring("h2"),
																					Type.list([
																						Type.tuple([
																							Type.bitstring("class"),
																							Type.list([
																								Type.tuple([
																									Type.atom("text"),
																									Type.bitstring(
																										"mt-3 text-xl font-black tracking-tight text-app-ink",
																									),
																								]),
																							]),
																						]),
																					]),
																					Type.list([
																						Type.tuple([
																							Type.atom("expression"),
																							Type.tuple([
																								Interpreter.dotOperator(
																									Interpreter.dotOperator(
																										context.vars.vars_0,
																										Type.atom("action"),
																									),
																									Type.atom("label"),
																								),
																							]),
																						]),
																					]),
																				]),
																				Type.tuple([
																					Type.atom("text"),
																					Type.bitstring("\n          "),
																				]),
																				Interpreter.case(
																					Interpreter.dotOperator(
																						Interpreter.dotOperator(
																							context.vars.vars_0,
																							Type.atom("action"),
																						),
																						Type.atom("description"),
																					),
																					[
																						{
																							match:
																								Type.variablePattern("x_6"),
																							guards: [
																								(context) =>
																									Erlang["orelse/2"](
																										(context) =>
																											Erlang["=:=/2"](
																												context.vars.x_6,
																												Type.atom("false"),
																											),
																										(context) =>
																											Erlang["=:=/2"](
																												context.vars.x_6,
																												Type.atom("nil"),
																											),
																										context,
																									),
																							],
																							body: (context) => {
																								return Type.atom("nil");
																							},
																						},
																						{
																							match: Type.matchPlaceholder(),
																							guards: [],
																							body: (context) => {
																								return Type.list([
																									Type.tuple([
																										Type.atom("element"),
																										Type.bitstring("p"),
																										Type.list([
																											Type.tuple([
																												Type.bitstring("class"),
																												Type.list([
																													Type.tuple([
																														Type.atom("text"),
																														Type.bitstring(
																															"mt-3 text-sm leading-6 text-app-muted",
																														),
																													]),
																												]),
																											]),
																										]),
																										Type.list([
																											Type.tuple([
																												Type.atom("expression"),
																												Type.tuple([
																													Interpreter.dotOperator(
																														Interpreter.dotOperator(
																															context.vars
																																.vars_0,
																															Type.atom(
																																"action",
																															),
																														),
																														Type.atom(
																															"description",
																														),
																													),
																												]),
																											]),
																										]),
																									]),
																								]);
																							},
																						},
																					],
																					context,
																				),
																				Type.tuple([
																					Type.atom("text"),
																					Type.bitstring("\n          "),
																				]),
																				Interpreter.case(
																					Interpreter.dotOperator(
																						Interpreter.dotOperator(
																							context.vars.vars_0,
																							Type.atom("action"),
																						),
																						Type.atom("available?"),
																					),
																					[
																						{
																							match:
																								Type.variablePattern("x_7"),
																							guards: [
																								(context) =>
																									Erlang["orelse/2"](
																										(context) =>
																											Erlang["=:=/2"](
																												context.vars.x_7,
																												Type.atom("false"),
																											),
																										(context) =>
																											Erlang["=:=/2"](
																												context.vars.x_7,
																												Type.atom("nil"),
																											),
																										context,
																									),
																							],
																							body: (context) => {
																								return Type.list([
																									Type.tuple([
																										Type.atom("text"),
																										Type.bitstring(
																											"\n            ",
																										),
																									]),
																									Type.tuple([
																										Type.atom("element"),
																										Type.bitstring("span"),
																										Type.list([
																											Type.tuple([
																												Type.bitstring("class"),
																												Type.list([
																													Type.tuple([
																														Type.atom(
																															"expression",
																														),
																														Type.tuple([
																															Type.bitstring([
																																Type.bitstringSegment(
																																	Type.string(
																																		"mt-6 ",
																																	),
																																	{
																																		type: "binary",
																																	},
																																),
																																Type.bitstringSegment(
																																	Elixir_String_Chars[
																																		"to_string/1"
																																	](
																																		Elixir_LeaplyWeb_Hologram_Pages_Listings_DetailPage[
																																			"primary_action_class/1"
																																		](
																																			Type.atom(
																																				"false",
																																			),
																																		),
																																	),
																																	{
																																		type: "binary",
																																	},
																																),
																															]),
																														]),
																													]),
																												]),
																											]),
																											Type.tuple([
																												Type.bitstring(
																													"aria-disabled",
																												),
																												Type.list([
																													Type.tuple([
																														Type.atom("text"),
																														Type.bitstring(
																															"true",
																														),
																													]),
																												]),
																											]),
																										]),
																										Type.list([
																											Type.tuple([
																												Type.atom("expression"),
																												Type.tuple([
																													Interpreter.dotOperator(
																														Interpreter.dotOperator(
																															context.vars
																																.vars_0,
																															Type.atom(
																																"action",
																															),
																														),
																														Type.atom("label"),
																													),
																												]),
																											]),
																										]),
																									]),
																									Type.tuple([
																										Type.atom("text"),
																										Type.bitstring(
																											"\n          ",
																										),
																									]),
																								]);
																							},
																						},
																						{
																							match: Type.matchPlaceholder(),
																							guards: [],
																							body: (context) => {
																								return Type.list([
																									Type.tuple([
																										Type.atom("text"),
																										Type.bitstring(
																											"\n            ",
																										),
																									]),
																									Type.tuple([
																										Type.atom("element"),
																										Type.bitstring("a"),
																										Type.list([
																											Type.tuple([
																												Type.bitstring("href"),
																												Type.list([
																													Type.tuple([
																														Type.atom(
																															"expression",
																														),
																														Type.tuple([
																															Interpreter.dotOperator(
																																Interpreter.dotOperator(
																																	context.vars
																																		.vars_0,
																																	Type.atom(
																																		"action",
																																	),
																																),
																																Type.atom(
																																	"href",
																																),
																															),
																														]),
																													]),
																												]),
																											]),
																											Type.tuple([
																												Type.bitstring("class"),
																												Type.list([
																													Type.tuple([
																														Type.atom(
																															"expression",
																														),
																														Type.tuple([
																															Type.bitstring([
																																Type.bitstringSegment(
																																	Type.string(
																																		"mt-6 ",
																																	),
																																	{
																																		type: "binary",
																																	},
																																),
																																Type.bitstringSegment(
																																	Elixir_String_Chars[
																																		"to_string/1"
																																	](
																																		Elixir_LeaplyWeb_Hologram_Pages_Listings_DetailPage[
																																			"primary_action_class/1"
																																		](
																																			Type.atom(
																																				"true",
																																			),
																																		),
																																	),
																																	{
																																		type: "binary",
																																	},
																																),
																															]),
																														]),
																													]),
																												]),
																											]),
																										]),
																										Type.list([
																											Type.tuple([
																												Type.atom("expression"),
																												Type.tuple([
																													Interpreter.dotOperator(
																														Interpreter.dotOperator(
																															context.vars
																																.vars_0,
																															Type.atom(
																																"action",
																															),
																														),
																														Type.atom("label"),
																													),
																												]),
																											]),
																										]),
																									]),
																									Type.tuple([
																										Type.atom("text"),
																										Type.bitstring(
																											"\n          ",
																										),
																									]),
																								]);
																							},
																						},
																					],
																					context,
																				),
																				Type.tuple([
																					Type.atom("text"),
																					Type.bitstring("\n          "),
																				]),
																				Type.tuple([
																					Type.atom("element"),
																					Type.bitstring("p"),
																					Type.list([
																						Type.tuple([
																							Type.bitstring("class"),
																							Type.list([
																								Type.tuple([
																									Type.atom("text"),
																									Type.bitstring(
																										"mt-5 text-center text-xs leading-5 text-app-muted",
																									),
																								]),
																							]),
																						]),
																					]),
																					Type.list([
																						Type.tuple([
																							Type.atom("text"),
																							Type.bitstring(
																								"Review the sharing details before you submit. You can leave and return while applying.",
																							),
																						]),
																					]),
																				]),
																				Type.tuple([
																					Type.atom("text"),
																					Type.bitstring("\n        "),
																				]),
																			]),
																		]),
																		Type.tuple([
																			Type.atom("text"),
																			Type.bitstring("\n      "),
																		]),
																	]),
																]),
																Type.tuple([
																	Type.atom("text"),
																	Type.bitstring("\n    "),
																]),
															]),
														]),
														Type.tuple([
															Type.atom("text"),
															Type.bitstring("\n  "),
														]),
													]),
												]),
												Type.tuple([
													Type.atom("text"),
													Type.bitstring("\n\n  "),
												]),
												Type.tuple([
													Type.atom("element"),
													Type.bitstring("div"),
													Type.list([
														Type.tuple([
															Type.bitstring("class"),
															Type.list([
																Type.tuple([
																	Type.atom("text"),
																	Type.bitstring(
																		"fixed inset-x-0 bottom-0 z-40 border-t border-app-border bg-app-surface/95 px-4 pb-[calc(1rem+env(safe-area-inset-bottom))] pt-4 backdrop-blur lg:hidden",
																	),
																]),
															]),
														]),
													]),
													Type.list([
														Type.tuple([
															Type.atom("text"),
															Type.bitstring("\n    "),
														]),
														Type.tuple([
															Type.atom("element"),
															Type.bitstring("div"),
															Type.list([
																Type.tuple([
																	Type.bitstring("class"),
																	Type.list([
																		Type.tuple([
																			Type.atom("text"),
																			Type.bitstring("mx-auto max-w-xl"),
																		]),
																	]),
																]),
															]),
															Type.list([
																Type.tuple([
																	Type.atom("text"),
																	Type.bitstring("\n      "),
																]),
																Interpreter.case(
																	Interpreter.dotOperator(
																		Interpreter.dotOperator(
																			context.vars.vars_0,
																			Type.atom("action"),
																		),
																		Type.atom("available?"),
																	),
																	[
																		{
																			match: Type.variablePattern("x_8"),
																			guards: [
																				(context) =>
																					Erlang["orelse/2"](
																						(context) =>
																							Erlang["=:=/2"](
																								context.vars.x_8,
																								Type.atom("false"),
																							),
																						(context) =>
																							Erlang["=:=/2"](
																								context.vars.x_8,
																								Type.atom("nil"),
																							),
																						context,
																					),
																			],
																			body: (context) => {
																				return Type.list([
																					Type.tuple([
																						Type.atom("text"),
																						Type.bitstring("\n        "),
																					]),
																					Type.tuple([
																						Type.atom("element"),
																						Type.bitstring("span"),
																						Type.list([
																							Type.tuple([
																								Type.bitstring("class"),
																								Type.list([
																									Type.tuple([
																										Type.atom("expression"),
																										Type.tuple([
																											Elixir_LeaplyWeb_Hologram_Pages_Listings_DetailPage[
																												"primary_action_class/1"
																											](Type.atom("false")),
																										]),
																									]),
																								]),
																							]),
																							Type.tuple([
																								Type.bitstring("aria-disabled"),
																								Type.list([
																									Type.tuple([
																										Type.atom("text"),
																										Type.bitstring("true"),
																									]),
																								]),
																							]),
																						]),
																						Type.list([
																							Type.tuple([
																								Type.atom("expression"),
																								Type.tuple([
																									Interpreter.dotOperator(
																										Interpreter.dotOperator(
																											context.vars.vars_0,
																											Type.atom("action"),
																										),
																										Type.atom("label"),
																									),
																								]),
																							]),
																						]),
																					]),
																					Type.tuple([
																						Type.atom("text"),
																						Type.bitstring("\n      "),
																					]),
																				]);
																			},
																		},
																		{
																			match: Type.matchPlaceholder(),
																			guards: [],
																			body: (context) => {
																				return Type.list([
																					Type.tuple([
																						Type.atom("text"),
																						Type.bitstring("\n        "),
																					]),
																					Type.tuple([
																						Type.atom("element"),
																						Type.bitstring("a"),
																						Type.list([
																							Type.tuple([
																								Type.bitstring("href"),
																								Type.list([
																									Type.tuple([
																										Type.atom("expression"),
																										Type.tuple([
																											Interpreter.dotOperator(
																												Interpreter.dotOperator(
																													context.vars.vars_0,
																													Type.atom("action"),
																												),
																												Type.atom("href"),
																											),
																										]),
																									]),
																								]),
																							]),
																							Type.tuple([
																								Type.bitstring("class"),
																								Type.list([
																									Type.tuple([
																										Type.atom("expression"),
																										Type.tuple([
																											Elixir_LeaplyWeb_Hologram_Pages_Listings_DetailPage[
																												"primary_action_class/1"
																											](Type.atom("true")),
																										]),
																									]),
																								]),
																							]),
																						]),
																						Type.list([
																							Type.tuple([
																								Type.atom("expression"),
																								Type.tuple([
																									Interpreter.dotOperator(
																										Interpreter.dotOperator(
																											context.vars.vars_0,
																											Type.atom("action"),
																										),
																										Type.atom("label"),
																									),
																								]),
																							]),
																						]),
																					]),
																					Type.tuple([
																						Type.atom("text"),
																						Type.bitstring("\n      "),
																					]),
																				]);
																			},
																		},
																	],
																	context,
																),
																Type.tuple([
																	Type.atom("text"),
																	Type.bitstring("\n    "),
																]),
															]),
														]),
														Type.tuple([
															Type.atom("text"),
															Type.bitstring("\n  "),
														]),
													]),
												]),
												Type.tuple([Type.atom("text"), Type.bitstring("\n")]),
											]),
										]),
									]);
								},
							},
						],
						context,
					);
					Interpreter.updateVarsToMatchedValues(context);
					return globalThis.hologram.return;
				},
			},
		],
	);

	Interpreter.defineElixirFunction("String", "first", 1, "public", [
		{
			params: (context) => [Type.variablePattern("string_0")],
			guards: [(context) => Erlang["is_binary/1"](context.vars.string_0)],
			body: (context) => {
				return Interpreter.case(
					Erlang_Unicode_Util["gc/1"](context.vars.string_0),
					[
						{
							match: Type.consPattern(
								Type.variablePattern("gc_1"),
								Type.matchPlaceholder(),
							),
							guards: [],
							body: (context) => {
								return Elixir_String["grapheme_to_binary/1"](context.vars.gc_1);
							},
						},
						{
							match: Type.list([]),
							guards: [],
							body: (context) => {
								return Type.atom("nil");
							},
						},
						{
							match: Type.tuple([
								Type.atom("error"),
								Type.bitstringPattern([
									Type.bitstringSegment(Type.variablePattern("byte_2"), {
										type: "integer",
									}),
									Type.bitstringSegment(Type.matchPlaceholder(), {
										type: "bitstring",
									}),
								]),
							]),
							guards: [],
							body: (context) => {
								return Type.bitstring([
									Type.bitstringSegment(context.vars.byte_2, {
										type: "integer",
									}),
								]);
							},
						},
					],
					context,
				);
			},
		},
	]);

	Interpreter.defineElixirFunction("String", "starts_with?", 2, "public", [
		{
			params: (context) => [
				Type.variablePattern("string_0"),
				Type.variablePattern("prefix_1"),
			],
			guards: [
				(context) =>
					Erlang["andalso/2"](
						(context) => Erlang["is_binary/1"](context.vars.string_0),
						(context) => Erlang["is_binary/1"](context.vars.prefix_1),
						context,
					),
			],
			body: (context) => {
				return Elixir_String["starts_with_string?/3"](
					context.vars.string_0,
					Erlang["byte_size/1"](context.vars.string_0),
					context.vars.prefix_1,
				);
			},
		},
		{
			params: (context) => [
				Type.variablePattern("string_0"),
				Type.variablePattern("prefix_1"),
			],
			guards: [
				(context) =>
					Erlang["andalso/2"](
						(context) => Erlang["is_binary/1"](context.vars.string_0),
						(context) => Erlang["is_list/1"](context.vars.prefix_1),
						context,
					),
			],
			body: (context) => {
				Interpreter.matchOperator(
					Erlang["byte_size/1"](context.vars.string_0),
					Type.variablePattern("string_size_2"),
					context,
				);
				Interpreter.updateVarsToMatchedValues(context);
				return Elixir_Enum["any?/2"](
					context.vars.prefix_1,
					Type.anonymousFunction(
						1,
						[
							{
								params: (context) => [Type.variablePattern("$679")],
								guards: [],
								body: (context) => {
									return Elixir_String["starts_with_string?/3"](
										context.vars.string_0,
										context.vars.string_size_2,
										context.vars["$679"],
									);
								},
							},
						],
						context,
					),
				);
			},
		},
		{
			params: (context) => [
				Type.variablePattern("string_0"),
				Type.variablePattern("prefix_1"),
			],
			guards: [(context) => Erlang["is_binary/1"](context.vars.string_0)],
			body: (context) => {
				Elixir_IO["warn/1"](
					Type.bitstring("compiled patterns are deprecated in starts_with?"),
				);
				return Interpreter.case(
					Erlang_Binary["match/2"](
						context.vars.string_0,
						context.vars.prefix_1,
					),
					[
						{
							match: Type.tuple([Type.integer(0n), Type.matchPlaceholder()]),
							guards: [],
							body: (context) => {
								return Type.atom("true");
							},
						},
						{
							match: Type.matchPlaceholder(),
							guards: [],
							body: (context) => {
								return Type.atom("false");
							},
						},
					],
					context,
				);
			},
		},
	]);

	Interpreter.defineElixirFunction(
		"String",
		"starts_with_string?",
		3,
		"private",
		[
			{
				params: (context) => [
					Type.variablePattern("string_0"),
					Type.variablePattern("string_size_1"),
					Type.variablePattern("prefix_2"),
				],
				guards: [(context) => Erlang["is_binary/1"](context.vars.prefix_2)],
				body: (context) => {
					Interpreter.matchOperator(
						Erlang["byte_size/1"](context.vars.prefix_2),
						Type.variablePattern("prefix_size_3"),
						context,
					);
					Interpreter.updateVarsToMatchedValues(context);
					return Interpreter.case(
						Erlang["=</2"](
							context.vars.prefix_size_3,
							context.vars.string_size_1,
						),
						[
							{
								match: Type.atom("false"),
								guards: [],
								body: (context) => {
									return Type.atom("false");
								},
							},
							{
								match: Type.atom("true"),
								guards: [],
								body: (context) => {
									return Erlang["==/2"](
										context.vars.prefix_2,
										Erlang["binary_part/3"](
											context.vars.string_0,
											Type.integer(0n),
											context.vars.prefix_size_3,
										),
									);
								},
							},
						],
						context,
					);
				},
			},
		],
	);
};

globalThis.hologram.pageScriptLoaded = true;
document.dispatchEvent(new CustomEvent("hologram:pageScriptLoaded"));

console.debug(
	"Hologram: page script executed in",
	PerformanceTimer.diff(startTime),
);
